/* tslint:disable */
/* eslint-disable */
/**
 * Api docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AcceptLinkedUserInvitationErrors
 */
export interface AcceptLinkedUserInvitationErrors {
    /**
     * Error message detailing what is wrong
     * @type {string}
     * @memberof AcceptLinkedUserInvitationErrors
     */
    'message'?: string;
    /**
     * 
     * @type {AcceptLinkedUserInvitationErrorsErrors}
     * @memberof AcceptLinkedUserInvitationErrors
     */
    'errors'?: AcceptLinkedUserInvitationErrorsErrors;
}
/**
 * Object containing detailed error messages indexed by field name
 * @export
 * @interface AcceptLinkedUserInvitationErrorsErrors
 */
export interface AcceptLinkedUserInvitationErrorsErrors {
    /**
     * 
     * @type {Array<string>}
     * @memberof AcceptLinkedUserInvitationErrorsErrors
     */
    'email'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AcceptLinkedUserInvitationErrorsErrors
     */
    'token'?: Array<string>;
}
/**
 * 
 * @export
 * @interface AcceptLinkedUserInvitationRequest
 */
export interface AcceptLinkedUserInvitationRequest {
    /**
     * 
     * @type {string}
     * @memberof AcceptLinkedUserInvitationRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AcceptLinkedUserInvitationRequest
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface AddReportEmailRequest
 */
export interface AddReportEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof AddReportEmailRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AddReportEmailRequest
     */
    'email': string;
}
/**
 * Admin Event Report
 * @export
 * @interface AdminEventReport
 */
export interface AdminEventReport {
    /**
     * 
     * @type {string}
     * @memberof AdminEventReport
     */
    'lastSold'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminEventReport
     */
    'totalCapacity': number;
    /**
     * 
     * @type {number}
     * @memberof AdminEventReport
     */
    'totalSold': number;
    /**
     * 
     * @type {number}
     * @memberof AdminEventReport
     */
    'totalUsed': number;
    /**
     * 
     * @type {number}
     * @memberof AdminEventReport
     */
    'totalRefunded': number;
    /**
     * 
     * @type {number}
     * @memberof AdminEventReport
     */
    'totalRevenue': number;
    /**
     * 
     * @type {Array<AdminEventReportAllOfTicketTypesInner>}
     * @memberof AdminEventReport
     */
    'ticketTypes': Array<AdminEventReportAllOfTicketTypesInner>;
    /**
     * 
     * @type {number}
     * @memberof AdminEventReport
     */
    'totalPlatformFee': number;
}
/**
 * 
 * @export
 * @interface AdminEventReportAllOfTicketTypesInner
 */
export interface AdminEventReportAllOfTicketTypesInner {
    /**
     * 
     * @type {string}
     * @memberof AdminEventReportAllOfTicketTypesInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminEventReportAllOfTicketTypesInner
     */
    'color': string;
    /**
     * 
     * @type {number}
     * @memberof AdminEventReportAllOfTicketTypesInner
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof AdminEventReportAllOfTicketTypesInner
     */
    'capacity': number;
    /**
     * 
     * @type {number}
     * @memberof AdminEventReportAllOfTicketTypesInner
     */
    'sold': number;
    /**
     * 
     * @type {number}
     * @memberof AdminEventReportAllOfTicketTypesInner
     */
    'used': number;
    /**
     * 
     * @type {number}
     * @memberof AdminEventReportAllOfTicketTypesInner
     */
    'refunded': number;
    /**
     * 
     * @type {number}
     * @memberof AdminEventReportAllOfTicketTypesInner
     */
    'revenue': number;
    /**
     * 
     * @type {number}
     * @memberof AdminEventReportAllOfTicketTypesInner
     */
    'platformFee'?: number;
}
/**
 * 
 * @export
 * @interface ApiLoginRequest
 */
export interface ApiLoginRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiLoginRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ApiLoginRequest
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface ApiTokenLoginByOtpRequest
 */
export interface ApiTokenLoginByOtpRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiTokenLoginByOtpRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ApiTokenLoginByOtpRequest
     */
    'otp': string;
    /**
     * 
     * @type {string}
     * @memberof ApiTokenLoginByOtpRequest
     */
    'deviceName': string;
}
/**
 * 
 * @export
 * @interface ApiTokenLoginRequest
 */
export interface ApiTokenLoginRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiTokenLoginRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ApiTokenLoginRequest
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof ApiTokenLoginRequest
     */
    'deviceName': string;
}
/**
 * 
 * @export
 * @interface ApiTokenOutput
 */
export interface ApiTokenOutput {
    /**
     * 
     * @type {string}
     * @memberof ApiTokenOutput
     */
    'token'?: string;
}
/**
 * 
 * @export
 * @interface CheckCouponRequest
 */
export interface CheckCouponRequest {
    /**
     * 
     * @type {string}
     * @memberof CheckCouponRequest
     */
    'code'?: string;
    /**
     * 
     * @type {number}
     * @memberof CheckCouponRequest
     */
    'showId'?: number;
}
/**
 * 
 * @export
 * @interface ConsumeTicketOutput
 */
export interface ConsumeTicketOutput {
    /**
     * 
     * @type {UserPriceResource}
     * @memberof ConsumeTicketOutput
     */
    'price': UserPriceResource;
    /**
     * 
     * @type {boolean}
     * @memberof ConsumeTicketOutput
     */
    'isValid': boolean;
    /**
     * 
     * @type {string}
     * @memberof ConsumeTicketOutput
     */
    'reason': string;
    /**
     * 
     * @type {boolean}
     * @memberof ConsumeTicketOutput
     */
    'alreadyUsed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ConsumeTicketOutput
     */
    'showName': string;
    /**
     * 
     * @type {string}
     * @memberof ConsumeTicketOutput
     */
    'priceName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConsumeTicketOutput
     */
    'validUntil'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConsumeTicketOutput
     */
    'eventStartsAt'?: string;
}
/**
 * 
 * @export
 * @interface ConsumeTicketRequest
 */
export interface ConsumeTicketRequest {
    /**
     * 
     * @type {string}
     * @memberof ConsumeTicketRequest
     */
    'uuid': string;
    /**
     * 
     * @type {number}
     * @memberof ConsumeTicketRequest
     */
    'showEventId': number;
    /**
     * 
     * @type {number}
     * @memberof ConsumeTicketRequest
     */
    'showId': number;
    /**
     * 
     * @type {number}
     * @memberof ConsumeTicketRequest
     */
    'showPriceId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ConsumeTicketRequest
     */
    'controlCode'?: string;
}
/**
 * 
 * @export
 * @interface ControlCodeAuthRequest
 */
export interface ControlCodeAuthRequest {
    /**
     * 
     * @type {string}
     * @memberof ControlCodeAuthRequest
     */
    'controlCode'?: string;
}
/**
 * 
 * @export
 * @interface CouponResource
 */
export interface CouponResource {
    /**
     * 
     * @type {number}
     * @memberof CouponResource
     */
    'discount': number;
}
/**
 * 
 * @export
 * @interface CreateCbteCtaVtaRequest
 */
export interface CreateCbteCtaVtaRequest {
    /**
     * 
     * @type {number}
     * @memberof CreateCbteCtaVtaRequest
     */
    'cbteTipo': number;
    /**
     * 
     * @type {number}
     * @memberof CreateCbteCtaVtaRequest
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof CreateCbteCtaVtaRequest
     */
    'docTipo'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateCbteCtaVtaRequest
     */
    'docNro'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateCbteCtaVtaRequest
     */
    'condIva'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateCbteCtaVtaRequest
     */
    'recipientName': string;
    /**
     * 
     * @type {number}
     * @memberof CreateCbteCtaVtaRequest
     */
    'showEventId': number;
}
/**
 * 
 * @export
 * @interface CreateCbteCtaVtaRequestErrors
 */
export interface CreateCbteCtaVtaRequestErrors {
    /**
     * Error message detailing what is wrong
     * @type {string}
     * @memberof CreateCbteCtaVtaRequestErrors
     */
    'message'?: string;
    /**
     * 
     * @type {CreateCbteCtaVtaRequestErrorsErrors}
     * @memberof CreateCbteCtaVtaRequestErrors
     */
    'errors'?: CreateCbteCtaVtaRequestErrorsErrors;
}
/**
 * Object containing detailed error messages indexed by field name
 * @export
 * @interface CreateCbteCtaVtaRequestErrorsErrors
 */
export interface CreateCbteCtaVtaRequestErrorsErrors {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCbteCtaVtaRequestErrorsErrors
     */
    'cbteTipo'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCbteCtaVtaRequestErrorsErrors
     */
    'amount'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCbteCtaVtaRequestErrorsErrors
     */
    'docTipo'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCbteCtaVtaRequestErrorsErrors
     */
    'docNro'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCbteCtaVtaRequestErrorsErrors
     */
    'condIva'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCbteCtaVtaRequestErrorsErrors
     */
    'recipientName'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCbteCtaVtaRequestErrorsErrors
     */
    'showEventId'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CreateCouponRequest
 */
export interface CreateCouponRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCouponRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCouponRequest
     */
    'code'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateCouponRequest
     */
    'discount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCouponRequest
     */
    'active'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateCouponRequestErrors
 */
export interface CreateCouponRequestErrors {
    /**
     * Error message detailing what is wrong
     * @type {string}
     * @memberof CreateCouponRequestErrors
     */
    'message'?: string;
    /**
     * 
     * @type {CreateCouponRequestErrorsErrors}
     * @memberof CreateCouponRequestErrors
     */
    'errors'?: CreateCouponRequestErrorsErrors;
}
/**
 * Object containing detailed error messages indexed by field name
 * @export
 * @interface CreateCouponRequestErrorsErrors
 */
export interface CreateCouponRequestErrorsErrors {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCouponRequestErrorsErrors
     */
    'name'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCouponRequestErrorsErrors
     */
    'code'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCouponRequestErrorsErrors
     */
    'discount'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCouponRequestErrorsErrors
     */
    'active'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CreateDonationProviderRequest
 */
export interface CreateDonationProviderRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateDonationProviderRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDonationProviderRequest
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDonationProviderRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDonationProviderRequest
     */
    'website': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDonationProviderRequest
     */
    'logo_url': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDonationProviderRequest
     */
    'phone_number': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDonationProviderRequest
     */
    'bank_information': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDonationProviderRequest
     */
    'contact_name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDonationProviderRequest
     */
    'taxes_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDonationProviderRequest
     */
    'active': boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateDonationProviderRequest
     */
    'fee'?: number;
}
/**
 * 
 * @export
 * @interface CreateDraftShowRequest
 */
export interface CreateDraftShowRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateDraftShowRequest
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDraftShowRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDraftShowRequest
     */
    'description': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDraftShowRequest
     */
    'ageRestricted': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDraftShowRequest
     */
    'isPrivate'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateDraftShowRequest
     */
    'genreId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateDraftShowRequest
     */
    'acceptedTermsId': number;
    /**
     * 
     * @type {string}
     * @memberof CreateDraftShowRequest
     */
    'externalUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDraftShowRequest
     */
    'billingPreference'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateDraftShowRequest
     */
    'donateProviderId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDraftShowRequest
     */
    'pixelId'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateDraftShowRequestErrors
 */
export interface CreateDraftShowRequestErrors {
    /**
     * Error message detailing what is wrong
     * @type {string}
     * @memberof CreateDraftShowRequestErrors
     */
    'message'?: string;
    /**
     * 
     * @type {CreateDraftShowRequestErrorsErrors}
     * @memberof CreateDraftShowRequestErrors
     */
    'errors'?: CreateDraftShowRequestErrorsErrors;
}
/**
 * Object containing detailed error messages indexed by field name
 * @export
 * @interface CreateDraftShowRequestErrorsErrors
 */
export interface CreateDraftShowRequestErrorsErrors {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateDraftShowRequestErrorsErrors
     */
    'type'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateDraftShowRequestErrorsErrors
     */
    'name'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateDraftShowRequestErrorsErrors
     */
    'description'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateDraftShowRequestErrorsErrors
     */
    'ageRestricted'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateDraftShowRequestErrorsErrors
     */
    'isPrivate'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateDraftShowRequestErrorsErrors
     */
    'genreId'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateDraftShowRequestErrorsErrors
     */
    'acceptedTermsId'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateDraftShowRequestErrorsErrors
     */
    'externalUrl'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateDraftShowRequestErrorsErrors
     */
    'billingPreference'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateDraftShowRequestErrorsErrors
     */
    'donateProviderId'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateDraftShowRequestErrorsErrors
     */
    'pixelId'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CreateFlyerRequest
 */
export interface CreateFlyerRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateFlyerRequest
     */
    'role'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateFlyerRequest
     */
    'active'?: boolean;
    /**
     * 
     * @type {File}
     * @memberof CreateFlyerRequest
     */
    'image'?: File;
}
/**
 * 
 * @export
 * @interface CreateFlyerRequestErrors
 */
export interface CreateFlyerRequestErrors {
    /**
     * Error message detailing what is wrong
     * @type {string}
     * @memberof CreateFlyerRequestErrors
     */
    'message'?: string;
    /**
     * 
     * @type {CreateFlyerRequestErrorsErrors}
     * @memberof CreateFlyerRequestErrors
     */
    'errors'?: CreateFlyerRequestErrorsErrors;
}
/**
 * Object containing detailed error messages indexed by field name
 * @export
 * @interface CreateFlyerRequestErrorsErrors
 */
export interface CreateFlyerRequestErrorsErrors {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateFlyerRequestErrorsErrors
     */
    'role'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateFlyerRequestErrorsErrors
     */
    'active'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateFlyerRequestErrorsErrors
     */
    'image'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CreateHomeFlyerRequest
 */
export interface CreateHomeFlyerRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateHomeFlyerRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateHomeFlyerRequest
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof CreateHomeFlyerRequest
     */
    'href'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateHomeFlyerRequest
     */
    'active': boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateHomeFlyerRequest
     */
    'path': string;
}
/**
 * 
 * @export
 * @interface CreateLocationRequest
 */
export interface CreateLocationRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    'locality'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    'country'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateLocationRequest
     */
    'lat'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLocationRequest
     */
    'lng'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    'placeId'?: string;
}
/**
 * 
 * @export
 * @interface CreateLocationRequestErrors
 */
export interface CreateLocationRequestErrors {
    /**
     * Error message detailing what is wrong
     * @type {string}
     * @memberof CreateLocationRequestErrors
     */
    'message'?: string;
    /**
     * 
     * @type {CreateLocationRequestErrorsErrors}
     * @memberof CreateLocationRequestErrors
     */
    'errors'?: CreateLocationRequestErrorsErrors;
}
/**
 * Object containing detailed error messages indexed by field name
 * @export
 * @interface CreateLocationRequestErrorsErrors
 */
export interface CreateLocationRequestErrorsErrors {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateLocationRequestErrorsErrors
     */
    'name'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateLocationRequestErrorsErrors
     */
    'address'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateLocationRequestErrorsErrors
     */
    'locality'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateLocationRequestErrorsErrors
     */
    'city'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateLocationRequestErrorsErrors
     */
    'country'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateLocationRequestErrorsErrors
     */
    'lat'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateLocationRequestErrorsErrors
     */
    'lng'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateLocationRequestErrorsErrors
     */
    'placeId'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CreateReservation422Response
 */
export interface CreateReservation422Response {
    /**
     * 
     * @type {string}
     * @memberof CreateReservation422Response
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface CreateReservationRequest
 */
export interface CreateReservationRequest {
    /**
     * 
     * @type {number}
     * @memberof CreateReservationRequest
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof CreateReservationRequest
     */
    'showEventId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateReservationRequest
     */
    'showId': number;
    /**
     * 
     * @type {number}
     * @memberof CreateReservationRequest
     */
    'showPriceId': number;
    /**
     * 
     * @type {string}
     * @memberof CreateReservationRequest
     */
    'couponCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateReservationRequest
     */
    'contributionAmount'?: number;
}
/**
 * 
 * @export
 * @interface CreateShowPriceRequest
 */
export interface CreateShowPriceRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateShowPriceRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateShowPriceRequest
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateShowPriceRequest
     */
    'price': number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateShowPriceRequest
     */
    'priceIncludesPlatformFee'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateShowPriceRequest
     */
    'color'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateShowPriceRequest
     */
    'availableTickets': number;
    /**
     * 
     * @type {number}
     * @memberof CreateShowPriceRequest
     */
    'maxTicketsPerReservation'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateShowPriceRequest
     */
    'reservableUntil'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateShowPriceRequest
     */
    'validUntil'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateShowPriceRequest
     */
    'listed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateShowPriceRequest
     */
    'allowContribution'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateShowPriceRequest
     */
    'permalink'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateShowPriceRequestErrors
 */
export interface CreateShowPriceRequestErrors {
    /**
     * Error message detailing what is wrong
     * @type {string}
     * @memberof CreateShowPriceRequestErrors
     */
    'message'?: string;
    /**
     * 
     * @type {CreateShowPriceRequestErrorsErrors}
     * @memberof CreateShowPriceRequestErrors
     */
    'errors'?: CreateShowPriceRequestErrorsErrors;
}
/**
 * Object containing detailed error messages indexed by field name
 * @export
 * @interface CreateShowPriceRequestErrorsErrors
 */
export interface CreateShowPriceRequestErrorsErrors {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowPriceRequestErrorsErrors
     */
    'name'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowPriceRequestErrorsErrors
     */
    'description'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowPriceRequestErrorsErrors
     */
    'price'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowPriceRequestErrorsErrors
     */
    'priceIncludesPlatformFee'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowPriceRequestErrorsErrors
     */
    'availableTickets'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowPriceRequestErrorsErrors
     */
    'maxTicketsPerReservation'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowPriceRequestErrorsErrors
     */
    'color'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowPriceRequestErrorsErrors
     */
    'reservableUntil'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowPriceRequestErrorsErrors
     */
    'validUntil'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowPriceRequestErrorsErrors
     */
    'listed'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowPriceRequestErrorsErrors
     */
    'allowContribution'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowPriceRequestErrorsErrors
     */
    'permalink'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CreateShowRequest
 */
export interface CreateShowRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateShowRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateShowRequest
     */
    'description': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateShowRequest
     */
    'ageRestriction': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateShowRequest
     */
    'isPrivate': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateShowRequest
     */
    'isOnline'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateShowRequest
     */
    'showCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateShowRequest
     */
    'externalUrl'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateShowRequest
     */
    'genreId': number;
    /**
     * 
     * @type {Array<ShowEventInput>}
     * @memberof CreateShowRequest
     */
    'showEvents'?: Array<ShowEventInput>;
    /**
     * 
     * @type {string}
     * @memberof CreateShowRequest
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof CreateShowRequest
     */
    'acceptedTermsId'?: number;
    /**
     * 
     * @type {LocationInput}
     * @memberof CreateShowRequest
     */
    'location'?: LocationInput;
    /**
     * 
     * @type {Array<ShowPriceInput>}
     * @memberof CreateShowRequest
     */
    'showPrices'?: Array<ShowPriceInput>;
    /**
     * 
     * @type {string}
     * @memberof CreateShowRequest
     */
    'flyer': string;
    /**
     * 
     * @type {Array<ShowFlyerInput>}
     * @memberof CreateShowRequest
     */
    'showFlyers'?: Array<ShowFlyerInput>;
    /**
     * 
     * @type {number}
     * @memberof CreateShowRequest
     */
    'donateProviderId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateShowRequest
     */
    'billingPreference'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateShowRequest
     */
    'onlineInformation'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateShowRequestErrors
 */
export interface CreateShowRequestErrors {
    /**
     * Error message detailing what is wrong
     * @type {string}
     * @memberof CreateShowRequestErrors
     */
    'message'?: string;
    /**
     * 
     * @type {CreateShowRequestErrorsErrors}
     * @memberof CreateShowRequestErrors
     */
    'errors'?: CreateShowRequestErrorsErrors;
}
/**
 * Object containing detailed error messages indexed by field name
 * @export
 * @interface CreateShowRequestErrorsErrors
 */
export interface CreateShowRequestErrorsErrors {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowRequestErrorsErrors
     */
    'name'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowRequestErrorsErrors
     */
    'description'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowRequestErrorsErrors
     */
    'ageRestriction'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowRequestErrorsErrors
     */
    'isPrivate'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowRequestErrorsErrors
     */
    'genreId'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowRequestErrorsErrors
     */
    'isOnline'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowRequestErrorsErrors
     */
    'type'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowRequestErrorsErrors
     */
    'externalUrl'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowRequestErrorsErrors
     */
    'flyer'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowRequestErrorsErrors
     */
    'donateProviderId'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowRequestErrorsErrors
     */
    'billingPreference'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowRequestErrorsErrors
     */
    'onlineInformation'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowRequestErrorsErrors
     */
    'acceptedTermsId'?: Array<string>;
    /**
     * 
     * @type {Array<Datetime>}
     * @memberof CreateShowRequestErrorsErrors
     */
    'showEvents.index.startsAt'?: Array<Datetime>;
    /**
     * 
     * @type {Array<Datetime>}
     * @memberof CreateShowRequestErrorsErrors
     */
    'showEvents.index.endsAt'?: Array<Datetime>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowRequestErrorsErrors
     */
    'showPrices.index.showPriceName'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowRequestErrorsErrors
     */
    'showPrices.index.showPriceValue'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowRequestErrorsErrors
     */
    'showPrices.index.showPriceAvailableTickets'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowRequestErrorsErrors
     */
    'showFlyers.index.filename'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowRequestErrorsErrors
     */
    'location.locationAddress'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowRequestErrorsErrors
     */
    'location.locationCity'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowRequestErrorsErrors
     */
    'location.locationCountry'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowRequestErrorsErrors
     */
    'location.locationLat'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowRequestErrorsErrors
     */
    'location.locationLng'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowRequestErrorsErrors
     */
    'location.locationLocality'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateShowRequestErrorsErrors
     */
    'location.locationName'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CreateTermAndConditionRequest
 */
export interface CreateTermAndConditionRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateTermAndConditionRequest
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTermAndConditionRequest
     */
    'language': string;
}
/**
 * 
 * @export
 * @interface CustomerPaymentRequest
 */
export interface CustomerPaymentRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomerPaymentRequest
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof CustomerPaymentRequest
     */
    'show_event_id': number;
    /**
     * 
     * @type {number}
     * @memberof CustomerPaymentRequest
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof CustomerPaymentRequest
     */
    'status': CustomerPaymentRequestStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof CustomerPaymentRequest
     */
    'user_id': number;
    /**
     * 
     * @type {string}
     * @memberof CustomerPaymentRequest
     */
    'filename': string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerPaymentRequest
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPaymentRequest
     */
    'updted_at'?: string;
}

export const CustomerPaymentRequestStatusEnum = {
    Requested: 'requested',
    Paid: 'paid'
} as const;

export type CustomerPaymentRequestStatusEnum = typeof CustomerPaymentRequestStatusEnum[keyof typeof CustomerPaymentRequestStatusEnum];

/**
 * 
 * @export
 * @interface CustomerPaymentRequestOutput
 */
export interface CustomerPaymentRequestOutput {
    /**
     * 
     * @type {string}
     * @memberof CustomerPaymentRequestOutput
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof CustomerPaymentRequestOutput
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof CustomerPaymentRequestOutput
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPaymentRequestOutput
     */
    'filename'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerPaymentRequestOutput
     */
    'filenameRealPath'?: string | null;
    /**
     * 
     * @type {UserDataOutput}
     * @memberof CustomerPaymentRequestOutput
     */
    'user': UserDataOutput;
    /**
     * 
     * @type {ShowEvent}
     * @memberof CustomerPaymentRequestOutput
     */
    'showEvent': ShowEvent;
    /**
     * 
     * @type {string}
     * @memberof CustomerPaymentRequestOutput
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPaymentRequestOutput
     */
    'updatedAt'?: string;
}
/**
 * 
 * @export
 * @interface DeleteMyAccount422Response
 */
export interface DeleteMyAccount422Response {
    /**
     * Error message detailing what is wrong
     * @type {string}
     * @memberof DeleteMyAccount422Response
     */
    'message'?: string;
    /**
     * 
     * @type {DeleteMyAccount422ResponseErrors}
     * @memberof DeleteMyAccount422Response
     */
    'errors'?: DeleteMyAccount422ResponseErrors;
}
/**
 * Object containing detailed error messages indexed by field name
 * @export
 * @interface DeleteMyAccount422ResponseErrors
 */
export interface DeleteMyAccount422ResponseErrors {
    /**
     * 
     * @type {Array<string>}
     * @memberof DeleteMyAccount422ResponseErrors
     */
    'reason'?: Array<string>;
}
/**
 * 
 * @export
 * @interface DeleteMyAccountRequest
 */
export interface DeleteMyAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof DeleteMyAccountRequest
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface DonateProviderAdminOutput
 */
export interface DonateProviderAdminOutput {
    /**
     * 
     * @type {number}
     * @memberof DonateProviderAdminOutput
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DonateProviderAdminOutput
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof DonateProviderAdminOutput
     */
    'website'?: string;
    /**
     * 
     * @type {string}
     * @memberof DonateProviderAdminOutput
     */
    'logo_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof DonateProviderAdminOutput
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof DonateProviderAdminOutput
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof DonateProviderAdminOutput
     */
    'phone_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof DonateProviderAdminOutput
     */
    'bank_information'?: string;
    /**
     * 
     * @type {string}
     * @memberof DonateProviderAdminOutput
     */
    'contact_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof DonateProviderAdminOutput
     */
    'taxes_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DonateProviderAdminOutput
     */
    'active'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DonateProviderAdminOutput
     */
    'fee'?: number | null;
}
/**
 * 
 * @export
 * @interface DonateProviderPublicOutput
 */
export interface DonateProviderPublicOutput {
    /**
     * 
     * @type {number}
     * @memberof DonateProviderPublicOutput
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DonateProviderPublicOutput
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof DonateProviderPublicOutput
     */
    'website'?: string;
    /**
     * 
     * @type {string}
     * @memberof DonateProviderPublicOutput
     */
    'logo_url'?: string;
}
/**
 * 
 * @export
 * @interface EditUserShowStatus422Response
 */
export interface EditUserShowStatus422Response {
    /**
     * Error message detailing what is wrong
     * @type {string}
     * @memberof EditUserShowStatus422Response
     */
    'message'?: string;
    /**
     * 
     * @type {EditUserShowStatus422ResponseErrors}
     * @memberof EditUserShowStatus422Response
     */
    'errors'?: EditUserShowStatus422ResponseErrors;
}
/**
 * Object containing detailed error messages indexed by field name
 * @export
 * @interface EditUserShowStatus422ResponseErrors
 */
export interface EditUserShowStatus422ResponseErrors {
    /**
     * 
     * @type {Array<string>}
     * @memberof EditUserShowStatus422ResponseErrors
     */
    'status'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditUserShowStatus422ResponseErrors
     */
    'show_events'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditUserShowStatus422ResponseErrors
     */
    'show_prices'?: Array<string>;
}
/**
 * 
 * @export
 * @interface FlyerResource
 */
export interface FlyerResource {
    /**
     * 
     * @type {number}
     * @memberof FlyerResource
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof FlyerResource
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof FlyerResource
     */
    'role': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FlyerResource
     */
    'active': boolean;
    /**
     * 
     * @type {string}
     * @memberof FlyerResource
     * @deprecated
     */
    'filename'?: string;
}
/**
 * 
 * @export
 * @interface Genre
 */
export interface Genre {
    /**
     * 
     * @type {number}
     * @memberof Genre
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Genre
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Genre
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface GenreResource
 */
export interface GenreResource {
    /**
     * 
     * @type {number}
     * @memberof GenreResource
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GenreResource
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GenreResource
     */
    'description': string;
}
/**
 * 
 * @export
 * @interface HomeFlyer
 */
export interface HomeFlyer {
    /**
     * 
     * @type {string}
     * @memberof HomeFlyer
     */
    'realPath'?: string;
    /**
     * 
     * @type {string}
     * @memberof HomeFlyer
     */
    'id'?: HomeFlyerIdEnum;
    /**
     * 
     * @type {string}
     * @memberof HomeFlyer
     */
    'name'?: HomeFlyerNameEnum;
    /**
     * 
     * @type {string}
     * @memberof HomeFlyer
     */
    'description'?: HomeFlyerDescriptionEnum;
    /**
     * 
     * @type {string}
     * @memberof HomeFlyer
     */
    'href'?: HomeFlyerHrefEnum;
    /**
     * 
     * @type {string}
     * @memberof HomeFlyer
     */
    'path'?: HomeFlyerPathEnum;
    /**
     * 
     * @type {boolean}
     * @memberof HomeFlyer
     */
    'active'?: boolean;
}

export const HomeFlyerIdEnum = {
    Id: 'id'
} as const;

export type HomeFlyerIdEnum = typeof HomeFlyerIdEnum[keyof typeof HomeFlyerIdEnum];
export const HomeFlyerNameEnum = {
    Name: 'name'
} as const;

export type HomeFlyerNameEnum = typeof HomeFlyerNameEnum[keyof typeof HomeFlyerNameEnum];
export const HomeFlyerDescriptionEnum = {
    Description: 'description'
} as const;

export type HomeFlyerDescriptionEnum = typeof HomeFlyerDescriptionEnum[keyof typeof HomeFlyerDescriptionEnum];
export const HomeFlyerHrefEnum = {
    Href: 'href'
} as const;

export type HomeFlyerHrefEnum = typeof HomeFlyerHrefEnum[keyof typeof HomeFlyerHrefEnum];
export const HomeFlyerPathEnum = {
    Path: 'path'
} as const;

export type HomeFlyerPathEnum = typeof HomeFlyerPathEnum[keyof typeof HomeFlyerPathEnum];

/**
 * 
 * @export
 * @interface InviteLinkedUserErrors
 */
export interface InviteLinkedUserErrors {
    /**
     * Error message detailing what is wrong
     * @type {string}
     * @memberof InviteLinkedUserErrors
     */
    'message'?: string;
    /**
     * 
     * @type {SendOtpErrorsErrors}
     * @memberof InviteLinkedUserErrors
     */
    'errors'?: SendOtpErrorsErrors;
}
/**
 * 
 * @export
 * @interface InviteLinkedUserRequest
 */
export interface InviteLinkedUserRequest {
    /**
     * 
     * @type {string}
     * @memberof InviteLinkedUserRequest
     */
    'email': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InviteLinkedUserRequest
     */
    'permissions'?: Array<string>;
}
/**
 * 
 * @export
 * @interface LinkedUserInvitation
 */
export interface LinkedUserInvitation {
    /**
     * 
     * @type {number}
     * @memberof LinkedUserInvitation
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof LinkedUserInvitation
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof LinkedUserInvitation
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof LinkedUserInvitation
     */
    'updated_at'?: string;
}
/**
 * 
 * @export
 * @interface LinkedUserInvitationOutput
 */
export interface LinkedUserInvitationOutput {
    /**
     * 
     * @type {number}
     * @memberof LinkedUserInvitationOutput
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof LinkedUserInvitationOutput
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof LinkedUserInvitationOutput
     */
    'createdAt'?: string;
}
/**
 * 
 * @export
 * @interface LinkedUserOutput
 */
export interface LinkedUserOutput {
    /**
     * 
     * @type {number}
     * @memberof LinkedUserOutput
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof LinkedUserOutput
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof LinkedUserOutput
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof LinkedUserOutput
     */
    'surname'?: string;
}
/**
 * 
 * @export
 * @interface ListReservationOutput
 */
export interface ListReservationOutput {
    /**
     * 
     * @type {number}
     * @memberof ListReservationOutput
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ListReservationOutput
     */
    'uuid': string;
    /**
     * 
     * @type {number}
     * @memberof ListReservationOutput
     */
    'ticketQuantity': number;
    /**
     * 
     * @type {string}
     * @memberof ListReservationOutput
     */
    'showName': string;
    /**
     * 
     * @type {string}
     * @memberof ListReservationOutput
     */
    'showFlyer': string;
    /**
     * 
     * @type {string}
     * @memberof ListReservationOutput
     */
    'date': string;
    /**
     * 
     * @type {boolean}
     * @memberof ListReservationOutput
     */
    'isOnline': boolean;
    /**
     * 
     * @type {string}
     * @memberof ListReservationOutput
     */
    'price': string;
    /**
     * 
     * @type {string}
     * @memberof ListReservationOutput
     */
    'showType': string;
    /**
     * 
     * @type {string}
     * @memberof ListReservationOutput
     */
    'purchasedDate': string;
    /**
     * 
     * @type {Location}
     * @memberof ListReservationOutput
     */
    'location'?: Location;
    /**
     * 
     * @type {string}
     * @memberof ListReservationOutput
     */
    'showPriceName'?: string;
}
/**
 * 
 * @export
 * @interface ListReservations200Response
 */
export interface ListReservations200Response {
    /**
     * 
     * @type {number}
     * @memberof ListReservations200Response
     */
    'current_page': number;
    /**
     * 
     * @type {string}
     * @memberof ListReservations200Response
     */
    'first_page_url': string;
    /**
     * 
     * @type {number}
     * @memberof ListReservations200Response
     */
    'from': number;
    /**
     * 
     * @type {number}
     * @memberof ListReservations200Response
     */
    'last_page': number;
    /**
     * 
     * @type {string}
     * @memberof ListReservations200Response
     */
    'last_page_url': string;
    /**
     * 
     * @type {Array<ListShowEventPaymentRequest200ResponseLinksInner>}
     * @memberof ListReservations200Response
     */
    'links': Array<ListShowEventPaymentRequest200ResponseLinksInner>;
    /**
     * 
     * @type {string}
     * @memberof ListReservations200Response
     */
    'next_page_url': string;
    /**
     * 
     * @type {string}
     * @memberof ListReservations200Response
     */
    'path': string;
    /**
     * 
     * @type {number}
     * @memberof ListReservations200Response
     */
    'per_page': number;
    /**
     * 
     * @type {string}
     * @memberof ListReservations200Response
     */
    'prev_page_url': string;
    /**
     * 
     * @type {number}
     * @memberof ListReservations200Response
     */
    'to': number;
    /**
     * 
     * @type {number}
     * @memberof ListReservations200Response
     */
    'total': number;
    /**
     * 
     * @type {Array<ListReservationOutput>}
     * @memberof ListReservations200Response
     */
    'data': Array<ListReservationOutput>;
}
/**
 * 
 * @export
 * @interface ListShowEventPaymentRequest200Response
 */
export interface ListShowEventPaymentRequest200Response {
    /**
     * 
     * @type {number}
     * @memberof ListShowEventPaymentRequest200Response
     */
    'current_page': number;
    /**
     * 
     * @type {Array<CustomerPaymentRequestOutput>}
     * @memberof ListShowEventPaymentRequest200Response
     */
    'data': Array<CustomerPaymentRequestOutput>;
    /**
     * 
     * @type {string}
     * @memberof ListShowEventPaymentRequest200Response
     */
    'first_page_url': string;
    /**
     * 
     * @type {number}
     * @memberof ListShowEventPaymentRequest200Response
     */
    'from': number;
    /**
     * 
     * @type {number}
     * @memberof ListShowEventPaymentRequest200Response
     */
    'last_page': number;
    /**
     * 
     * @type {string}
     * @memberof ListShowEventPaymentRequest200Response
     */
    'last_page_url': string;
    /**
     * 
     * @type {Array<ListShowEventPaymentRequest200ResponseLinksInner>}
     * @memberof ListShowEventPaymentRequest200Response
     */
    'links': Array<ListShowEventPaymentRequest200ResponseLinksInner>;
    /**
     * 
     * @type {string}
     * @memberof ListShowEventPaymentRequest200Response
     */
    'next_page_url': string;
    /**
     * 
     * @type {string}
     * @memberof ListShowEventPaymentRequest200Response
     */
    'path': string;
    /**
     * 
     * @type {number}
     * @memberof ListShowEventPaymentRequest200Response
     */
    'per_page': number;
    /**
     * 
     * @type {string}
     * @memberof ListShowEventPaymentRequest200Response
     */
    'prev_page_url': string;
    /**
     * 
     * @type {number}
     * @memberof ListShowEventPaymentRequest200Response
     */
    'to': number;
    /**
     * 
     * @type {number}
     * @memberof ListShowEventPaymentRequest200Response
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface ListShowEventPaymentRequest200ResponseLinksInner
 */
export interface ListShowEventPaymentRequest200ResponseLinksInner {
    /**
     * 
     * @type {string}
     * @memberof ListShowEventPaymentRequest200ResponseLinksInner
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof ListShowEventPaymentRequest200ResponseLinksInner
     */
    'label'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ListShowEventPaymentRequest200ResponseLinksInner
     */
    'active'?: boolean;
}
/**
 * 
 * @export
 * @interface ListShowEventTicketsOutput
 */
export interface ListShowEventTicketsOutput {
    /**
     * 
     * @type {string}
     * @memberof ListShowEventTicketsOutput
     */
    'uuid': string;
    /**
     * 
     * @type {boolean}
     * @memberof ListShowEventTicketsOutput
     */
    'active': boolean;
    /**
     * 
     * @type {string}
     * @memberof ListShowEventTicketsOutput
     */
    'customer'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListShowEventTicketsOutput
     */
    'userName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListShowEventTicketsOutput
     */
    'userEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListShowEventTicketsOutput
     */
    'priceName'?: string | null;
}
/**
 * 
 * @export
 * @interface ListShows200Response
 */
export interface ListShows200Response {
    /**
     * 
     * @type {number}
     * @memberof ListShows200Response
     */
    'current_page': number;
    /**
     * 
     * @type {Array<ShowPublicOutput>}
     * @memberof ListShows200Response
     */
    'data': Array<ShowPublicOutput>;
    /**
     * 
     * @type {string}
     * @memberof ListShows200Response
     */
    'first_page_url': string;
    /**
     * 
     * @type {number}
     * @memberof ListShows200Response
     */
    'from': number;
    /**
     * 
     * @type {number}
     * @memberof ListShows200Response
     */
    'last_page': number;
    /**
     * 
     * @type {string}
     * @memberof ListShows200Response
     */
    'last_page_url': string;
    /**
     * 
     * @type {Array<ListShowEventPaymentRequest200ResponseLinksInner>}
     * @memberof ListShows200Response
     */
    'links': Array<ListShowEventPaymentRequest200ResponseLinksInner>;
    /**
     * 
     * @type {string}
     * @memberof ListShows200Response
     */
    'next_page_url': string;
    /**
     * 
     * @type {string}
     * @memberof ListShows200Response
     */
    'path': string;
    /**
     * 
     * @type {number}
     * @memberof ListShows200Response
     */
    'per_page': number;
    /**
     * 
     * @type {string}
     * @memberof ListShows200Response
     */
    'prev_page_url': string;
    /**
     * 
     * @type {number}
     * @memberof ListShows200Response
     */
    'to': number;
    /**
     * 
     * @type {number}
     * @memberof ListShows200Response
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface ListShowsToControl200Response
 */
export interface ListShowsToControl200Response {
    /**
     * 
     * @type {number}
     * @memberof ListShowsToControl200Response
     */
    'current_page': number;
    /**
     * 
     * @type {string}
     * @memberof ListShowsToControl200Response
     */
    'first_page_url': string;
    /**
     * 
     * @type {number}
     * @memberof ListShowsToControl200Response
     */
    'from': number;
    /**
     * 
     * @type {number}
     * @memberof ListShowsToControl200Response
     */
    'last_page': number;
    /**
     * 
     * @type {string}
     * @memberof ListShowsToControl200Response
     */
    'last_page_url': string;
    /**
     * 
     * @type {Array<ListShowEventPaymentRequest200ResponseLinksInner>}
     * @memberof ListShowsToControl200Response
     */
    'links': Array<ListShowEventPaymentRequest200ResponseLinksInner>;
    /**
     * 
     * @type {string}
     * @memberof ListShowsToControl200Response
     */
    'next_page_url': string;
    /**
     * 
     * @type {string}
     * @memberof ListShowsToControl200Response
     */
    'path': string;
    /**
     * 
     * @type {number}
     * @memberof ListShowsToControl200Response
     */
    'per_page': number;
    /**
     * 
     * @type {string}
     * @memberof ListShowsToControl200Response
     */
    'prev_page_url': string;
    /**
     * 
     * @type {number}
     * @memberof ListShowsToControl200Response
     */
    'to': number;
    /**
     * 
     * @type {number}
     * @memberof ListShowsToControl200Response
     */
    'total': number;
    /**
     * 
     * @type {Array<ShowToControlInformation>}
     * @memberof ListShowsToControl200Response
     */
    'data': Array<ShowToControlInformation>;
}
/**
 * 
 * @export
 * @interface ListTickets200Response
 */
export interface ListTickets200Response {
    /**
     * 
     * @type {number}
     * @memberof ListTickets200Response
     */
    'current_page': number;
    /**
     * 
     * @type {string}
     * @memberof ListTickets200Response
     */
    'first_page_url': string;
    /**
     * 
     * @type {number}
     * @memberof ListTickets200Response
     */
    'from': number;
    /**
     * 
     * @type {number}
     * @memberof ListTickets200Response
     */
    'last_page': number;
    /**
     * 
     * @type {string}
     * @memberof ListTickets200Response
     */
    'last_page_url': string;
    /**
     * 
     * @type {Array<ListShowEventPaymentRequest200ResponseLinksInner>}
     * @memberof ListTickets200Response
     */
    'links': Array<ListShowEventPaymentRequest200ResponseLinksInner>;
    /**
     * 
     * @type {string}
     * @memberof ListTickets200Response
     */
    'next_page_url': string;
    /**
     * 
     * @type {string}
     * @memberof ListTickets200Response
     */
    'path': string;
    /**
     * 
     * @type {number}
     * @memberof ListTickets200Response
     */
    'per_page': number;
    /**
     * 
     * @type {string}
     * @memberof ListTickets200Response
     */
    'prev_page_url': string;
    /**
     * 
     * @type {number}
     * @memberof ListTickets200Response
     */
    'to': number;
    /**
     * 
     * @type {number}
     * @memberof ListTickets200Response
     */
    'total': number;
    /**
     * 
     * @type {Array<ListShowEventTicketsOutput>}
     * @memberof ListTickets200Response
     */
    'data': Array<ListShowEventTicketsOutput>;
}
/**
 * 
 * @export
 * @interface ListUserShows200Response
 */
export interface ListUserShows200Response {
    /**
     * 
     * @type {PaginatedResourceLinks}
     * @memberof ListUserShows200Response
     */
    'links': PaginatedResourceLinks;
    /**
     * 
     * @type {PaginatedResourceMeta}
     * @memberof ListUserShows200Response
     */
    'meta': PaginatedResourceMeta;
    /**
     * 
     * @type {Array<UserShowResource>}
     * @memberof ListUserShows200Response
     */
    'data': Array<UserShowResource>;
}
/**
 * 
 * @export
 * @interface Location
 */
export interface Location {
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'locality': string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'country': string;
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'lat': number;
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'lng': number;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'googleMapPreviewUrl': string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'updated_at'?: string;
}
/**
 * 
 * @export
 * @interface LocationInput
 */
export interface LocationInput {
    /**
     * 
     * @type {string}
     * @memberof LocationInput
     */
    'locationName': string;
    /**
     * 
     * @type {string}
     * @memberof LocationInput
     */
    'locationAddress': string;
    /**
     * 
     * @type {string}
     * @memberof LocationInput
     */
    'locationLocality': string;
    /**
     * 
     * @type {string}
     * @memberof LocationInput
     */
    'locationCity': string;
    /**
     * 
     * @type {string}
     * @memberof LocationInput
     */
    'locationCountry': string;
    /**
     * 
     * @type {number}
     * @memberof LocationInput
     */
    'locationLat': number;
    /**
     * 
     * @type {number}
     * @memberof LocationInput
     */
    'locationLng': number;
}
/**
 * 
 * @export
 * @interface LocationResource
 */
export interface LocationResource {
    /**
     * 
     * @type {number}
     * @memberof LocationResource
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof LocationResource
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof LocationResource
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof LocationResource
     */
    'locality': string;
    /**
     * 
     * @type {string}
     * @memberof LocationResource
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof LocationResource
     */
    'country': string;
    /**
     * 
     * @type {number}
     * @memberof LocationResource
     */
    'lat': number;
    /**
     * 
     * @type {number}
     * @memberof LocationResource
     */
    'lng': number;
    /**
     * 
     * @type {string}
     * @memberof LocationResource
     */
    'placeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationResource
     */
    'googleMapPreviewUrl': string;
}
/**
 * 
 * @export
 * @interface MinimalShowEvent
 */
export interface MinimalShowEvent {
    /**
     * 
     * @type {number}
     * @memberof MinimalShowEvent
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof MinimalShowEvent
     */
    'startsAt'?: string;
}
/**
 * 
 * @export
 * @interface MinimalShowPrice
 */
export interface MinimalShowPrice {
    /**
     * 
     * @type {number}
     * @memberof MinimalShowPrice
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof MinimalShowPrice
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof MinimalShowPrice
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof MinimalShowPrice
     */
    'color'?: string;
}
/**
 * Standard structure of paginated response
 * @export
 * @interface PaginatedResource
 */
export interface PaginatedResource {
    /**
     * 
     * @type {PaginatedResourceLinks}
     * @memberof PaginatedResource
     */
    'links': PaginatedResourceLinks;
    /**
     * 
     * @type {PaginatedResourceMeta}
     * @memberof PaginatedResource
     */
    'meta': PaginatedResourceMeta;
}
/**
 * 
 * @export
 * @interface PaginatedResourceLinks
 */
export interface PaginatedResourceLinks {
    /**
     * 
     * @type {string}
     * @memberof PaginatedResourceLinks
     */
    'first'?: string;
    /**
     * 
     * @type {string}
     * @memberof PaginatedResourceLinks
     */
    'last'?: string;
    /**
     * 
     * @type {string}
     * @memberof PaginatedResourceLinks
     */
    'prev'?: string;
    /**
     * 
     * @type {string}
     * @memberof PaginatedResourceLinks
     */
    'next'?: string;
}
/**
 * 
 * @export
 * @interface PaginatedResourceMeta
 */
export interface PaginatedResourceMeta {
    /**
     * 
     * @type {number}
     * @memberof PaginatedResourceMeta
     */
    'current_page'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResourceMeta
     */
    'from'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResourceMeta
     */
    'last_page'?: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedResourceMeta
     */
    'path'?: string;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResourceMeta
     */
    'per_page'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResourceMeta
     */
    'to'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResourceMeta
     */
    'total'?: number;
    /**
     * 
     * @type {Array<ListShowEventPaymentRequest200ResponseLinksInner>}
     * @memberof PaginatedResourceMeta
     */
    'links'?: Array<ListShowEventPaymentRequest200ResponseLinksInner>;
}
/**
 * Standard structure of paginated response
 * @export
 * @interface PaginatedResponse
 */
export interface PaginatedResponse {
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponse
     */
    'current_page': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedResponse
     */
    'first_page_url': string;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponse
     */
    'from': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponse
     */
    'last_page': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedResponse
     */
    'last_page_url': string;
    /**
     * 
     * @type {Array<ListShowEventPaymentRequest200ResponseLinksInner>}
     * @memberof PaginatedResponse
     */
    'links': Array<ListShowEventPaymentRequest200ResponseLinksInner>;
    /**
     * 
     * @type {string}
     * @memberof PaginatedResponse
     */
    'next_page_url': string;
    /**
     * 
     * @type {string}
     * @memberof PaginatedResponse
     */
    'path': string;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponse
     */
    'per_page': number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedResponse
     */
    'prev_page_url': string;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponse
     */
    'to': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedResponse
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface PatchCouponRequest
 */
export interface PatchCouponRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchCouponRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchCouponRequest
     */
    'code'?: string;
    /**
     * 
     * @type {number}
     * @memberof PatchCouponRequest
     */
    'discount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PatchCouponRequest
     */
    'active'?: boolean;
}
/**
 * 
 * @export
 * @interface PatchCouponRequestErrors
 */
export interface PatchCouponRequestErrors {
    /**
     * Error message detailing what is wrong
     * @type {string}
     * @memberof PatchCouponRequestErrors
     */
    'message'?: string;
    /**
     * 
     * @type {CreateCouponRequestErrorsErrors}
     * @memberof PatchCouponRequestErrors
     */
    'errors'?: CreateCouponRequestErrorsErrors;
}
/**
 * 
 * @export
 * @interface PatchFlyerRequest
 */
export interface PatchFlyerRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchFlyerRequest
     */
    'role'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PatchFlyerRequest
     */
    'active'?: boolean;
}
/**
 * 
 * @export
 * @interface PatchFlyerRequestErrors
 */
export interface PatchFlyerRequestErrors {
    /**
     * Error message detailing what is wrong
     * @type {string}
     * @memberof PatchFlyerRequestErrors
     */
    'message'?: string;
    /**
     * 
     * @type {PatchFlyerRequestErrorsErrors}
     * @memberof PatchFlyerRequestErrors
     */
    'errors'?: PatchFlyerRequestErrorsErrors;
}
/**
 * Object containing detailed error messages indexed by field name
 * @export
 * @interface PatchFlyerRequestErrorsErrors
 */
export interface PatchFlyerRequestErrorsErrors {
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchFlyerRequestErrorsErrors
     */
    'role'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchFlyerRequestErrorsErrors
     */
    'active'?: Array<string>;
}
/**
 * 
 * @export
 * @interface PatchLocationRequest
 */
export interface PatchLocationRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchLocationRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchLocationRequest
     */
    'placeId'?: string;
}
/**
 * 
 * @export
 * @interface PatchLocationRequestErrors
 */
export interface PatchLocationRequestErrors {
    /**
     * Error message detailing what is wrong
     * @type {string}
     * @memberof PatchLocationRequestErrors
     */
    'message'?: string;
    /**
     * 
     * @type {PatchLocationRequestErrorsErrors}
     * @memberof PatchLocationRequestErrors
     */
    'errors'?: PatchLocationRequestErrorsErrors;
}
/**
 * Object containing detailed error messages indexed by field name
 * @export
 * @interface PatchLocationRequestErrorsErrors
 */
export interface PatchLocationRequestErrorsErrors {
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchLocationRequestErrorsErrors
     */
    'name'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchLocationRequestErrorsErrors
     */
    'placeId'?: Array<string>;
}
/**
 * 
 * @export
 * @interface PatchShowPriceRequest
 */
export interface PatchShowPriceRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchShowPriceRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchShowPriceRequest
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof PatchShowPriceRequest
     */
    'availableTickets'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchShowPriceRequest
     */
    'maxTicketsPerReservation'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchShowPriceRequest
     */
    'color'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchShowPriceRequest
     */
    'reservableUntil'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchShowPriceRequest
     */
    'validUntil'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchShowPriceRequest
     */
    'listed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchShowPriceRequest
     */
    'permalink'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchShowPriceRequest
     */
    'allowContribution'?: boolean;
}
/**
 * 
 * @export
 * @interface PatchShowPriceRequestErrors
 */
export interface PatchShowPriceRequestErrors {
    /**
     * Error message detailing what is wrong
     * @type {string}
     * @memberof PatchShowPriceRequestErrors
     */
    'message'?: string;
    /**
     * 
     * @type {PatchShowPriceRequestErrorsErrors}
     * @memberof PatchShowPriceRequestErrors
     */
    'errors'?: PatchShowPriceRequestErrorsErrors;
}
/**
 * Object containing detailed error messages indexed by field name
 * @export
 * @interface PatchShowPriceRequestErrorsErrors
 */
export interface PatchShowPriceRequestErrorsErrors {
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchShowPriceRequestErrorsErrors
     */
    'name'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchShowPriceRequestErrorsErrors
     */
    'description'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchShowPriceRequestErrorsErrors
     */
    'availableTickets'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchShowPriceRequestErrorsErrors
     */
    'color'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchShowPriceRequestErrorsErrors
     */
    'reservableUntil'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchShowPriceRequestErrorsErrors
     */
    'validUntil'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchShowPriceRequestErrorsErrors
     */
    'listed'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchShowPriceRequestErrorsErrors
     */
    'allowContribution'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatchShowPriceRequestErrorsErrors
     */
    'permalink'?: Array<string>;
}
/**
 * 
 * @export
 * @interface PatchShowRequest
 */
export interface PatchShowRequest {
    /**
     * 
     * @type {string}
     * @memberof PatchShowRequest
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchShowRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchShowRequest
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchShowRequest
     */
    'ageRestricted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchShowRequest
     */
    'isPrivate'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PatchShowRequest
     */
    'genreId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchShowRequest
     */
    'acceptedTermsId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchShowRequest
     */
    'externalUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchShowRequest
     */
    'billingPreference'?: string;
    /**
     * 
     * @type {number}
     * @memberof PatchShowRequest
     */
    'donateProviderId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PatchShowRequest
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchShowRequest
     */
    'pixelId'?: string | null;
}
/**
 * 
 * @export
 * @interface PatchShowRequestErrors
 */
export interface PatchShowRequestErrors {
    /**
     * Error message detailing what is wrong
     * @type {string}
     * @memberof PatchShowRequestErrors
     */
    'message'?: string;
    /**
     * 
     * @type {CreateDraftShowRequestErrorsErrors}
     * @memberof PatchShowRequestErrors
     */
    'errors'?: CreateDraftShowRequestErrorsErrors;
}
/**
 * 
 * @export
 * @interface PublicEventResource
 */
export interface PublicEventResource {
    /**
     * 
     * @type {number}
     * @memberof PublicEventResource
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PublicEventResource
     */
    'startsAt': string;
    /**
     * 
     * @type {string}
     * @memberof PublicEventResource
     */
    'endsAt': string;
}
/**
 * 
 * @export
 * @interface RegisterUserErrors
 */
export interface RegisterUserErrors {
    /**
     * Error message detailing what is wrong
     * @type {string}
     * @memberof RegisterUserErrors
     */
    'message'?: string;
    /**
     * 
     * @type {RegisterUserErrorsErrors}
     * @memberof RegisterUserErrors
     */
    'errors'?: RegisterUserErrorsErrors;
}
/**
 * Object containing detailed error messages indexed by field name
 * @export
 * @interface RegisterUserErrorsErrors
 */
export interface RegisterUserErrorsErrors {
    /**
     * 
     * @type {Array<string>}
     * @memberof RegisterUserErrorsErrors
     */
    'password'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RegisterUserErrorsErrors
     */
    'name'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RegisterUserErrorsErrors
     */
    'surname'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RegisterUserErrorsErrors
     */
    'email'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RegisterUserErrorsErrors
     */
    'acceptedTerms'?: Array<string>;
}
/**
 * 
 * @export
 * @interface RegisterUserRequest
 */
export interface RegisterUserRequest {
    /**
     * 
     * @type {string}
     * @memberof RegisterUserRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterUserRequest
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterUserRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterUserRequest
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterUserRequest
     */
    'password_confirmation'?: string;
    /**
     * 
     * @type {number}
     * @memberof RegisterUserRequest
     */
    'acceptedTermsId'?: number;
}
/**
 * 
 * @export
 * @interface RequestPaymentToCustomerRequest
 */
export interface RequestPaymentToCustomerRequest {
    /**
     * 
     * @type {number}
     * @memberof RequestPaymentToCustomerRequest
     */
    'amount': number;
}
/**
 * 
 * @export
 * @interface ReservationResponse
 */
export interface ReservationResponse {
    /**
     * 
     * @type {string}
     * @memberof ReservationResponse
     */
    'reservationToken': string;
    /**
     * 
     * @type {string}
     * @memberof ReservationResponse
     */
    'paymentProviderName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReservationResponse
     */
    'paymentLink'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReservationResponse
     */
    'price'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReservationResponse
     */
    'fee'?: number | null;
}
/**
 * 
 * @export
 * @interface ReservationTokenRequest
 */
export interface ReservationTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof ReservationTokenRequest
     */
    'reservationToken': string;
}
/**
 * Reservations Overview
 * @export
 * @interface ReservationsOverview
 */
export interface ReservationsOverview {
    /**
     * 
     * @type {number}
     * @memberof ReservationsOverview
     */
    'reservations': number;
    /**
     * 
     * @type {number}
     * @memberof ReservationsOverview
     */
    'tickets': number;
    /**
     * 
     * @type {number}
     * @memberof ReservationsOverview
     */
    'organizerAmount': number;
    /**
     * 
     * @type {number}
     * @memberof ReservationsOverview
     */
    'feeGrossAmount': number;
}
/**
 * 
 * @export
 * @interface ResetLinkErrors
 */
export interface ResetLinkErrors {
    /**
     * Error message detailing what is wrong
     * @type {string}
     * @memberof ResetLinkErrors
     */
    'message'?: string;
    /**
     * 
     * @type {ResetLinkErrorsErrors}
     * @memberof ResetLinkErrors
     */
    'errors'?: ResetLinkErrorsErrors;
}
/**
 * Object containing detailed error messages indexed by field name
 * @export
 * @interface ResetLinkErrorsErrors
 */
export interface ResetLinkErrorsErrors {
    /**
     * 
     * @type {Array<string>}
     * @memberof ResetLinkErrorsErrors
     */
    'email'?: Array<string>;
}
/**
 * 
 * @export
 * @interface ResetPasswordErrors
 */
export interface ResetPasswordErrors {
    /**
     * Error message detailing what is wrong
     * @type {string}
     * @memberof ResetPasswordErrors
     */
    'message'?: string;
    /**
     * 
     * @type {ResetPasswordErrorsErrors}
     * @memberof ResetPasswordErrors
     */
    'errors'?: ResetPasswordErrorsErrors;
}
/**
 * Object containing detailed error messages indexed by field name
 * @export
 * @interface ResetPasswordErrorsErrors
 */
export interface ResetPasswordErrorsErrors {
    /**
     * 
     * @type {Array<string>}
     * @memberof ResetPasswordErrorsErrors
     */
    'password'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResetPasswordErrorsErrors
     */
    'email'?: Array<string>;
}
/**
 * 
 * @export
 * @interface ResetPasswordRequest
 */
export interface ResetPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordRequest
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordRequest
     */
    'password_confirmation': string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordRequest
     */
    'securityCode': string;
}
/**
 * 
 * @export
 * @interface Role
 */
export interface Role {
    /**
     * 
     * @type {number}
     * @memberof Role
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Role
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Role
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Role
     */
    'protected'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Role
     */
    'updated_at'?: string;
}
/**
 * 
 * @export
 * @interface SalesReportRecipientMinimalResource
 */
export interface SalesReportRecipientMinimalResource {
    /**
     * 
     * @type {number}
     * @memberof SalesReportRecipientMinimalResource
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof SalesReportRecipientMinimalResource
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SalesReportRecipientMinimalResource
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface SendOtpErrors
 */
export interface SendOtpErrors {
    /**
     * Error message detailing what is wrong
     * @type {string}
     * @memberof SendOtpErrors
     */
    'message'?: string;
    /**
     * 
     * @type {SendOtpErrorsErrors}
     * @memberof SendOtpErrors
     */
    'errors'?: SendOtpErrorsErrors;
}
/**
 * Object containing detailed error messages indexed by field name
 * @export
 * @interface SendOtpErrorsErrors
 */
export interface SendOtpErrorsErrors {
    /**
     * 
     * @type {Array<string>}
     * @memberof SendOtpErrorsErrors
     */
    'email'?: Array<string>;
}
/**
 * 
 * @export
 * @interface SendOtpRequest
 */
export interface SendOtpRequest {
    /**
     * 
     * @type {string}
     * @memberof SendOtpRequest
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface SendResetLinkRequest
 */
export interface SendResetLinkRequest {
    /**
     * 
     * @type {string}
     * @memberof SendResetLinkRequest
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface Show
 */
export interface Show {
    /**
     * 
     * @type {number}
     * @memberof Show
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Show
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Show
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof Show
     */
    'path': string;
    /**
     * 
     * @type {string}
     * @memberof Show
     */
    'status': string;
    /**
     * 
     * @type {number}
     * @memberof Show
     * @deprecated
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof Show
     */
    'type': ShowTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof Show
     */
    'genre_id': number;
    /**
     * 
     * @type {boolean}
     * @memberof Show
     */
    'ageRestriction': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Show
     */
    'isOnline': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Show
     */
    'isPrivate': boolean;
    /**
     * 
     * @type {string}
     * @memberof Show
     */
    'flyer': string;
    /**
     * 
     * @type {number}
     * @memberof Show
     */
    'location_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof Show
     */
    'donate_provider_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Show
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof Show
     */
    'billing_preference'?: string;
    /**
     * 
     * @type {string}
     * @memberof Show
     */
    'realFlyerPath'?: string;
    /**
     * 
     * @type {string}
     * @memberof Show
     */
    'eventDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Show
     */
    'externalUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof Show
     */
    'googleMapUrl'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Show
     */
    'availableTickets'?: number;
    /**
     * 
     * @type {number}
     * @memberof Show
     */
    'availableTicketsPerShowEvent'?: number;
    /**
     * 
     * @type {number}
     * @memberof Show
     */
    'terms_and_condition_id'?: number;
    /**
     * 
     * @type {Location}
     * @memberof Show
     */
    'location'?: Location;
    /**
     * 
     * @type {User}
     * @memberof Show
     */
    'user'?: User;
    /**
     * 
     * @type {Genre}
     * @memberof Show
     * @deprecated
     */
    'genre'?: Genre;
    /**
     * 
     * @type {Array<ShowFlyer>}
     * @memberof Show
     */
    'show_flyers'?: Array<ShowFlyer>;
    /**
     * 
     * @type {string}
     * @memberof Show
     */
    'code'?: string;
    /**
     * 
     * @type {Array<ShowEvent>}
     * @memberof Show
     */
    'show_events'?: Array<ShowEvent>;
    /**
     * 
     * @type {Array<ShowPrice>}
     * @memberof Show
     */
    'show_prices'?: Array<ShowPrice>;
    /**
     * 
     * @type {DonateProviderPublicOutput}
     * @memberof Show
     */
    'donateProviderPublicInformation'?: DonateProviderPublicOutput;
}

export const ShowTypeEnum = {
    Paid: 'paid',
    External: 'external'
} as const;

export type ShowTypeEnum = typeof ShowTypeEnum[keyof typeof ShowTypeEnum];

/**
 * 
 * @export
 * @interface ShowEvent
 */
export interface ShowEvent {
    /**
     * 
     * @type {number}
     * @memberof ShowEvent
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ShowEvent
     */
    'startsAt': string;
    /**
     * 
     * @type {string}
     * @memberof ShowEvent
     */
    'endsAt': string;
    /**
     * 
     * @type {number}
     * @memberof ShowEvent
     */
    'show_id': number;
    /**
     * 
     * @type {number}
     * @memberof ShowEvent
     */
    'revenue': number;
    /**
     * 
     * @type {string}
     * @memberof ShowEvent
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowEvent
     */
    'updated_at'?: string;
}
/**
 * 
 * @export
 * @interface ShowEventDetailedOutput
 */
export interface ShowEventDetailedOutput {
    /**
     * 
     * @type {string}
     * @memberof ShowEventDetailedOutput
     */
    'startsAt': string;
    /**
     * 
     * @type {string}
     * @memberof ShowEventDetailedOutput
     */
    'endsAt': string;
    /**
     * 
     * @type {string}
     * @memberof ShowEventDetailedOutput
     */
    'showName': string;
    /**
     * 
     * @type {number}
     * @memberof ShowEventDetailedOutput
     */
    'revenue': number;
    /**
     * 
     * @type {number}
     * @memberof ShowEventDetailedOutput
     */
    'withdraw': number;
    /**
     * 
     * @type {number}
     * @memberof ShowEventDetailedOutput
     */
    'ticketsSold': number;
}
/**
 * 
 * @export
 * @interface ShowEventInput
 */
export interface ShowEventInput {
    /**
     * 
     * @type {string}
     * @memberof ShowEventInput
     */
    'startsAt': string;
    /**
     * 
     * @type {string}
     * @memberof ShowEventInput
     */
    'endsAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof ShowEventInput
     */
    'listed': boolean;
}
/**
 * 
 * @export
 * @interface ShowEventPublicOutput
 */
export interface ShowEventPublicOutput {
    /**
     * 
     * @type {string}
     * @memberof ShowEventPublicOutput
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ShowEventPublicOutput
     */
    'startsAt': string;
    /**
     * 
     * @type {string}
     * @memberof ShowEventPublicOutput
     */
    'endsAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof ShowEventPublicOutput
     */
    'soldOut': boolean;
    /**
     * 
     * @type {Array<ShowPricePublicOutput>}
     * @memberof ShowEventPublicOutput
     */
    'showPrices'?: Array<ShowPricePublicOutput>;
}
/**
 * 
 * @export
 * @interface ShowFlyer
 */
export interface ShowFlyer {
    /**
     * 
     * @type {number}
     * @memberof ShowFlyer
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShowFlyer
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowFlyer
     */
    'role'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ShowFlyer
     */
    'active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ShowFlyer
     * @deprecated
     */
    'filename'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowFlyer
     * @deprecated
     */
    'realFlyerPath'?: string;
}
/**
 * 
 * @export
 * @interface ShowFlyerInput
 */
export interface ShowFlyerInput {
    /**
     * 
     * @type {string}
     * @memberof ShowFlyerInput
     */
    'filename': string;
    /**
     * 
     * @type {string}
     * @memberof ShowFlyerInput
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface ShowPrice
 */
export interface ShowPrice {
    /**
     * 
     * @type {number}
     * @memberof ShowPrice
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ShowPrice
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ShowPrice
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShowPrice
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof ShowPrice
     */
    'platformFee': number;
    /**
     * 
     * @type {number}
     * @memberof ShowPrice
     */
    'show_id': number;
    /**
     * 
     * @type {number}
     * @memberof ShowPrice
     */
    'available_tickets': number;
    /**
     * 
     * @type {number}
     * @memberof ShowPrice
     */
    'maxTicketsPerReservation': number;
    /**
     * 
     * @type {string}
     * @memberof ShowPrice
     */
    'color'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowPrice
     */
    'reservableUntil'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShowPrice
     */
    'validUntil'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ShowPrice
     */
    'listed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShowPrice
     */
    'allowContribution'?: boolean;
}
/**
 * 
 * @export
 * @interface ShowPriceInput
 */
export interface ShowPriceInput {
    /**
     * 
     * @type {string}
     * @memberof ShowPriceInput
     */
    'showPriceName': string;
    /**
     * 
     * @type {number}
     * @memberof ShowPriceInput
     */
    'showPriceValue': number;
    /**
     * 
     * @type {number}
     * @memberof ShowPriceInput
     */
    'showPriceAvailableTickets': number;
}
/**
 * 
 * @export
 * @interface ShowPricePublicOutput
 */
export interface ShowPricePublicOutput {
    /**
     * 
     * @type {number}
     * @memberof ShowPricePublicOutput
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ShowPricePublicOutput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ShowPricePublicOutput
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof ShowPricePublicOutput
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof ShowPricePublicOutput
     */
    'platformFee': number;
    /**
     * 
     * @type {boolean}
     * @memberof ShowPricePublicOutput
     */
    'priceIncludesPlatformFee': boolean;
    /**
     * 
     * @type {string}
     * @memberof ShowPricePublicOutput
     */
    'color': string;
    /**
     * 
     * @type {string}
     * @memberof ShowPricePublicOutput
     */
    'reservableUntil'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShowPricePublicOutput
     */
    'validUntil'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ShowPricePublicOutput
     */
    'allowContribution'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShowPricePublicOutput
     */
    'soldOut'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ShowPricePublicOutput
     */
    'maxTicketsPerReservation'?: number | null;
}
/**
 * 
 * @export
 * @interface ShowPriceUserOutput
 */
export interface ShowPriceUserOutput {
    /**
     * 
     * @type {number}
     * @memberof ShowPriceUserOutput
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof ShowPriceUserOutput
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof ShowPriceUserOutput
     */
    'platformFee': number;
    /**
     * 
     * @type {boolean}
     * @memberof ShowPriceUserOutput
     */
    'priceIncludesPlatformFee': boolean;
    /**
     * 
     * @type {string}
     * @memberof ShowPriceUserOutput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ShowPriceUserOutput
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShowPriceUserOutput
     */
    'availableTickets': number;
    /**
     * 
     * @type {string}
     * @memberof ShowPriceUserOutput
     */
    'color': string;
    /**
     * 
     * @type {string}
     * @memberof ShowPriceUserOutput
     */
    'reservableUntil'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShowPriceUserOutput
     */
    'validUntil'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShowPriceUserOutput
     */
    'maxTicketsPerReservation': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ShowPriceUserOutput
     */
    'listed': boolean;
    /**
     * 
     * @type {string}
     * @memberof ShowPriceUserOutput
     */
    'permalink': string | null;
}
/**
 * 
 * @export
 * @interface ShowPublicObject
 */
export interface ShowPublicObject {
    /**
     * 
     * @type {number}
     * @memberof ShowPublicObject
     * @deprecated
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ShowPublicObject
     * @deprecated
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ShowPublicObject
     * @deprecated
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof ShowPublicObject
     * @deprecated
     */
    'path': string;
    /**
     * 
     * @type {string}
     * @memberof ShowPublicObject
     * @deprecated
     */
    'status': string;
    /**
     * 
     * @type {number}
     * @memberof ShowPublicObject
     * @deprecated
     */
    'price'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShowPublicObject
     * @deprecated
     */
    'type': ShowPublicObjectTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ShowPublicObject
     * @deprecated
     */
    'genre_id': number;
    /**
     * 
     * @type {boolean}
     * @memberof ShowPublicObject
     * @deprecated
     */
    'ageRestriction': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShowPublicObject
     * @deprecated
     */
    'isOnline': boolean;
    /**
     * 
     * @type {string}
     * @memberof ShowPublicObject
     * @deprecated
     */
    'isPrivate': string;
    /**
     * 
     * @type {number}
     * @memberof ShowPublicObject
     * @deprecated
     */
    'flyer': number;
    /**
     * 
     * @type {number}
     * @memberof ShowPublicObject
     * @deprecated
     */
    'location_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShowPublicObject
     * @deprecated
     */
    'donate_provider_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowPublicObject
     * @deprecated
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof ShowPublicObject
     * @deprecated
     */
    'billing_preference'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowPublicObject
     * @deprecated
     */
    'realFlyerPath'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowPublicObject
     * @deprecated
     */
    'eventDate'?: string;
    /**
     * 
     * @type {any}
     * @memberof ShowPublicObject
     * @deprecated
     */
    'googleMapUrl'?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ShowPublicObject
     * @deprecated
     */
    'externalUrl'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShowPublicObject
     * @deprecated
     */
    'availableTickets'?: number;
    /**
     * 
     * @type {number}
     * @memberof ShowPublicObject
     * @deprecated
     */
    'availableTicketsPerShowEvent'?: number;
    /**
     * 
     * @type {Location}
     * @memberof ShowPublicObject
     */
    'location'?: Location;
    /**
     * 
     * @type {Genre}
     * @memberof ShowPublicObject
     * @deprecated
     */
    'genre'?: Genre;
    /**
     * 
     * @type {Array<ShowFlyer>}
     * @memberof ShowPublicObject
     * @deprecated
     */
    'show_flyers'?: Array<ShowFlyer>;
    /**
     * 
     * @type {Array<ShowEvent>}
     * @memberof ShowPublicObject
     * @deprecated
     */
    'show_events'?: Array<ShowEvent>;
    /**
     * 
     * @type {Array<ShowPrice>}
     * @memberof ShowPublicObject
     * @deprecated
     */
    'show_prices'?: Array<ShowPrice>;
    /**
     * 
     * @type {DonateProviderPublicOutput}
     * @memberof ShowPublicObject
     */
    'donateProviderPublicInformation'?: DonateProviderPublicOutput;
}

export const ShowPublicObjectTypeEnum = {
    Paid: 'paid',
    External: 'external'
} as const;

export type ShowPublicObjectTypeEnum = typeof ShowPublicObjectTypeEnum[keyof typeof ShowPublicObjectTypeEnum];

/**
 * 
 * @export
 * @interface ShowPublicOutput
 */
export interface ShowPublicOutput {
    /**
     * 
     * @type {number}
     * @memberof ShowPublicOutput
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ShowPublicOutput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ShowPublicOutput
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof ShowPublicOutput
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof ShowPublicOutput
     */
    'path': string;
    /**
     * 
     * @type {number}
     * @memberof ShowPublicOutput
     * @deprecated
     */
    'minPrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShowPublicOutput
     */
    'type': string;
    /**
     * 
     * @type {boolean}
     * @memberof ShowPublicOutput
     */
    'ageRestriction': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShowPublicOutput
     */
    'isOnline': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShowPublicOutput
     */
    'isPrivate': boolean;
    /**
     * 
     * @type {string}
     * @memberof ShowPublicOutput
     */
    'flyer': string | null;
    /**
     * 
     * @type {string}
     * @memberof ShowPublicOutput
     */
    'realFlyerPath': string;
    /**
     * 
     * @type {string}
     * @memberof ShowPublicOutput
     */
    'eventDate': string;
    /**
     * 
     * @type {Genre}
     * @memberof ShowPublicOutput
     * @deprecated
     */
    'genre': Genre;
    /**
     * 
     * @type {boolean}
     * @memberof ShowPublicOutput
     */
    'soldOut'?: boolean;
    /**
     * $showFlyers
     * @type {Array<ShowFlyer>}
     * @memberof ShowPublicOutput
     */
    'showFlyers': Array<ShowFlyer>;
    /**
     * $showEvents
     * @type {Array<ShowEventPublicOutput>}
     * @memberof ShowPublicOutput
     */
    'showEvents': Array<ShowEventPublicOutput>;
    /**
     * 
     * @type {string}
     * @memberof ShowPublicOutput
     */
    'googleMapUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShowPublicOutput
     */
    'externalUrl'?: string | null;
    /**
     * 
     * @type {ShowPublicOutputLocation}
     * @memberof ShowPublicOutput
     */
    'location'?: ShowPublicOutputLocation | null;
    /**
     * 
     * @type {ShowPublicOutputDonateProvider}
     * @memberof ShowPublicOutput
     */
    'donateProvider'?: ShowPublicOutputDonateProvider | null;
}
/**
 * @type ShowPublicOutputDonateProvider
 * @export
 */
export type ShowPublicOutputDonateProvider = DonateProviderPublicOutput;

/**
 * @type ShowPublicOutputLocation
 * @export
 */
export type ShowPublicOutputLocation = Location;

/**
 * 
 * @export
 * @interface ShowResource
 */
export interface ShowResource {
    /**
     * 
     * @type {number}
     * @memberof ShowResource
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ShowResource
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof ShowResource
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ShowResource
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof ShowResource
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof ShowResource
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof ShowResource
     */
    'path': string;
    /**
     * 
     * @type {boolean}
     * @memberof ShowResource
     */
    'ageRestricted': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShowResource
     */
    'isOnline': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShowResource
     */
    'isPrivate': boolean;
    /**
     * 
     * @type {number}
     * @memberof ShowResource
     */
    'availableTickets': number;
    /**
     * 
     * @type {string}
     * @memberof ShowResource
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ShowResource
     */
    'onlineInformation': string;
    /**
     * 
     * @type {string}
     * @memberof ShowResource
     */
    'externalUrl': string;
    /**
     * 
     * @type {string}
     * @memberof ShowResource
     */
    'billingPreference': string;
    /**
     * 
     * @type {string}
     * @memberof ShowResource
     */
    'flyer'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowResource
     */
    'flyerUrl': string;
    /**
     * 
     * @type {Array<UserPriceResource>}
     * @memberof ShowResource
     */
    'ticketTypes': Array<UserPriceResource>;
    /**
     * 
     * @type {Array<UserEventResource>}
     * @memberof ShowResource
     */
    'events': Array<UserEventResource>;
    /**
     * 
     * @type {GenreResource}
     * @memberof ShowResource
     */
    'genre': GenreResource;
    /**
     * 
     * @type {LocationResource}
     * @memberof ShowResource
     */
    'location': LocationResource;
    /**
     * 
     * @type {Array<FlyerResource>}
     * @memberof ShowResource
     */
    'flyers': Array<FlyerResource>;
}
/**
 * List shows and host user shows to control tickets
 * @export
 * @interface ShowToControlInformation
 */
export interface ShowToControlInformation {
    /**
     * 
     * @type {number}
     * @memberof ShowToControlInformation
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ShowToControlInformation
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ShowToControlInformation
     */
    'flyer': string;
    /**
     * 
     * @type {string}
     * @memberof ShowToControlInformation
     */
    'type': string;
    /**
     * 
     * @type {Array<MinimalShowEvent>}
     * @memberof ShowToControlInformation
     */
    'showEvents': Array<MinimalShowEvent>;
    /**
     * 
     * @type {Array<MinimalShowPrice>}
     * @memberof ShowToControlInformation
     */
    'showPrices'?: Array<MinimalShowPrice>;
}
/**
 * 
 * @export
 * @interface TermAndConditionAdminOutput
 */
export interface TermAndConditionAdminOutput {
    /**
     * 
     * @type {number}
     * @memberof TermAndConditionAdminOutput
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof TermAndConditionAdminOutput
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof TermAndConditionAdminOutput
     */
    'language'?: string;
    /**
     * 
     * @type {string}
     * @memberof TermAndConditionAdminOutput
     */
    'createdAt'?: string;
    /**
     * 
     * @type {UserDataOutput}
     * @memberof TermAndConditionAdminOutput
     */
    'user'?: UserDataOutput;
}
/**
 * 
 * @export
 * @interface TermAndConditionPublicOutput
 */
export interface TermAndConditionPublicOutput {
    /**
     * 
     * @type {number}
     * @memberof TermAndConditionPublicOutput
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof TermAndConditionPublicOutput
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof TermAndConditionPublicOutput
     */
    'language': string;
    /**
     * 
     * @type {string}
     * @memberof TermAndConditionPublicOutput
     */
    'createdAt'?: string;
}
/**
 * 
 * @export
 * @interface Ticket
 */
export interface Ticket {
    /**
     * 
     * @type {boolean}
     * @memberof Ticket
     * @deprecated
     */
    'active': boolean;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     * @deprecated
     */
    'uuid': string;
    /**
     * 
     * @type {number}
     * @memberof Ticket
     * @deprecated
     */
    'reservation_id': number;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     * @deprecated
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof Ticket
     * @deprecated
     */
    'updated_at'?: string;
}
/**
 * 
 * @export
 * @interface TicketOutput
 */
export interface TicketOutput {
    /**
     * 
     * @type {string}
     * @memberof TicketOutput
     */
    'showName': string;
    /**
     * 
     * @type {string}
     * @memberof TicketOutput
     */
    'showFlyer': string;
    /**
     * 
     * @type {boolean}
     * @memberof TicketOutput
     */
    'isOnline': boolean;
    /**
     * 
     * @type {string}
     * @memberof TicketOutput
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof TicketOutput
     */
    'date': string;
    /**
     * 
     * @type {ShowPricePublicOutput}
     * @memberof TicketOutput
     */
    'price'?: ShowPricePublicOutput;
    /**
     * $tickets
     * @type {Array<Ticket>}
     * @memberof TicketOutput
     */
    'tickets': Array<Ticket>;
    /**
     * 
     * @type {Location}
     * @memberof TicketOutput
     */
    'location': Location;
}
/**
 * Tickets breakdown
 * @export
 * @interface TicketTypeBreakdown
 */
export interface TicketTypeBreakdown {
    /**
     * 
     * @type {string}
     * @memberof TicketTypeBreakdown
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TicketTypeBreakdown
     */
    'color': string;
    /**
     * 
     * @type {number}
     * @memberof TicketTypeBreakdown
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof TicketTypeBreakdown
     */
    'capacity': number;
    /**
     * 
     * @type {number}
     * @memberof TicketTypeBreakdown
     */
    'sold': number;
    /**
     * 
     * @type {number}
     * @memberof TicketTypeBreakdown
     */
    'used': number;
    /**
     * 
     * @type {number}
     * @memberof TicketTypeBreakdown
     */
    'refunded': number;
    /**
     * 
     * @type {number}
     * @memberof TicketTypeBreakdown
     */
    'revenue': number;
}
/**
 * 
 * @export
 * @interface TicketTypeResource
 */
export interface TicketTypeResource {
    /**
     * 
     * @type {number}
     * @memberof TicketTypeResource
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof TicketTypeResource
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TicketTypeResource
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TicketTypeResource
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof TicketTypeResource
     */
    'platformFee': number;
    /**
     * 
     * @type {boolean}
     * @memberof TicketTypeResource
     */
    'priceIncludesPlatformFee': boolean;
    /**
     * 
     * @type {string}
     * @memberof TicketTypeResource
     */
    'color': string;
    /**
     * 
     * @type {number}
     * @memberof TicketTypeResource
     */
    'ticketsAvailable': number;
    /**
     * 
     * @type {number}
     * @memberof TicketTypeResource
     */
    'maxTicketsPerReservation': number;
    /**
     * 
     * @type {string}
     * @memberof TicketTypeResource
     */
    'validUntil': string;
}
/**
 * 
 * @export
 * @interface UpdateCustomerPaymentRequest
 */
export interface UpdateCustomerPaymentRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerPaymentRequest
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerPaymentRequest
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCustomerPaymentRequest
     */
    'filename': string;
}
/**
 * 
 * @export
 * @interface UpdateDonationProviderRequest
 */
export interface UpdateDonationProviderRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateDonationProviderRequest
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateDonationProviderRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDonationProviderRequest
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDonationProviderRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDonationProviderRequest
     */
    'website': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDonationProviderRequest
     */
    'logo_url': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDonationProviderRequest
     */
    'phone_number': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDonationProviderRequest
     */
    'bank_information': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDonationProviderRequest
     */
    'contact_name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDonationProviderRequest
     */
    'taxes_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDonationProviderRequest
     */
    'active': boolean;
}
/**
 * 
 * @export
 * @interface UpdateGenreRequest
 */
export interface UpdateGenreRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateGenreRequest
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateGenreRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateGenreRequest
     */
    'description': string;
}
/**
 * 
 * @export
 * @interface UpdateHomeFlyerRequest
 */
export interface UpdateHomeFlyerRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateHomeFlyerRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateHomeFlyerRequest
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateHomeFlyerRequest
     */
    'href'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateHomeFlyerRequest
     */
    'active': boolean;
}
/**
 * 
 * @export
 * @interface UpdatePasswordInformationErrors
 */
export interface UpdatePasswordInformationErrors {
    /**
     * Error message detailing what is wrong
     * @type {string}
     * @memberof UpdatePasswordInformationErrors
     */
    'message'?: string;
    /**
     * 
     * @type {UpdatePasswordInformationErrorsErrors}
     * @memberof UpdatePasswordInformationErrors
     */
    'errors'?: UpdatePasswordInformationErrorsErrors;
}
/**
 * Object containing detailed error messages indexed by field name
 * @export
 * @interface UpdatePasswordInformationErrorsErrors
 */
export interface UpdatePasswordInformationErrorsErrors {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdatePasswordInformationErrorsErrors
     */
    'bank_alias'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdatePasswordInformationErrorsErrors
     */
    'bank_number'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdatePasswordInformationErrorsErrors
     */
    'identification_number'?: Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateRoleRequest
 */
export interface UpdateRoleRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateRoleRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRoleRequest
     */
    'description': string;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateRoleRequest
     */
    'permissionsIds': Array<number>;
}
/**
 * 
 * @export
 * @interface UpdateShowByAdminRequest
 */
export interface UpdateShowByAdminRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateShowByAdminRequest
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateShowByAdminRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateShowByAdminRequest
     */
    'flyer': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateShowByAdminRequest
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateShowByAdminRequest
     */
    'genre_id': number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateShowByAdminRequest
     */
    'ageRestriction': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateShowByAdminRequest
     */
    'isPrivate': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateShowByAdminRequest
     */
    'isOnline'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateShowByAdminRequest
     */
    'onlineInformation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateShowByAdminRequest
     */
    'pixelId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateShowByAdminRequest
     */
    'code'?: string | null;
    /**
     * 
     * @type {Array<ShowFlyerInput>}
     * @memberof UpdateShowByAdminRequest
     */
    'showFlyers'?: Array<ShowFlyerInput>;
    /**
     * 
     * @type {string}
     * @memberof UpdateShowByAdminRequest
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface UpdateShowRequest
 */
export interface UpdateShowRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateShowRequest
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateShowRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateShowRequest
     */
    'flyer'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateShowRequest
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateShowRequest
     */
    'genre_id': number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateShowRequest
     */
    'ageRestriction': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateShowRequest
     */
    'isPrivate': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateShowRequest
     */
    'isOnline'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateShowRequest
     */
    'onlineInformation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateShowRequest
     */
    'pixelId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateShowRequest
     */
    'code'?: string | null;
    /**
     * 
     * @type {Array<ShowFlyerInput>}
     * @memberof UpdateShowRequest
     */
    'showFlyers'?: Array<ShowFlyerInput>;
}
/**
 * 
 * @export
 * @interface UpdateUserDataErrors
 */
export interface UpdateUserDataErrors {
    /**
     * Error message detailing what is wrong
     * @type {string}
     * @memberof UpdateUserDataErrors
     */
    'message'?: string;
    /**
     * 
     * @type {UpdateUserDataErrorsErrors}
     * @memberof UpdateUserDataErrors
     */
    'errors'?: UpdateUserDataErrorsErrors;
}
/**
 * Object containing detailed error messages indexed by field name
 * @export
 * @interface UpdateUserDataErrorsErrors
 */
export interface UpdateUserDataErrorsErrors {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateUserDataErrorsErrors
     */
    'surname'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateUserDataErrorsErrors
     */
    'name'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateUserDataErrorsErrors
     */
    'email'?: Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateUserInformationRequest
 */
export interface UpdateUserInformationRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserInformationRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserInformationRequest
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserInformationRequest
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface UpdateUserPasswordErrors
 */
export interface UpdateUserPasswordErrors {
    /**
     * Error message detailing what is wrong
     * @type {string}
     * @memberof UpdateUserPasswordErrors
     */
    'message'?: string;
    /**
     * 
     * @type {UpdateUserPasswordErrorsErrors}
     * @memberof UpdateUserPasswordErrors
     */
    'errors'?: UpdateUserPasswordErrorsErrors;
}
/**
 * Object containing detailed error messages indexed by field name
 * @export
 * @interface UpdateUserPasswordErrorsErrors
 */
export interface UpdateUserPasswordErrorsErrors {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateUserPasswordErrorsErrors
     */
    'password'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateUserPasswordErrorsErrors
     */
    'password_actual'?: Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateUserPasswordRequest
 */
export interface UpdateUserPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserPasswordRequest
     */
    'password_actual': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserPasswordRequest
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserPasswordRequest
     */
    'password_confirmation': string;
}
/**
 * 
 * @export
 * @interface UpdateUserPaymentInformationRequest
 */
export interface UpdateUserPaymentInformationRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserPaymentInformationRequest
     */
    'bank_number': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserPaymentInformationRequest
     */
    'bank_alias': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserPaymentInformationRequest
     */
    'identification_number': string;
}
/**
 * 
 * @export
 * @interface UpdateUserRequest
 */
export interface UpdateUserRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    'email': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserRequest
     */
    'active': boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateUserRequest
     */
    'rolesIds'?: Array<number>;
}
/**
 * 
 * @export
 * @interface UpdateVisitorRequest
 */
export interface UpdateVisitorRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateVisitorRequest
     */
    'active': boolean;
}
/**
 * 
 * @export
 * @interface UploadedFileOutput
 */
export interface UploadedFileOutput {
    /**
     * 
     * @type {string}
     * @memberof UploadedFileOutput
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof UploadedFileOutput
     */
    'filename': string;
}
/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {number}
     * @memberof User
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'surname'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'email'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'change_password'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'avatar'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'two_factor'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'is_online'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'locale'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'timezone'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'has_google_user'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'has_mp_user'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {Array<Role>}
     * @memberof User
     */
    'roles'?: Array<Role>;
}
/**
 * 
 * @export
 * @interface UserCouponReferenceResource
 */
export interface UserCouponReferenceResource {
    /**
     * 
     * @type {number}
     * @memberof UserCouponReferenceResource
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UserCouponReferenceResource
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface UserCouponResource
 */
export interface UserCouponResource {
    /**
     * 
     * @type {number}
     * @memberof UserCouponResource
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UserCouponResource
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UserCouponResource
     */
    'code': string;
    /**
     * 
     * @type {number}
     * @memberof UserCouponResource
     */
    'discount': number;
    /**
     * 
     * @type {boolean}
     * @memberof UserCouponResource
     */
    'active': boolean;
    /**
     * 
     * @type {UserUserMinimalResource}
     * @memberof UserCouponResource
     */
    'user': UserUserMinimalResource;
    /**
     * 
     * @type {UserShowReferenceResource}
     * @memberof UserCouponResource
     */
    'show': UserShowReferenceResource;
}
/**
 * 
 * @export
 * @interface UserCreateShowEvent422Response
 */
export interface UserCreateShowEvent422Response {
    /**
     * Error message detailing what is wrong
     * @type {string}
     * @memberof UserCreateShowEvent422Response
     */
    'message'?: string;
    /**
     * 
     * @type {UserCreateShowEvent422ResponseErrors}
     * @memberof UserCreateShowEvent422Response
     */
    'errors'?: UserCreateShowEvent422ResponseErrors;
}
/**
 * Object containing detailed error messages indexed by field name
 * @export
 * @interface UserCreateShowEvent422ResponseErrors
 */
export interface UserCreateShowEvent422ResponseErrors {
    /**
     * 
     * @type {Array<string>}
     * @memberof UserCreateShowEvent422ResponseErrors
     */
    'startsAt'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserCreateShowEvent422ResponseErrors
     */
    'endsAt'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserCreateShowEvent422ResponseErrors
     */
    'listed'?: Array<string>;
}
/**
 * 
 * @export
 * @interface UserCreateShowEventRequest
 */
export interface UserCreateShowEventRequest {
    /**
     * 
     * @type {string}
     * @memberof UserCreateShowEventRequest
     */
    'startsAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreateShowEventRequest
     */
    'endsAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserCreateShowEventRequest
     */
    'listed'?: boolean;
}
/**
 * 
 * @export
 * @interface UserDataOutput
 */
export interface UserDataOutput {
    /**
     * 
     * @type {string}
     * @memberof UserDataOutput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UserDataOutput
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof UserDataOutput
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface UserEventReferenceResource
 */
export interface UserEventReferenceResource {
    /**
     * 
     * @type {number}
     * @memberof UserEventReferenceResource
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UserEventReferenceResource
     */
    'startsAt': string;
}
/**
 * User Event Report
 * @export
 * @interface UserEventReport
 */
export interface UserEventReport {
    /**
     * 
     * @type {string}
     * @memberof UserEventReport
     */
    'lastSold'?: string;
    /**
     * 
     * @type {number}
     * @memberof UserEventReport
     */
    'totalCapacity': number;
    /**
     * 
     * @type {number}
     * @memberof UserEventReport
     */
    'totalSold': number;
    /**
     * 
     * @type {number}
     * @memberof UserEventReport
     */
    'totalUsed': number;
    /**
     * 
     * @type {number}
     * @memberof UserEventReport
     */
    'totalRefunded': number;
    /**
     * 
     * @type {number}
     * @memberof UserEventReport
     */
    'totalRevenue': number;
    /**
     * 
     * @type {Array<TicketTypeBreakdown>}
     * @memberof UserEventReport
     */
    'ticketTypes': Array<TicketTypeBreakdown>;
}
/**
 * 
 * @export
 * @interface UserEventResource
 */
export interface UserEventResource {
    /**
     * 
     * @type {number}
     * @memberof UserEventResource
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UserEventResource
     */
    'startsAt': string;
    /**
     * 
     * @type {string}
     * @memberof UserEventResource
     */
    'endsAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserEventResource
     */
    'listed': boolean;
    /**
     * 
     * @type {string}
     * @memberof UserEventResource
     */
    'controlCode': string;
    /**
     * 
     * @type {number}
     * @memberof UserEventResource
     */
    'ticketsSold': number;
    /**
     * 
     * @type {number}
     * @memberof UserEventResource
     */
    'totalTickets': number;
}
/**
 * 
 * @export
 * @interface UserEventStandaloneResource
 */
export interface UserEventStandaloneResource {
    /**
     * 
     * @type {number}
     * @memberof UserEventStandaloneResource
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UserEventStandaloneResource
     */
    'startsAt': string;
    /**
     * 
     * @type {string}
     * @memberof UserEventStandaloneResource
     */
    'endsAt': string;
    /**
     * 
     * @type {UserShowReferenceResource}
     * @memberof UserEventStandaloneResource
     */
    'show'?: UserShowReferenceResource;
    /**
     * 
     * @type {Array<UserPriceReferenceResource>}
     * @memberof UserEventStandaloneResource
     */
    'prices'?: Array<UserPriceReferenceResource>;
}
/**
 * 
 * @export
 * @interface UserLinkedAccountsOutput
 */
export interface UserLinkedAccountsOutput {
    /**
     * 
     * @type {boolean}
     * @memberof UserLinkedAccountsOutput
     */
    'mercadoPago': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserLinkedAccountsOutput
     */
    'gmail': boolean;
}
/**
 * 
 * @export
 * @interface UserListCoupons200Response
 */
export interface UserListCoupons200Response {
    /**
     * 
     * @type {PaginatedResourceLinks}
     * @memberof UserListCoupons200Response
     */
    'links': PaginatedResourceLinks;
    /**
     * 
     * @type {PaginatedResourceMeta}
     * @memberof UserListCoupons200Response
     */
    'meta': PaginatedResourceMeta;
    /**
     * 
     * @type {Array<UserCouponResource>}
     * @memberof UserListCoupons200Response
     */
    'data': Array<UserCouponResource>;
}
/**
 * 
 * @export
 * @interface UserListEvents200Response
 */
export interface UserListEvents200Response {
    /**
     * 
     * @type {PaginatedResourceLinks}
     * @memberof UserListEvents200Response
     */
    'links': PaginatedResourceLinks;
    /**
     * 
     * @type {PaginatedResourceMeta}
     * @memberof UserListEvents200Response
     */
    'meta': PaginatedResourceMeta;
    /**
     * 
     * @type {Array<UserEventStandaloneResource>}
     * @memberof UserListEvents200Response
     */
    'data': Array<UserEventStandaloneResource>;
}
/**
 * 
 * @export
 * @interface UserListReservations200Response
 */
export interface UserListReservations200Response {
    /**
     * 
     * @type {PaginatedResourceLinks}
     * @memberof UserListReservations200Response
     */
    'links': PaginatedResourceLinks;
    /**
     * 
     * @type {PaginatedResourceMeta}
     * @memberof UserListReservations200Response
     */
    'meta': PaginatedResourceMeta;
    /**
     * 
     * @type {Array<UserReservationResource>}
     * @memberof UserListReservations200Response
     */
    'data': Array<UserReservationResource>;
}
/**
 * 
 * @export
 * @interface UserListTickets200Response
 */
export interface UserListTickets200Response {
    /**
     * 
     * @type {Array<UserTicketResource>}
     * @memberof UserListTickets200Response
     */
    'data'?: Array<UserTicketResource>;
}
/**
 * 
 * @export
 * @interface UserPriceReferenceResource
 */
export interface UserPriceReferenceResource {
    /**
     * 
     * @type {number}
     * @memberof UserPriceReferenceResource
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UserPriceReferenceResource
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UserPriceReferenceResource
     */
    'color': string;
}
/**
 * 
 * @export
 * @interface UserPriceResource
 */
export interface UserPriceResource {
    /**
     * 
     * @type {number}
     * @memberof UserPriceResource
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UserPriceResource
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UserPriceResource
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof UserPriceResource
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof UserPriceResource
     */
    'platformFee': number;
    /**
     * 
     * @type {boolean}
     * @memberof UserPriceResource
     */
    'priceIncludesPlatformFee': boolean;
    /**
     * 
     * @type {string}
     * @memberof UserPriceResource
     */
    'color': string | null;
    /**
     * 
     * @type {number}
     * @memberof UserPriceResource
     */
    'availableTickets'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserPriceResource
     */
    'ticketsAvailable': number;
    /**
     * 
     * @type {number}
     * @memberof UserPriceResource
     */
    'maxTicketsPerReservation': number;
    /**
     * 
     * @type {string}
     * @memberof UserPriceResource
     */
    'reservableUntil': string | null;
    /**
     * 
     * @type {string}
     * @memberof UserPriceResource
     */
    'validUntil': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserPriceResource
     */
    'listed': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserPriceResource
     */
    'allowContribution': boolean;
    /**
     * 
     * @type {number}
     * @memberof UserPriceResource
     */
    'ticketsSold': number;
    /**
     * 
     * @type {string}
     * @memberof UserPriceResource
     */
    'permalink'?: string | null;
}
/**
 * 
 * @export
 * @interface UserReservationResource
 */
export interface UserReservationResource {
    /**
     * 
     * @type {number}
     * @memberof UserReservationResource
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UserReservationResource
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof UserReservationResource
     */
    'status': string;
    /**
     * 
     * @type {number}
     * @memberof UserReservationResource
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof UserReservationResource
     */
    'quantity': number;
    /**
     * 
     * @type {string}
     * @memberof UserReservationResource
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof UserReservationResource
     */
    'updatedAt': string;
    /**
     * 
     * @type {UserShowReferenceResource}
     * @memberof UserReservationResource
     */
    'show': UserShowReferenceResource;
    /**
     * 
     * @type {UserEventReferenceResource}
     * @memberof UserReservationResource
     */
    'event': UserEventReferenceResource;
    /**
     * 
     * @type {UserPriceReferenceResource}
     * @memberof UserReservationResource
     */
    'price': UserPriceReferenceResource;
    /**
     * 
     * @type {UserUserMinimalResource}
     * @memberof UserReservationResource
     */
    'user': UserUserMinimalResource;
}
/**
 * 
 * @export
 * @interface UserShowReferenceResource
 */
export interface UserShowReferenceResource {
    /**
     * 
     * @type {number}
     * @memberof UserShowReferenceResource
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UserShowReferenceResource
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UserShowReferenceResource
     */
    'flyerUrl': string;
}
/**
 * 
 * @export
 * @interface UserShowResource
 */
export interface UserShowResource {
    /**
     * 
     * @type {number}
     * @memberof UserShowResource
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UserShowResource
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof UserShowResource
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UserShowResource
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof UserShowResource
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof UserShowResource
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof UserShowResource
     */
    'path': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserShowResource
     */
    'ageRestricted': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserShowResource
     */
    'isOnline': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserShowResource
     */
    'isPrivate': boolean;
    /**
     * 
     * @type {number}
     * @memberof UserShowResource
     */
    'serviceCharge': number;
    /**
     * 
     * @type {number}
     * @memberof UserShowResource
     */
    'availableTickets': number;
    /**
     * 
     * @type {string}
     * @memberof UserShowResource
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof UserShowResource
     */
    'onlineInformation': string;
    /**
     * 
     * @type {string}
     * @memberof UserShowResource
     */
    'externalUrl': string;
    /**
     * 
     * @type {string}
     * @memberof UserShowResource
     */
    'billingPreference': string;
    /**
     * 
     * @type {string}
     * @memberof UserShowResource
     */
    'flyer'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserShowResource
     */
    'flyerUrl': string;
    /**
     * 
     * @type {string}
     * @memberof UserShowResource
     */
    'pixelId'?: string;
    /**
     * 
     * @type {Array<UserPriceResource>}
     * @memberof UserShowResource
     */
    'ticketTypes': Array<UserPriceResource>;
    /**
     * 
     * @type {Array<UserEventResource>}
     * @memberof UserShowResource
     */
    'events': Array<UserEventResource>;
    /**
     * 
     * @type {GenreResource}
     * @memberof UserShowResource
     */
    'genre': GenreResource;
    /**
     * 
     * @type {LocationResource}
     * @memberof UserShowResource
     */
    'location': LocationResource;
    /**
     * 
     * @type {Array<FlyerResource>}
     * @memberof UserShowResource
     */
    'flyers': Array<FlyerResource>;
    /**
     * 
     * @type {UserUserMinimalResource}
     * @memberof UserShowResource
     */
    'user'?: UserUserMinimalResource;
    /**
     * 
     * @type {number}
     * @memberof UserShowResource
     */
    'donateProviderId'?: number | null;
}
/**
 * 
 * @export
 * @interface UserTicketResource
 */
export interface UserTicketResource {
    /**
     * 
     * @type {number}
     * @memberof UserTicketResource
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UserTicketResource
     */
    'usedAt': string | null;
    /**
     * 
     * @type {UserUserMinimalResource}
     * @memberof UserTicketResource
     */
    'markedAsUsedBy': UserUserMinimalResource;
    /**
     * 
     * @type {string}
     * @memberof UserTicketResource
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof UserTicketResource
     */
    'updatedAt'?: string;
}
/**
 * 
 * @export
 * @interface UserUserMinimalResource
 */
export interface UserUserMinimalResource {
    /**
     * 
     * @type {number}
     * @memberof UserUserMinimalResource
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UserUserMinimalResource
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UserUserMinimalResource
     */
    'surname': string;
    /**
     * 
     * @type {string}
     * @memberof UserUserMinimalResource
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface VisitorOutput
 */
export interface VisitorOutput {
    /**
     * 
     * @type {number}
     * @memberof VisitorOutput
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof VisitorOutput
     */
    'ip': string;
    /**
     * 
     * @type {boolean}
     * @memberof VisitorOutput
     */
    'active': boolean;
    /**
     * 
     * @type {string}
     * @memberof VisitorOutput
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof VisitorOutput
     */
    'updated_at': string;
}

/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new session
         * @param {ApiLoginRequest} apiLoginRequest User\&#39;s credentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewSession: async (apiLoginRequest: ApiLoginRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiLoginRequest' is not null or undefined
            assertParamExists('createNewSession', 'apiLoginRequest', apiLoginRequest)
            const localVarPath = `/api/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiLoginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new token
         * @param {ApiTokenLoginRequest} apiTokenLoginRequest User\&#39;s credentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewSessionToken: async (apiTokenLoginRequest: ApiTokenLoginRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiTokenLoginRequest' is not null or undefined
            assertParamExists('createNewSessionToken', 'apiTokenLoginRequest', apiTokenLoginRequest)
            const localVarPath = `/api/auth/login/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTokenLoginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new token
         * @param {ApiTokenLoginByOtpRequest} apiTokenLoginByOtpRequest User\&#39;s credentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewTokenUsingOtp: async (apiTokenLoginByOtpRequest: ApiTokenLoginByOtpRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiTokenLoginByOtpRequest' is not null or undefined
            assertParamExists('createNewTokenUsingOtp', 'apiTokenLoginByOtpRequest', apiTokenLoginByOtpRequest)
            const localVarPath = `/api/auth/token/otp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiTokenLoginByOtpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Destroy token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroySessionToken: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth/logout/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set CSRF cookie
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCSRFToken: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sanctum/csrf-cookie`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Close Session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Register new User
         * @summary Register new User
         * @param {RegisterUserRequest} registerUserRequest User Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerNewUser: async (registerUserRequest: RegisterUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerUserRequest' is not null or undefined
            assertParamExists('registerNewUser', 'registerUserRequest', registerUserRequest)
            const localVarPath = `/api/auth/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reset password
         * @summary Reset Password
         * @param {ResetPasswordRequest} resetPasswordRequest User Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: async (resetPasswordRequest: ResetPasswordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetPasswordRequest' is not null or undefined
            assertParamExists('resetPassword', 'resetPasswordRequest', resetPasswordRequest)
            const localVarPath = `/api/auth/resetPassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send OTP
         * @summary Send OTP
         * @param {SendOtpRequest} sendOtpRequest User Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendOtp: async (sendOtpRequest: SendOtpRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendOtpRequest' is not null or undefined
            assertParamExists('sendOtp', 'sendOtpRequest', sendOtpRequest)
            const localVarPath = `/api/auth/otp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendOtpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send Reset Link
         * @summary Send Reset Link
         * @param {SendResetLinkRequest} sendResetLinkRequest User Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendResetLink: async (sendResetLinkRequest: SendResetLinkRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendResetLinkRequest' is not null or undefined
            assertParamExists('sendResetLink', 'sendResetLinkRequest', sendResetLinkRequest)
            const localVarPath = `/api/auth/sendResetLink`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendResetLinkRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new session
         * @param {ApiLoginRequest} apiLoginRequest User\&#39;s credentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNewSession(apiLoginRequest: ApiLoginRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNewSession(apiLoginRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.createNewSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new token
         * @param {ApiTokenLoginRequest} apiTokenLoginRequest User\&#39;s credentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNewSessionToken(apiTokenLoginRequest: ApiTokenLoginRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTokenOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNewSessionToken(apiTokenLoginRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.createNewSessionToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new token
         * @param {ApiTokenLoginByOtpRequest} apiTokenLoginByOtpRequest User\&#39;s credentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNewTokenUsingOtp(apiTokenLoginByOtpRequest: ApiTokenLoginByOtpRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTokenOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNewTokenUsingOtp(apiTokenLoginByOtpRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.createNewTokenUsingOtp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Destroy token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async destroySessionToken(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.destroySessionToken(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.destroySessionToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set CSRF cookie
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCSRFToken(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCSRFToken(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.getCSRFToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Close Session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.logout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Register new User
         * @summary Register new User
         * @param {RegisterUserRequest} registerUserRequest User Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerNewUser(registerUserRequest: RegisterUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerNewUser(registerUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.registerNewUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reset password
         * @summary Reset Password
         * @param {ResetPasswordRequest} resetPasswordRequest User Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPassword(resetPasswordRequest: ResetPasswordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPassword(resetPasswordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.resetPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send OTP
         * @summary Send OTP
         * @param {SendOtpRequest} sendOtpRequest User Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendOtp(sendOtpRequest: SendOtpRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendOtp(sendOtpRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.sendOtp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Send Reset Link
         * @summary Send Reset Link
         * @param {SendResetLinkRequest} sendResetLinkRequest User Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendResetLink(sendResetLinkRequest: SendResetLinkRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendResetLink(sendResetLinkRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.sendResetLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * Create a new session
         * @param {ApiLoginRequest} apiLoginRequest User\&#39;s credentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewSession(apiLoginRequest: ApiLoginRequest, options?: any): AxiosPromise<any> {
            return localVarFp.createNewSession(apiLoginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new token
         * @param {ApiTokenLoginRequest} apiTokenLoginRequest User\&#39;s credentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewSessionToken(apiTokenLoginRequest: ApiTokenLoginRequest, options?: any): AxiosPromise<ApiTokenOutput> {
            return localVarFp.createNewSessionToken(apiTokenLoginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new token
         * @param {ApiTokenLoginByOtpRequest} apiTokenLoginByOtpRequest User\&#39;s credentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewTokenUsingOtp(apiTokenLoginByOtpRequest: ApiTokenLoginByOtpRequest, options?: any): AxiosPromise<ApiTokenOutput> {
            return localVarFp.createNewTokenUsingOtp(apiTokenLoginByOtpRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Destroy token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        destroySessionToken(options?: any): AxiosPromise<any> {
            return localVarFp.destroySessionToken(options).then((request) => request(axios, basePath));
        },
        /**
         * Set CSRF cookie
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCSRFToken(options?: any): AxiosPromise<any> {
            return localVarFp.getCSRFToken(options).then((request) => request(axios, basePath));
        },
        /**
         * Close Session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options?: any): AxiosPromise<any> {
            return localVarFp.logout(options).then((request) => request(axios, basePath));
        },
        /**
         * Register new User
         * @summary Register new User
         * @param {RegisterUserRequest} registerUserRequest User Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerNewUser(registerUserRequest: RegisterUserRequest, options?: any): AxiosPromise<any> {
            return localVarFp.registerNewUser(registerUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Reset password
         * @summary Reset Password
         * @param {ResetPasswordRequest} resetPasswordRequest User Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(resetPasswordRequest: ResetPasswordRequest, options?: any): AxiosPromise<any> {
            return localVarFp.resetPassword(resetPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Send OTP
         * @summary Send OTP
         * @param {SendOtpRequest} sendOtpRequest User Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendOtp(sendOtpRequest: SendOtpRequest, options?: any): AxiosPromise<any> {
            return localVarFp.sendOtp(sendOtpRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Send Reset Link
         * @summary Send Reset Link
         * @param {SendResetLinkRequest} sendResetLinkRequest User Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendResetLink(sendResetLinkRequest: SendResetLinkRequest, options?: any): AxiosPromise<any> {
            return localVarFp.sendResetLink(sendResetLinkRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     * Create a new session
     * @param {ApiLoginRequest} apiLoginRequest User\&#39;s credentials
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public createNewSession(apiLoginRequest: ApiLoginRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).createNewSession(apiLoginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new token
     * @param {ApiTokenLoginRequest} apiTokenLoginRequest User\&#39;s credentials
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public createNewSessionToken(apiTokenLoginRequest: ApiTokenLoginRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).createNewSessionToken(apiTokenLoginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new token
     * @param {ApiTokenLoginByOtpRequest} apiTokenLoginByOtpRequest User\&#39;s credentials
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public createNewTokenUsingOtp(apiTokenLoginByOtpRequest: ApiTokenLoginByOtpRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).createNewTokenUsingOtp(apiTokenLoginByOtpRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Destroy token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public destroySessionToken(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).destroySessionToken(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set CSRF cookie
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public getCSRFToken(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).getCSRFToken(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Close Session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public logout(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).logout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Register new User
     * @summary Register new User
     * @param {RegisterUserRequest} registerUserRequest User Data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public registerNewUser(registerUserRequest: RegisterUserRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).registerNewUser(registerUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reset password
     * @summary Reset Password
     * @param {ResetPasswordRequest} resetPasswordRequest User Data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public resetPassword(resetPasswordRequest: ResetPasswordRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).resetPassword(resetPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send OTP
     * @summary Send OTP
     * @param {SendOtpRequest} sendOtpRequest User Data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public sendOtp(sendOtpRequest: SendOtpRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).sendOtp(sendOtpRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send Reset Link
     * @summary Send Reset Link
     * @param {SendResetLinkRequest} sendResetLinkRequest User Data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public sendResetLink(sendResetLinkRequest: SendResetLinkRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).sendResetLink(sendResetLinkRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CouponsApi - axios parameter creator
 * @export
 */
export const CouponsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Check Coupon
         * @summary Check Coupon
         * @param {CheckCouponRequest} checkCouponRequest Check Coupon Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkCoupon: async (checkCouponRequest: CheckCouponRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checkCouponRequest' is not null or undefined
            assertParamExists('checkCoupon', 'checkCouponRequest', checkCouponRequest)
            const localVarPath = `/api/coupons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkCouponRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create Coupon
         * @summary Create Coupon
         * @param {number} showId Show id
         * @param {CreateCouponRequest} createCouponRequest Create Coupon Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCoupon: async (showId: number, createCouponRequest: CreateCouponRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'showId' is not null or undefined
            assertParamExists('createCoupon', 'showId', showId)
            // verify required parameter 'createCouponRequest' is not null or undefined
            assertParamExists('createCoupon', 'createCouponRequest', createCouponRequest)
            const localVarPath = `/api/user/shows/{showId}/coupons`
                .replace(`{${"showId"}}`, encodeURIComponent(String(showId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCouponRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Patch Coupon
         * @summary Patch Coupon
         * @param {number} couponId Id
         * @param {PatchCouponRequest} patchCouponRequest Patch Coupon Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCoupon: async (couponId: number, patchCouponRequest: PatchCouponRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'couponId' is not null or undefined
            assertParamExists('patchCoupon', 'couponId', couponId)
            // verify required parameter 'patchCouponRequest' is not null or undefined
            assertParamExists('patchCoupon', 'patchCouponRequest', patchCouponRequest)
            const localVarPath = `/api/user/coupons/{couponId}`
                .replace(`{${"couponId"}}`, encodeURIComponent(String(couponId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchCouponRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List coupons
         * @param {number} [itemsPerPage] Items per Page
         * @param {number} [page] Page
         * @param {string} [name] Filter by name
         * @param {string} [code] Filter by code
         * @param {boolean} [active] Filter by active
         * @param {number} [showId] Filter by show id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userListCoupons: async (itemsPerPage?: number, page?: number, name?: string, code?: string, active?: boolean, showId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/coupons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            if (showId !== undefined) {
                localVarQueryParameter['showId'] = showId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CouponsApi - functional programming interface
 * @export
 */
export const CouponsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CouponsApiAxiosParamCreator(configuration)
    return {
        /**
         * Check Coupon
         * @summary Check Coupon
         * @param {CheckCouponRequest} checkCouponRequest Check Coupon Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkCoupon(checkCouponRequest: CheckCouponRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CouponResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkCoupon(checkCouponRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsApi.checkCoupon']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create Coupon
         * @summary Create Coupon
         * @param {number} showId Show id
         * @param {CreateCouponRequest} createCouponRequest Create Coupon Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCoupon(showId: number, createCouponRequest: CreateCouponRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserCouponResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCoupon(showId, createCouponRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsApi.createCoupon']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Patch Coupon
         * @summary Patch Coupon
         * @param {number} couponId Id
         * @param {PatchCouponRequest} patchCouponRequest Patch Coupon Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchCoupon(couponId: number, patchCouponRequest: PatchCouponRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserCouponResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchCoupon(couponId, patchCouponRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsApi.patchCoupon']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List coupons
         * @param {number} [itemsPerPage] Items per Page
         * @param {number} [page] Page
         * @param {string} [name] Filter by name
         * @param {string} [code] Filter by code
         * @param {boolean} [active] Filter by active
         * @param {number} [showId] Filter by show id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userListCoupons(itemsPerPage?: number, page?: number, name?: string, code?: string, active?: boolean, showId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserListCoupons200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userListCoupons(itemsPerPage, page, name, code, active, showId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouponsApi.userListCoupons']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CouponsApi - factory interface
 * @export
 */
export const CouponsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CouponsApiFp(configuration)
    return {
        /**
         * Check Coupon
         * @summary Check Coupon
         * @param {CheckCouponRequest} checkCouponRequest Check Coupon Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkCoupon(checkCouponRequest: CheckCouponRequest, options?: any): AxiosPromise<CouponResource> {
            return localVarFp.checkCoupon(checkCouponRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create Coupon
         * @summary Create Coupon
         * @param {number} showId Show id
         * @param {CreateCouponRequest} createCouponRequest Create Coupon Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCoupon(showId: number, createCouponRequest: CreateCouponRequest, options?: any): AxiosPromise<UserCouponResource> {
            return localVarFp.createCoupon(showId, createCouponRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Patch Coupon
         * @summary Patch Coupon
         * @param {number} couponId Id
         * @param {PatchCouponRequest} patchCouponRequest Patch Coupon Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCoupon(couponId: number, patchCouponRequest: PatchCouponRequest, options?: any): AxiosPromise<UserCouponResource> {
            return localVarFp.patchCoupon(couponId, patchCouponRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List coupons
         * @param {number} [itemsPerPage] Items per Page
         * @param {number} [page] Page
         * @param {string} [name] Filter by name
         * @param {string} [code] Filter by code
         * @param {boolean} [active] Filter by active
         * @param {number} [showId] Filter by show id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userListCoupons(itemsPerPage?: number, page?: number, name?: string, code?: string, active?: boolean, showId?: number, options?: any): AxiosPromise<UserListCoupons200Response> {
            return localVarFp.userListCoupons(itemsPerPage, page, name, code, active, showId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CouponsApi - object-oriented interface
 * @export
 * @class CouponsApi
 * @extends {BaseAPI}
 */
export class CouponsApi extends BaseAPI {
    /**
     * Check Coupon
     * @summary Check Coupon
     * @param {CheckCouponRequest} checkCouponRequest Check Coupon Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    public checkCoupon(checkCouponRequest: CheckCouponRequest, options?: RawAxiosRequestConfig) {
        return CouponsApiFp(this.configuration).checkCoupon(checkCouponRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create Coupon
     * @summary Create Coupon
     * @param {number} showId Show id
     * @param {CreateCouponRequest} createCouponRequest Create Coupon Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    public createCoupon(showId: number, createCouponRequest: CreateCouponRequest, options?: RawAxiosRequestConfig) {
        return CouponsApiFp(this.configuration).createCoupon(showId, createCouponRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Patch Coupon
     * @summary Patch Coupon
     * @param {number} couponId Id
     * @param {PatchCouponRequest} patchCouponRequest Patch Coupon Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    public patchCoupon(couponId: number, patchCouponRequest: PatchCouponRequest, options?: RawAxiosRequestConfig) {
        return CouponsApiFp(this.configuration).patchCoupon(couponId, patchCouponRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List coupons
     * @param {number} [itemsPerPage] Items per Page
     * @param {number} [page] Page
     * @param {string} [name] Filter by name
     * @param {string} [code] Filter by code
     * @param {boolean} [active] Filter by active
     * @param {number} [showId] Filter by show id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    public userListCoupons(itemsPerPage?: number, page?: number, name?: string, code?: string, active?: boolean, showId?: number, options?: RawAxiosRequestConfig) {
        return CouponsApiFp(this.configuration).userListCoupons(itemsPerPage, page, name, code, active, showId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DonateProvidersApi - axios parameter creator
 * @export
 */
export const DonateProvidersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDonationProviders: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/donateProviders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DonateProvidersApi - functional programming interface
 * @export
 */
export const DonateProvidersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DonateProvidersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDonationProviders(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DonateProviderPublicOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDonationProviders(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DonateProvidersApi.listDonationProviders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DonateProvidersApi - factory interface
 * @export
 */
export const DonateProvidersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DonateProvidersApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDonationProviders(options?: any): AxiosPromise<Array<DonateProviderPublicOutput>> {
            return localVarFp.listDonationProviders(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DonateProvidersApi - object-oriented interface
 * @export
 * @class DonateProvidersApi
 * @extends {BaseAPI}
 */
export class DonateProvidersApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DonateProvidersApi
     */
    public listDonationProviders(options?: RawAxiosRequestConfig) {
        return DonateProvidersApiFp(this.configuration).listDonationProviders(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EventsApi - axios parameter creator
 * @export
 */
export const EventsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [itemsPerPage] Items per Page
         * @param {number} [page] Page
         * @param {string} [startsAtGte] 
         * @param {string} [startsAtLte] 
         * @param {string} [endsAtGte] 
         * @param {string} [endsAtLte] 
         * @param {string} [showName] 
         * @param {Array<string>} [showStatuses] 
         * @param {UserListEventsShowTypeEnum} [showType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userListEvents: async (itemsPerPage?: number, page?: number, startsAtGte?: string, startsAtLte?: string, endsAtGte?: string, endsAtLte?: string, showName?: string, showStatuses?: Array<string>, showType?: UserListEventsShowTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (startsAtGte !== undefined) {
                localVarQueryParameter['startsAtGte'] = startsAtGte;
            }

            if (startsAtLte !== undefined) {
                localVarQueryParameter['startsAtLte'] = startsAtLte;
            }

            if (endsAtGte !== undefined) {
                localVarQueryParameter['endsAtGte'] = endsAtGte;
            }

            if (endsAtLte !== undefined) {
                localVarQueryParameter['endsAtLte'] = endsAtLte;
            }

            if (showName !== undefined) {
                localVarQueryParameter['showName'] = showName;
            }

            if (showStatuses) {
                localVarQueryParameter['showStatuses[]'] = showStatuses;
            }

            if (showType !== undefined) {
                localVarQueryParameter['showType'] = showType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventsApi - functional programming interface
 * @export
 */
export const EventsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EventsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [itemsPerPage] Items per Page
         * @param {number} [page] Page
         * @param {string} [startsAtGte] 
         * @param {string} [startsAtLte] 
         * @param {string} [endsAtGte] 
         * @param {string} [endsAtLte] 
         * @param {string} [showName] 
         * @param {Array<string>} [showStatuses] 
         * @param {UserListEventsShowTypeEnum} [showType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userListEvents(itemsPerPage?: number, page?: number, startsAtGte?: string, startsAtLte?: string, endsAtGte?: string, endsAtLte?: string, showName?: string, showStatuses?: Array<string>, showType?: UserListEventsShowTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserListEvents200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userListEvents(itemsPerPage, page, startsAtGte, startsAtLte, endsAtGte, endsAtLte, showName, showStatuses, showType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.userListEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EventsApi - factory interface
 * @export
 */
export const EventsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EventsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [itemsPerPage] Items per Page
         * @param {number} [page] Page
         * @param {string} [startsAtGte] 
         * @param {string} [startsAtLte] 
         * @param {string} [endsAtGte] 
         * @param {string} [endsAtLte] 
         * @param {string} [showName] 
         * @param {Array<string>} [showStatuses] 
         * @param {UserListEventsShowTypeEnum} [showType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userListEvents(itemsPerPage?: number, page?: number, startsAtGte?: string, startsAtLte?: string, endsAtGte?: string, endsAtLte?: string, showName?: string, showStatuses?: Array<string>, showType?: UserListEventsShowTypeEnum, options?: any): AxiosPromise<UserListEvents200Response> {
            return localVarFp.userListEvents(itemsPerPage, page, startsAtGte, startsAtLte, endsAtGte, endsAtLte, showName, showStatuses, showType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EventsApi - object-oriented interface
 * @export
 * @class EventsApi
 * @extends {BaseAPI}
 */
export class EventsApi extends BaseAPI {
    /**
     * 
     * @param {number} [itemsPerPage] Items per Page
     * @param {number} [page] Page
     * @param {string} [startsAtGte] 
     * @param {string} [startsAtLte] 
     * @param {string} [endsAtGte] 
     * @param {string} [endsAtLte] 
     * @param {string} [showName] 
     * @param {Array<string>} [showStatuses] 
     * @param {UserListEventsShowTypeEnum} [showType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public userListEvents(itemsPerPage?: number, page?: number, startsAtGte?: string, startsAtLte?: string, endsAtGte?: string, endsAtLte?: string, showName?: string, showStatuses?: Array<string>, showType?: UserListEventsShowTypeEnum, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).userListEvents(itemsPerPage, page, startsAtGte, startsAtLte, endsAtGte, endsAtLte, showName, showStatuses, showType, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const UserListEventsShowTypeEnum = {
    Paid: 'paid',
    External: 'external'
} as const;
export type UserListEventsShowTypeEnum = typeof UserListEventsShowTypeEnum[keyof typeof UserListEventsShowTypeEnum];


/**
 * FilesApi - axios parameter creator
 * @export
 */
export const FilesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Upload Flyer
         * @param {File} flyer Image file to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFlyers: async (flyer: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flyer' is not null or undefined
            assertParamExists('uploadFlyers', 'flyer', flyer)
            const localVarPath = `/api/files-service/flyers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (flyer !== undefined) { 
                localVarFormParams.append('flyer', flyer as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload Invoice
         * @param {File} invoice File or Image to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadInvoice: async (invoice: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoice' is not null or undefined
            assertParamExists('uploadInvoice', 'invoice', invoice)
            const localVarPath = `/api/files-service/invoices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (invoice !== undefined) { 
                localVarFormParams.append('invoice', invoice as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FilesApi - functional programming interface
 * @export
 */
export const FilesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FilesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Upload Flyer
         * @param {File} flyer Image file to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadFlyers(flyer: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadedFileOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadFlyers(flyer, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilesApi.uploadFlyers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload Invoice
         * @param {File} invoice File or Image to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadInvoice(invoice: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadedFileOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadInvoice(invoice, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilesApi.uploadInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FilesApi - factory interface
 * @export
 */
export const FilesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FilesApiFp(configuration)
    return {
        /**
         * 
         * @summary Upload Flyer
         * @param {File} flyer Image file to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFlyers(flyer: File, options?: any): AxiosPromise<UploadedFileOutput> {
            return localVarFp.uploadFlyers(flyer, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload Invoice
         * @param {File} invoice File or Image to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadInvoice(invoice: File, options?: any): AxiosPromise<UploadedFileOutput> {
            return localVarFp.uploadInvoice(invoice, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FilesApi - object-oriented interface
 * @export
 * @class FilesApi
 * @extends {BaseAPI}
 */
export class FilesApi extends BaseAPI {
    /**
     * 
     * @summary Upload Flyer
     * @param {File} flyer Image file to upload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesApi
     */
    public uploadFlyers(flyer: File, options?: RawAxiosRequestConfig) {
        return FilesApiFp(this.configuration).uploadFlyers(flyer, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload Invoice
     * @param {File} invoice File or Image to upload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesApi
     */
    public uploadInvoice(invoice: File, options?: RawAxiosRequestConfig) {
        return FilesApiFp(this.configuration).uploadInvoice(invoice, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GenresApi - axios parameter creator
 * @export
 */
export const GenresApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGenres: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/genres`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GenresApi - functional programming interface
 * @export
 */
export const GenresApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GenresApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listGenres(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GenreResource>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listGenres(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GenresApi.listGenres']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GenresApi - factory interface
 * @export
 */
export const GenresApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GenresApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGenres(options?: any): AxiosPromise<Array<GenreResource>> {
            return localVarFp.listGenres(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GenresApi - object-oriented interface
 * @export
 * @class GenresApi
 * @extends {BaseAPI}
 */
export class GenresApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GenresApi
     */
    public listGenres(options?: RawAxiosRequestConfig) {
        return GenresApiFp(this.configuration).listGenres(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HomeFlyersApi - axios parameter creator
 * @export
 */
export const HomeFlyersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActiveHomeFlyers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/homeFlyers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HomeFlyersApi - functional programming interface
 * @export
 */
export const HomeFlyersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HomeFlyersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listActiveHomeFlyers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HomeFlyer>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listActiveHomeFlyers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HomeFlyersApi.listActiveHomeFlyers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HomeFlyersApi - factory interface
 * @export
 */
export const HomeFlyersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HomeFlyersApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActiveHomeFlyers(options?: any): AxiosPromise<Array<HomeFlyer>> {
            return localVarFp.listActiveHomeFlyers(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HomeFlyersApi - object-oriented interface
 * @export
 * @class HomeFlyersApi
 * @extends {BaseAPI}
 */
export class HomeFlyersApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HomeFlyersApi
     */
    public listActiveHomeFlyers(options?: RawAxiosRequestConfig) {
        return HomeFlyersApiFp(this.configuration).listActiveHomeFlyers(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LocationsApi - axios parameter creator
 * @export
 */
export const LocationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new location
         * @param {CreateLocationRequest} createLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLocation: async (createLocationRequest: CreateLocationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createLocationRequest' is not null or undefined
            assertParamExists('createLocation', 'createLocationRequest', createLocationRequest)
            const localVarPath = `/api/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createLocationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [name] Filter by name
         * @param {string} [address] Filter by address
         * @param {string} [city] Filter by city
         * @param {string} [placeId] Filter by placeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLocations: async (name?: string, address?: string, city?: string, placeId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (address !== undefined) {
                localVarQueryParameter['address'] = address;
            }

            if (city !== undefined) {
                localVarQueryParameter['city'] = city;
            }

            if (placeId !== undefined) {
                localVarQueryParameter['placeId'] = placeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Patch Location
         * @param {number} id Location id
         * @param {PatchLocationRequest} patchLocationRequest Patch Location Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchLocation: async (id: number, patchLocationRequest: PatchLocationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchLocation', 'id', id)
            // verify required parameter 'patchLocationRequest' is not null or undefined
            assertParamExists('patchLocation', 'patchLocationRequest', patchLocationRequest)
            const localVarPath = `/api/locations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchLocationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocationsApi - functional programming interface
 * @export
 */
export const LocationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new location
         * @param {CreateLocationRequest} createLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLocation(createLocationRequest: CreateLocationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLocation(createLocationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.createLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [name] Filter by name
         * @param {string} [address] Filter by address
         * @param {string} [city] Filter by city
         * @param {string} [placeId] Filter by placeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listLocations(name?: string, address?: string, city?: string, placeId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LocationResource>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listLocations(name, address, city, placeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.listLocations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Patch Location
         * @param {number} id Location id
         * @param {PatchLocationRequest} patchLocationRequest Patch Location Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchLocation(id: number, patchLocationRequest: PatchLocationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchLocation(id, patchLocationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationsApi.patchLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LocationsApi - factory interface
 * @export
 */
export const LocationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new location
         * @param {CreateLocationRequest} createLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLocation(createLocationRequest: CreateLocationRequest, options?: any): AxiosPromise<LocationResource> {
            return localVarFp.createLocation(createLocationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [name] Filter by name
         * @param {string} [address] Filter by address
         * @param {string} [city] Filter by city
         * @param {string} [placeId] Filter by placeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLocations(name?: string, address?: string, city?: string, placeId?: string, options?: any): AxiosPromise<Array<LocationResource>> {
            return localVarFp.listLocations(name, address, city, placeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Patch Location
         * @param {number} id Location id
         * @param {PatchLocationRequest} patchLocationRequest Patch Location Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchLocation(id: number, patchLocationRequest: PatchLocationRequest, options?: any): AxiosPromise<LocationResource> {
            return localVarFp.patchLocation(id, patchLocationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LocationsApi - object-oriented interface
 * @export
 * @class LocationsApi
 * @extends {BaseAPI}
 */
export class LocationsApi extends BaseAPI {
    /**
     * 
     * @summary Create a new location
     * @param {CreateLocationRequest} createLocationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public createLocation(createLocationRequest: CreateLocationRequest, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).createLocation(createLocationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [name] Filter by name
     * @param {string} [address] Filter by address
     * @param {string} [city] Filter by city
     * @param {string} [placeId] Filter by placeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public listLocations(name?: string, address?: string, city?: string, placeId?: string, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).listLocations(name, address, city, placeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Patch Location
     * @param {number} id Location id
     * @param {PatchLocationRequest} patchLocationRequest Patch Location Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public patchLocation(id: number, patchLocationRequest: PatchLocationRequest, options?: RawAxiosRequestConfig) {
        return LocationsApiFp(this.configuration).patchLocation(id, patchLocationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReservationsApi - axios parameter creator
 * @export
 */
export const ReservationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Confirm Reservation
         * @param {ReservationTokenRequest} reservationTokenRequest Confirmation to be confirmed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmReservation: async (reservationTokenRequest: ReservationTokenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reservationTokenRequest' is not null or undefined
            assertParamExists('confirmReservation', 'reservationTokenRequest', reservationTokenRequest)
            const localVarPath = `/api/reservations/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reservationTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create Reservation
         * @param {CreateReservationRequest} createReservationRequest Confirmation to be confirmed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReservation: async (createReservationRequest: CreateReservationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createReservationRequest' is not null or undefined
            assertParamExists('createReservation', 'createReservationRequest', createReservationRequest)
            const localVarPath = `/api/reservations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createReservationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Extend Reservation
         * @param {ReservationTokenRequest} reservationTokenRequest Confirmation to be confirmed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extendReservationExpirationTime: async (reservationTokenRequest: ReservationTokenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reservationTokenRequest' is not null or undefined
            assertParamExists('extendReservationExpirationTime', 'reservationTokenRequest', reservationTokenRequest)
            const localVarPath = `/api/reservations/extend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reservationTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [showName] Filter by show name
         * @param {ListReservationsItemsToShowEnum} [itemsToShow] Filter by show event date: all, current, past
         * @param {number} [page] Page of filter resources
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReservations: async (showName?: string, itemsToShow?: ListReservationsItemsToShowEnum, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/reservations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (showName !== undefined) {
                localVarQueryParameter['showName'] = showName;
            }

            if (itemsToShow !== undefined) {
                localVarQueryParameter['itemsToShow'] = itemsToShow;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resend Tickets Via Email
         * @param {string} uuid ID of reservation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendEmail: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('resendEmail', 'uuid', uuid)
            const localVarPath = `/api/reservations/{uuid}/resendEmail`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Show Reservation Tickets
         * @param {string} uuid ID of reservation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showTickets: async (uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('showTickets', 'uuid', uuid)
            const localVarPath = `/api/reservations/{uuid}/tickets`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Export event buyers
         * @param {number} showId Show id
         * @param {number} eventId Event id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userExportEventBuyers: async (showId: number, eventId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'showId' is not null or undefined
            assertParamExists('userExportEventBuyers', 'showId', showId)
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('userExportEventBuyers', 'eventId', eventId)
            const localVarPath = `/api/user/shows/{showId}/events/{eventId}/buyers`
                .replace(`{${"showId"}}`, encodeURIComponent(String(showId)))
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List reservations
         * @param {number} [itemsPerPage] Items per Page
         * @param {number} [page] Page
         * @param {string} [uuid] Filter by uuid
         * @param {number} [eventId] Filter by eventId
         * @param {number} [priceId] Filter by priceId
         * @param {number} [userId] Filter by userId
         * @param {Array<UserListReservationsStatusEnum>} [status] Filter by multiple status
         * @param {string} [createdAtGte] Filter by creation date
         * @param {string} [createdAtLte] Filter by creation date
         * @param {number} [showId] Filter by showId
         * @param {string} [showName] Filter by showName
         * @param {string} [userEmail] Filter by userEmail
         * @param {UserListReservationsItemsToShowEnum} [itemsToShow] Deprecated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userListReservations: async (itemsPerPage?: number, page?: number, uuid?: string, eventId?: number, priceId?: number, userId?: number, status?: Array<UserListReservationsStatusEnum>, createdAtGte?: string, createdAtLte?: string, showId?: number, showName?: string, userEmail?: string, itemsToShow?: UserListReservationsItemsToShowEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/reservations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (uuid !== undefined) {
                localVarQueryParameter['uuid'] = uuid;
            }

            if (eventId !== undefined) {
                localVarQueryParameter['eventId'] = eventId;
            }

            if (priceId !== undefined) {
                localVarQueryParameter['priceId'] = priceId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (status) {
                localVarQueryParameter['status[]'] = status;
            }

            if (createdAtGte !== undefined) {
                localVarQueryParameter['createdAtGte'] = createdAtGte;
            }

            if (createdAtLte !== undefined) {
                localVarQueryParameter['createdAtLte'] = createdAtLte;
            }

            if (showId !== undefined) {
                localVarQueryParameter['showId'] = showId;
            }

            if (showName !== undefined) {
                localVarQueryParameter['showName'] = showName;
            }

            if (userEmail !== undefined) {
                localVarQueryParameter['userEmail'] = userEmail;
            }

            if (itemsToShow !== undefined) {
                localVarQueryParameter['itemsToShow'] = itemsToShow;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Overview reservations
         * @param {string} [uuid] Filter by uuid
         * @param {number} [eventId] Filter by eventId
         * @param {number} [priceId] Filter by priceId
         * @param {number} [userId] Filter by userId
         * @param {Array<UserReservationsDashboardStatusEnum>} [status] Filter by multiple status
         * @param {string} [createdAtGte] Filter by creation date
         * @param {string} [createdAtLte] Filter by creation date
         * @param {number} [showId] Filter by showId
         * @param {string} [showName] Filter by showName
         * @param {string} [userEmail] Filter by userEmail
         * @param {UserReservationsDashboardItemsToShowEnum} [itemsToShow] Deprecated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userReservationsDashboard: async (uuid?: string, eventId?: number, priceId?: number, userId?: number, status?: Array<UserReservationsDashboardStatusEnum>, createdAtGte?: string, createdAtLte?: string, showId?: number, showName?: string, userEmail?: string, itemsToShow?: UserReservationsDashboardItemsToShowEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dashboards/reservationsOverview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (uuid !== undefined) {
                localVarQueryParameter['uuid'] = uuid;
            }

            if (eventId !== undefined) {
                localVarQueryParameter['eventId'] = eventId;
            }

            if (priceId !== undefined) {
                localVarQueryParameter['priceId'] = priceId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (status) {
                localVarQueryParameter['status[]'] = status;
            }

            if (createdAtGte !== undefined) {
                localVarQueryParameter['createdAtGte'] = createdAtGte;
            }

            if (createdAtLte !== undefined) {
                localVarQueryParameter['createdAtLte'] = createdAtLte;
            }

            if (showId !== undefined) {
                localVarQueryParameter['showId'] = showId;
            }

            if (showName !== undefined) {
                localVarQueryParameter['showName'] = showName;
            }

            if (userEmail !== undefined) {
                localVarQueryParameter['userEmail'] = userEmail;
            }

            if (itemsToShow !== undefined) {
                localVarQueryParameter['itemsToShow'] = itemsToShow;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReservationsApi - functional programming interface
 * @export
 */
export const ReservationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReservationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Confirm Reservation
         * @param {ReservationTokenRequest} reservationTokenRequest Confirmation to be confirmed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmReservation(reservationTokenRequest: ReservationTokenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmReservation(reservationTokenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReservationsApi.confirmReservation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create Reservation
         * @param {CreateReservationRequest} createReservationRequest Confirmation to be confirmed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createReservation(createReservationRequest: CreateReservationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReservationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createReservation(createReservationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReservationsApi.createReservation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Extend Reservation
         * @param {ReservationTokenRequest} reservationTokenRequest Confirmation to be confirmed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async extendReservationExpirationTime(reservationTokenRequest: ReservationTokenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.extendReservationExpirationTime(reservationTokenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReservationsApi.extendReservationExpirationTime']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [showName] Filter by show name
         * @param {ListReservationsItemsToShowEnum} [itemsToShow] Filter by show event date: all, current, past
         * @param {number} [page] Page of filter resources
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listReservations(showName?: string, itemsToShow?: ListReservationsItemsToShowEnum, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListReservations200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listReservations(showName, itemsToShow, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReservationsApi.listReservations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Resend Tickets Via Email
         * @param {string} uuid ID of reservation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendEmail(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendEmail(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReservationsApi.resendEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Show Reservation Tickets
         * @param {string} uuid ID of reservation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async showTickets(uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TicketOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.showTickets(uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReservationsApi.showTickets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Export event buyers
         * @param {number} showId Show id
         * @param {number} eventId Event id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userExportEventBuyers(showId: number, eventId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userExportEventBuyers(showId, eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReservationsApi.userExportEventBuyers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List reservations
         * @param {number} [itemsPerPage] Items per Page
         * @param {number} [page] Page
         * @param {string} [uuid] Filter by uuid
         * @param {number} [eventId] Filter by eventId
         * @param {number} [priceId] Filter by priceId
         * @param {number} [userId] Filter by userId
         * @param {Array<UserListReservationsStatusEnum>} [status] Filter by multiple status
         * @param {string} [createdAtGte] Filter by creation date
         * @param {string} [createdAtLte] Filter by creation date
         * @param {number} [showId] Filter by showId
         * @param {string} [showName] Filter by showName
         * @param {string} [userEmail] Filter by userEmail
         * @param {UserListReservationsItemsToShowEnum} [itemsToShow] Deprecated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userListReservations(itemsPerPage?: number, page?: number, uuid?: string, eventId?: number, priceId?: number, userId?: number, status?: Array<UserListReservationsStatusEnum>, createdAtGte?: string, createdAtLte?: string, showId?: number, showName?: string, userEmail?: string, itemsToShow?: UserListReservationsItemsToShowEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserListReservations200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userListReservations(itemsPerPage, page, uuid, eventId, priceId, userId, status, createdAtGte, createdAtLte, showId, showName, userEmail, itemsToShow, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReservationsApi.userListReservations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Overview reservations
         * @param {string} [uuid] Filter by uuid
         * @param {number} [eventId] Filter by eventId
         * @param {number} [priceId] Filter by priceId
         * @param {number} [userId] Filter by userId
         * @param {Array<UserReservationsDashboardStatusEnum>} [status] Filter by multiple status
         * @param {string} [createdAtGte] Filter by creation date
         * @param {string} [createdAtLte] Filter by creation date
         * @param {number} [showId] Filter by showId
         * @param {string} [showName] Filter by showName
         * @param {string} [userEmail] Filter by userEmail
         * @param {UserReservationsDashboardItemsToShowEnum} [itemsToShow] Deprecated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userReservationsDashboard(uuid?: string, eventId?: number, priceId?: number, userId?: number, status?: Array<UserReservationsDashboardStatusEnum>, createdAtGte?: string, createdAtLte?: string, showId?: number, showName?: string, userEmail?: string, itemsToShow?: UserReservationsDashboardItemsToShowEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReservationsOverview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userReservationsDashboard(uuid, eventId, priceId, userId, status, createdAtGte, createdAtLte, showId, showName, userEmail, itemsToShow, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReservationsApi.userReservationsDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReservationsApi - factory interface
 * @export
 */
export const ReservationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReservationsApiFp(configuration)
    return {
        /**
         * Confirm Reservation
         * @param {ReservationTokenRequest} reservationTokenRequest Confirmation to be confirmed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmReservation(reservationTokenRequest: ReservationTokenRequest, options?: any): AxiosPromise<any> {
            return localVarFp.confirmReservation(reservationTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create Reservation
         * @param {CreateReservationRequest} createReservationRequest Confirmation to be confirmed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReservation(createReservationRequest: CreateReservationRequest, options?: any): AxiosPromise<ReservationResponse> {
            return localVarFp.createReservation(createReservationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Extend Reservation
         * @param {ReservationTokenRequest} reservationTokenRequest Confirmation to be confirmed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extendReservationExpirationTime(reservationTokenRequest: ReservationTokenRequest, options?: any): AxiosPromise<any> {
            return localVarFp.extendReservationExpirationTime(reservationTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [showName] Filter by show name
         * @param {ListReservationsItemsToShowEnum} [itemsToShow] Filter by show event date: all, current, past
         * @param {number} [page] Page of filter resources
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReservations(showName?: string, itemsToShow?: ListReservationsItemsToShowEnum, page?: number, options?: any): AxiosPromise<ListReservations200Response> {
            return localVarFp.listReservations(showName, itemsToShow, page, options).then((request) => request(axios, basePath));
        },
        /**
         * Resend Tickets Via Email
         * @param {string} uuid ID of reservation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendEmail(uuid: string, options?: any): AxiosPromise<any> {
            return localVarFp.resendEmail(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Show Reservation Tickets
         * @param {string} uuid ID of reservation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showTickets(uuid: string, options?: any): AxiosPromise<TicketOutput> {
            return localVarFp.showTickets(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Export event buyers
         * @param {number} showId Show id
         * @param {number} eventId Event id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userExportEventBuyers(showId: number, eventId: number, options?: any): AxiosPromise<void> {
            return localVarFp.userExportEventBuyers(showId, eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List reservations
         * @param {number} [itemsPerPage] Items per Page
         * @param {number} [page] Page
         * @param {string} [uuid] Filter by uuid
         * @param {number} [eventId] Filter by eventId
         * @param {number} [priceId] Filter by priceId
         * @param {number} [userId] Filter by userId
         * @param {Array<UserListReservationsStatusEnum>} [status] Filter by multiple status
         * @param {string} [createdAtGte] Filter by creation date
         * @param {string} [createdAtLte] Filter by creation date
         * @param {number} [showId] Filter by showId
         * @param {string} [showName] Filter by showName
         * @param {string} [userEmail] Filter by userEmail
         * @param {UserListReservationsItemsToShowEnum} [itemsToShow] Deprecated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userListReservations(itemsPerPage?: number, page?: number, uuid?: string, eventId?: number, priceId?: number, userId?: number, status?: Array<UserListReservationsStatusEnum>, createdAtGte?: string, createdAtLte?: string, showId?: number, showName?: string, userEmail?: string, itemsToShow?: UserListReservationsItemsToShowEnum, options?: any): AxiosPromise<UserListReservations200Response> {
            return localVarFp.userListReservations(itemsPerPage, page, uuid, eventId, priceId, userId, status, createdAtGte, createdAtLte, showId, showName, userEmail, itemsToShow, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Overview reservations
         * @param {string} [uuid] Filter by uuid
         * @param {number} [eventId] Filter by eventId
         * @param {number} [priceId] Filter by priceId
         * @param {number} [userId] Filter by userId
         * @param {Array<UserReservationsDashboardStatusEnum>} [status] Filter by multiple status
         * @param {string} [createdAtGte] Filter by creation date
         * @param {string} [createdAtLte] Filter by creation date
         * @param {number} [showId] Filter by showId
         * @param {string} [showName] Filter by showName
         * @param {string} [userEmail] Filter by userEmail
         * @param {UserReservationsDashboardItemsToShowEnum} [itemsToShow] Deprecated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userReservationsDashboard(uuid?: string, eventId?: number, priceId?: number, userId?: number, status?: Array<UserReservationsDashboardStatusEnum>, createdAtGte?: string, createdAtLte?: string, showId?: number, showName?: string, userEmail?: string, itemsToShow?: UserReservationsDashboardItemsToShowEnum, options?: any): AxiosPromise<ReservationsOverview> {
            return localVarFp.userReservationsDashboard(uuid, eventId, priceId, userId, status, createdAtGte, createdAtLte, showId, showName, userEmail, itemsToShow, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReservationsApi - object-oriented interface
 * @export
 * @class ReservationsApi
 * @extends {BaseAPI}
 */
export class ReservationsApi extends BaseAPI {
    /**
     * Confirm Reservation
     * @param {ReservationTokenRequest} reservationTokenRequest Confirmation to be confirmed
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationsApi
     */
    public confirmReservation(reservationTokenRequest: ReservationTokenRequest, options?: RawAxiosRequestConfig) {
        return ReservationsApiFp(this.configuration).confirmReservation(reservationTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create Reservation
     * @param {CreateReservationRequest} createReservationRequest Confirmation to be confirmed
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationsApi
     */
    public createReservation(createReservationRequest: CreateReservationRequest, options?: RawAxiosRequestConfig) {
        return ReservationsApiFp(this.configuration).createReservation(createReservationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Extend Reservation
     * @param {ReservationTokenRequest} reservationTokenRequest Confirmation to be confirmed
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationsApi
     */
    public extendReservationExpirationTime(reservationTokenRequest: ReservationTokenRequest, options?: RawAxiosRequestConfig) {
        return ReservationsApiFp(this.configuration).extendReservationExpirationTime(reservationTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [showName] Filter by show name
     * @param {ListReservationsItemsToShowEnum} [itemsToShow] Filter by show event date: all, current, past
     * @param {number} [page] Page of filter resources
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationsApi
     */
    public listReservations(showName?: string, itemsToShow?: ListReservationsItemsToShowEnum, page?: number, options?: RawAxiosRequestConfig) {
        return ReservationsApiFp(this.configuration).listReservations(showName, itemsToShow, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resend Tickets Via Email
     * @param {string} uuid ID of reservation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationsApi
     */
    public resendEmail(uuid: string, options?: RawAxiosRequestConfig) {
        return ReservationsApiFp(this.configuration).resendEmail(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Show Reservation Tickets
     * @param {string} uuid ID of reservation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationsApi
     */
    public showTickets(uuid: string, options?: RawAxiosRequestConfig) {
        return ReservationsApiFp(this.configuration).showTickets(uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Export event buyers
     * @param {number} showId Show id
     * @param {number} eventId Event id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationsApi
     */
    public userExportEventBuyers(showId: number, eventId: number, options?: RawAxiosRequestConfig) {
        return ReservationsApiFp(this.configuration).userExportEventBuyers(showId, eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List reservations
     * @param {number} [itemsPerPage] Items per Page
     * @param {number} [page] Page
     * @param {string} [uuid] Filter by uuid
     * @param {number} [eventId] Filter by eventId
     * @param {number} [priceId] Filter by priceId
     * @param {number} [userId] Filter by userId
     * @param {Array<UserListReservationsStatusEnum>} [status] Filter by multiple status
     * @param {string} [createdAtGte] Filter by creation date
     * @param {string} [createdAtLte] Filter by creation date
     * @param {number} [showId] Filter by showId
     * @param {string} [showName] Filter by showName
     * @param {string} [userEmail] Filter by userEmail
     * @param {UserListReservationsItemsToShowEnum} [itemsToShow] Deprecated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationsApi
     */
    public userListReservations(itemsPerPage?: number, page?: number, uuid?: string, eventId?: number, priceId?: number, userId?: number, status?: Array<UserListReservationsStatusEnum>, createdAtGte?: string, createdAtLte?: string, showId?: number, showName?: string, userEmail?: string, itemsToShow?: UserListReservationsItemsToShowEnum, options?: RawAxiosRequestConfig) {
        return ReservationsApiFp(this.configuration).userListReservations(itemsPerPage, page, uuid, eventId, priceId, userId, status, createdAtGte, createdAtLte, showId, showName, userEmail, itemsToShow, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Overview reservations
     * @param {string} [uuid] Filter by uuid
     * @param {number} [eventId] Filter by eventId
     * @param {number} [priceId] Filter by priceId
     * @param {number} [userId] Filter by userId
     * @param {Array<UserReservationsDashboardStatusEnum>} [status] Filter by multiple status
     * @param {string} [createdAtGte] Filter by creation date
     * @param {string} [createdAtLte] Filter by creation date
     * @param {number} [showId] Filter by showId
     * @param {string} [showName] Filter by showName
     * @param {string} [userEmail] Filter by userEmail
     * @param {UserReservationsDashboardItemsToShowEnum} [itemsToShow] Deprecated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationsApi
     */
    public userReservationsDashboard(uuid?: string, eventId?: number, priceId?: number, userId?: number, status?: Array<UserReservationsDashboardStatusEnum>, createdAtGte?: string, createdAtLte?: string, showId?: number, showName?: string, userEmail?: string, itemsToShow?: UserReservationsDashboardItemsToShowEnum, options?: RawAxiosRequestConfig) {
        return ReservationsApiFp(this.configuration).userReservationsDashboard(uuid, eventId, priceId, userId, status, createdAtGte, createdAtLte, showId, showName, userEmail, itemsToShow, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListReservationsItemsToShowEnum = {
    All: 'all',
    Current: 'current',
    Past: 'past'
} as const;
export type ListReservationsItemsToShowEnum = typeof ListReservationsItemsToShowEnum[keyof typeof ListReservationsItemsToShowEnum];
/**
 * @export
 */
export const UserListReservationsStatusEnum = {
    Approved: 'approved',
    Canceled: 'canceled',
    Error: 'error',
    Expired: 'expired',
    Pending: 'pending',
    PreOrder: 'pre_order',
    Refunded: 'refunded'
} as const;
export type UserListReservationsStatusEnum = typeof UserListReservationsStatusEnum[keyof typeof UserListReservationsStatusEnum];
/**
 * @export
 */
export const UserListReservationsItemsToShowEnum = {
    All: 'all',
    Current: 'current',
    Past: 'past'
} as const;
export type UserListReservationsItemsToShowEnum = typeof UserListReservationsItemsToShowEnum[keyof typeof UserListReservationsItemsToShowEnum];
/**
 * @export
 */
export const UserReservationsDashboardStatusEnum = {
    Approved: 'approved',
    Canceled: 'canceled',
    Error: 'error',
    Expired: 'expired',
    Pending: 'pending',
    PreOrder: 'pre_order',
    Refunded: 'refunded'
} as const;
export type UserReservationsDashboardStatusEnum = typeof UserReservationsDashboardStatusEnum[keyof typeof UserReservationsDashboardStatusEnum];
/**
 * @export
 */
export const UserReservationsDashboardItemsToShowEnum = {
    All: 'all',
    Current: 'current',
    Past: 'past'
} as const;
export type UserReservationsDashboardItemsToShowEnum = typeof UserReservationsDashboardItemsToShowEnum[keyof typeof UserReservationsDashboardItemsToShowEnum];


/**
 * ShowEventsApi - axios parameter creator
 * @export
 */
export const ShowEventsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Event Report
         * @param {number} showId Show id
         * @param {number} eventId Event id
         * @param {string} [controlCode] Control code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventReport: async (showId: number, eventId: number, controlCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'showId' is not null or undefined
            assertParamExists('eventReport', 'showId', showId)
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('eventReport', 'eventId', eventId)
            const localVarPath = `/api/user/shows/{showId}/events/{eventId}/report`
                .replace(`{${"showId"}}`, encodeURIComponent(String(showId)))
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (controlCode !== undefined) {
                localVarQueryParameter['controlCode'] = controlCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Show Event Detail
         * @param {number} showEventId ID of show Event
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getShowEventById: async (showEventId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'showEventId' is not null or undefined
            assertParamExists('getShowEventById', 'showEventId', showEventId)
            const localVarPath = `/api/showEvents/{showEventId}`
                .replace(`{${"showEventId"}}`, encodeURIComponent(String(showEventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get paginated resources
         * @param {number} showEventId ID of showEvent
         * @param {number} [page] Page of filter resources
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listShowEventPaymentRequest: async (showEventId: number, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'showEventId' is not null or undefined
            assertParamExists('listShowEventPaymentRequest', 'showEventId', showEventId)
            const localVarPath = `/api/showEvents/{showEventId}/payments`
                .replace(`{${"showEventId"}}`, encodeURIComponent(String(showEventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update user\'s payment information
         * @param {number} showEvent ID of show Event
         * @param {RequestPaymentToCustomerRequest} requestPaymentToCustomerRequest Customer Payment Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPaymentToCustomer: async (showEvent: number, requestPaymentToCustomerRequest: RequestPaymentToCustomerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'showEvent' is not null or undefined
            assertParamExists('requestPaymentToCustomer', 'showEvent', showEvent)
            // verify required parameter 'requestPaymentToCustomerRequest' is not null or undefined
            assertParamExists('requestPaymentToCustomer', 'requestPaymentToCustomerRequest', requestPaymentToCustomerRequest)
            const localVarPath = `/api/showEvents/{showEvent}/requestPayment`
                .replace(`{${"showEvent"}}`, encodeURIComponent(String(showEvent)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestPaymentToCustomerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new show event
         * @summary Create a new show event
         * @param {number} showId Show id
         * @param {UserCreateShowEventRequest} userCreateShowEventRequest Create Show Event Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userCreateShowEvent: async (showId: number, userCreateShowEventRequest: UserCreateShowEventRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'showId' is not null or undefined
            assertParamExists('userCreateShowEvent', 'showId', showId)
            // verify required parameter 'userCreateShowEventRequest' is not null or undefined
            assertParamExists('userCreateShowEvent', 'userCreateShowEventRequest', userCreateShowEventRequest)
            const localVarPath = `/api/user/shows/{showId}/events`
                .replace(`{${"showId"}}`, encodeURIComponent(String(showId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userCreateShowEventRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Export event buyers
         * @param {number} showId Show id
         * @param {number} eventId Event id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userExportEventBuyers: async (showId: number, eventId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'showId' is not null or undefined
            assertParamExists('userExportEventBuyers', 'showId', showId)
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('userExportEventBuyers', 'eventId', eventId)
            const localVarPath = `/api/user/shows/{showId}/events/{eventId}/buyers`
                .replace(`{${"showId"}}`, encodeURIComponent(String(showId)))
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShowEventsApi - functional programming interface
 * @export
 */
export const ShowEventsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShowEventsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Event Report
         * @param {number} showId Show id
         * @param {number} eventId Event id
         * @param {string} [controlCode] Control code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eventReport(showId: number, eventId: number, controlCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserEventReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.eventReport(showId, eventId, controlCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShowEventsApi.eventReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Show Event Detail
         * @param {number} showEventId ID of show Event
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getShowEventById(showEventId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShowEventDetailedOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShowEventById(showEventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShowEventsApi.getShowEventById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get paginated resources
         * @param {number} showEventId ID of showEvent
         * @param {number} [page] Page of filter resources
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listShowEventPaymentRequest(showEventId: number, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListShowEventPaymentRequest200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listShowEventPaymentRequest(showEventId, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShowEventsApi.listShowEventPaymentRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update user\'s payment information
         * @param {number} showEvent ID of show Event
         * @param {RequestPaymentToCustomerRequest} requestPaymentToCustomerRequest Customer Payment Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestPaymentToCustomer(showEvent: number, requestPaymentToCustomerRequest: RequestPaymentToCustomerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerPaymentRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestPaymentToCustomer(showEvent, requestPaymentToCustomerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShowEventsApi.requestPaymentToCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new show event
         * @summary Create a new show event
         * @param {number} showId Show id
         * @param {UserCreateShowEventRequest} userCreateShowEventRequest Create Show Event Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userCreateShowEvent(showId: number, userCreateShowEventRequest: UserCreateShowEventRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserEventResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userCreateShowEvent(showId, userCreateShowEventRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShowEventsApi.userCreateShowEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Export event buyers
         * @param {number} showId Show id
         * @param {number} eventId Event id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userExportEventBuyers(showId: number, eventId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userExportEventBuyers(showId, eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShowEventsApi.userExportEventBuyers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ShowEventsApi - factory interface
 * @export
 */
export const ShowEventsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShowEventsApiFp(configuration)
    return {
        /**
         * 
         * @summary Event Report
         * @param {number} showId Show id
         * @param {number} eventId Event id
         * @param {string} [controlCode] Control code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventReport(showId: number, eventId: number, controlCode?: string, options?: any): AxiosPromise<UserEventReport> {
            return localVarFp.eventReport(showId, eventId, controlCode, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Show Event Detail
         * @param {number} showEventId ID of show Event
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getShowEventById(showEventId: number, options?: any): AxiosPromise<ShowEventDetailedOutput> {
            return localVarFp.getShowEventById(showEventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get paginated resources
         * @param {number} showEventId ID of showEvent
         * @param {number} [page] Page of filter resources
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listShowEventPaymentRequest(showEventId: number, page?: number, options?: any): AxiosPromise<ListShowEventPaymentRequest200Response> {
            return localVarFp.listShowEventPaymentRequest(showEventId, page, options).then((request) => request(axios, basePath));
        },
        /**
         * Update user\'s payment information
         * @param {number} showEvent ID of show Event
         * @param {RequestPaymentToCustomerRequest} requestPaymentToCustomerRequest Customer Payment Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPaymentToCustomer(showEvent: number, requestPaymentToCustomerRequest: RequestPaymentToCustomerRequest, options?: any): AxiosPromise<CustomerPaymentRequest> {
            return localVarFp.requestPaymentToCustomer(showEvent, requestPaymentToCustomerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new show event
         * @summary Create a new show event
         * @param {number} showId Show id
         * @param {UserCreateShowEventRequest} userCreateShowEventRequest Create Show Event Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userCreateShowEvent(showId: number, userCreateShowEventRequest: UserCreateShowEventRequest, options?: any): AxiosPromise<UserEventResource> {
            return localVarFp.userCreateShowEvent(showId, userCreateShowEventRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Export event buyers
         * @param {number} showId Show id
         * @param {number} eventId Event id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userExportEventBuyers(showId: number, eventId: number, options?: any): AxiosPromise<void> {
            return localVarFp.userExportEventBuyers(showId, eventId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShowEventsApi - object-oriented interface
 * @export
 * @class ShowEventsApi
 * @extends {BaseAPI}
 */
export class ShowEventsApi extends BaseAPI {
    /**
     * 
     * @summary Event Report
     * @param {number} showId Show id
     * @param {number} eventId Event id
     * @param {string} [controlCode] Control code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShowEventsApi
     */
    public eventReport(showId: number, eventId: number, controlCode?: string, options?: RawAxiosRequestConfig) {
        return ShowEventsApiFp(this.configuration).eventReport(showId, eventId, controlCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Show Event Detail
     * @param {number} showEventId ID of show Event
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ShowEventsApi
     */
    public getShowEventById(showEventId: number, options?: RawAxiosRequestConfig) {
        return ShowEventsApiFp(this.configuration).getShowEventById(showEventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get paginated resources
     * @param {number} showEventId ID of showEvent
     * @param {number} [page] Page of filter resources
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShowEventsApi
     */
    public listShowEventPaymentRequest(showEventId: number, page?: number, options?: RawAxiosRequestConfig) {
        return ShowEventsApiFp(this.configuration).listShowEventPaymentRequest(showEventId, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update user\'s payment information
     * @param {number} showEvent ID of show Event
     * @param {RequestPaymentToCustomerRequest} requestPaymentToCustomerRequest Customer Payment Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShowEventsApi
     */
    public requestPaymentToCustomer(showEvent: number, requestPaymentToCustomerRequest: RequestPaymentToCustomerRequest, options?: RawAxiosRequestConfig) {
        return ShowEventsApiFp(this.configuration).requestPaymentToCustomer(showEvent, requestPaymentToCustomerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new show event
     * @summary Create a new show event
     * @param {number} showId Show id
     * @param {UserCreateShowEventRequest} userCreateShowEventRequest Create Show Event Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShowEventsApi
     */
    public userCreateShowEvent(showId: number, userCreateShowEventRequest: UserCreateShowEventRequest, options?: RawAxiosRequestConfig) {
        return ShowEventsApiFp(this.configuration).userCreateShowEvent(showId, userCreateShowEventRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Export event buyers
     * @param {number} showId Show id
     * @param {number} eventId Event id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShowEventsApi
     */
    public userExportEventBuyers(showId: number, eventId: number, options?: RawAxiosRequestConfig) {
        return ShowEventsApiFp(this.configuration).userExportEventBuyers(showId, eventId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ShowPricesApi - axios parameter creator
 * @export
 */
export const ShowPricesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new show price
         * @summary Create a new show price
         * @param {number} showId Show id
         * @param {CreateShowPriceRequest} createShowPriceRequest Create Show Price Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShowPrice: async (showId: number, createShowPriceRequest: CreateShowPriceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'showId' is not null or undefined
            assertParamExists('createShowPrice', 'showId', showId)
            // verify required parameter 'createShowPriceRequest' is not null or undefined
            assertParamExists('createShowPrice', 'createShowPriceRequest', createShowPriceRequest)
            const localVarPath = `/api/user/shows/{showId}/prices`
                .replace(`{${"showId"}}`, encodeURIComponent(String(showId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createShowPriceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update Show Price by Id
         * @summary Update Show Price
         * @param {number} showId Show id
         * @param {number} id Show Price id
         * @param {PatchShowPriceRequest} patchShowPriceRequest Update Show Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchShowPrice: async (showId: number, id: number, patchShowPriceRequest: PatchShowPriceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'showId' is not null or undefined
            assertParamExists('patchShowPrice', 'showId', showId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchShowPrice', 'id', id)
            // verify required parameter 'patchShowPriceRequest' is not null or undefined
            assertParamExists('patchShowPrice', 'patchShowPriceRequest', patchShowPriceRequest)
            const localVarPath = `/api/user/shows/{showId}/prices/{id}`
                .replace(`{${"showId"}}`, encodeURIComponent(String(showId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchShowPriceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShowPricesApi - functional programming interface
 * @export
 */
export const ShowPricesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShowPricesApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new show price
         * @summary Create a new show price
         * @param {number} showId Show id
         * @param {CreateShowPriceRequest} createShowPriceRequest Create Show Price Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createShowPrice(showId: number, createShowPriceRequest: CreateShowPriceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShowPriceUserOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createShowPrice(showId, createShowPriceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShowPricesApi.createShowPrice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update Show Price by Id
         * @summary Update Show Price
         * @param {number} showId Show id
         * @param {number} id Show Price id
         * @param {PatchShowPriceRequest} patchShowPriceRequest Update Show Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchShowPrice(showId: number, id: number, patchShowPriceRequest: PatchShowPriceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShowPriceUserOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchShowPrice(showId, id, patchShowPriceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShowPricesApi.patchShowPrice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ShowPricesApi - factory interface
 * @export
 */
export const ShowPricesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShowPricesApiFp(configuration)
    return {
        /**
         * Create a new show price
         * @summary Create a new show price
         * @param {number} showId Show id
         * @param {CreateShowPriceRequest} createShowPriceRequest Create Show Price Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShowPrice(showId: number, createShowPriceRequest: CreateShowPriceRequest, options?: any): AxiosPromise<ShowPriceUserOutput> {
            return localVarFp.createShowPrice(showId, createShowPriceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update Show Price by Id
         * @summary Update Show Price
         * @param {number} showId Show id
         * @param {number} id Show Price id
         * @param {PatchShowPriceRequest} patchShowPriceRequest Update Show Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchShowPrice(showId: number, id: number, patchShowPriceRequest: PatchShowPriceRequest, options?: any): AxiosPromise<ShowPriceUserOutput> {
            return localVarFp.patchShowPrice(showId, id, patchShowPriceRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShowPricesApi - object-oriented interface
 * @export
 * @class ShowPricesApi
 * @extends {BaseAPI}
 */
export class ShowPricesApi extends BaseAPI {
    /**
     * Create a new show price
     * @summary Create a new show price
     * @param {number} showId Show id
     * @param {CreateShowPriceRequest} createShowPriceRequest Create Show Price Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShowPricesApi
     */
    public createShowPrice(showId: number, createShowPriceRequest: CreateShowPriceRequest, options?: RawAxiosRequestConfig) {
        return ShowPricesApiFp(this.configuration).createShowPrice(showId, createShowPriceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update Show Price by Id
     * @summary Update Show Price
     * @param {number} showId Show id
     * @param {number} id Show Price id
     * @param {PatchShowPriceRequest} patchShowPriceRequest Update Show Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShowPricesApi
     */
    public patchShowPrice(showId: number, id: number, patchShowPriceRequest: PatchShowPriceRequest, options?: RawAxiosRequestConfig) {
        return ShowPricesApiFp(this.configuration).patchShowPrice(showId, id, patchShowPriceRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ShowsApi - axios parameter creator
 * @export
 */
export const ShowsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new Show
         * @param {CreateDraftShowRequest} createDraftShowRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDraftShow: async (createDraftShowRequest: CreateDraftShowRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDraftShowRequest' is not null or undefined
            assertParamExists('createDraftShow', 'createDraftShowRequest', createDraftShowRequest)
            const localVarPath = `/api/v0/shows`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDraftShowRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Show by code
         * @summary Get Active Show by code
         * @param {string} code Code of show
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShowByCode: async (code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('getShowByCode', 'code', code)
            const localVarPath = `/api/showsByCode/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Show Detail
         * @summary Get Active Show by path
         * @param {string} path Path of show
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShowByPath: async (path: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'path' is not null or undefined
            assertParamExists('getShowByPath', 'path', path)
            const localVarPath = `/api/shows/byPath/{path}`
                .replace(`{${"path"}}`, encodeURIComponent(String(path)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets paginated resources
         * @param {string} [name] Name to filter resources
         * @param {string} [description] Description to filter resources
         * @param {Array<ListShowsTypesEnum>} [types] Types to filter resources
         * @param {Array<ListShowsWhenDateInEnum>} [whenDateIn] Parameter to filter resources
         * @param {Array<ListShowsModesEnum>} [modes] Modes to filter resources
         * @param {number} [page] Page of filter resources
         * @param {Array<ListShowsStatusEnum>} [status] Filter by multiple status
         * @param {number} [maxPrice] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listShows: async (name?: string, description?: string, types?: Array<ListShowsTypesEnum>, whenDateIn?: Array<ListShowsWhenDateInEnum>, modes?: Array<ListShowsModesEnum>, page?: number, status?: Array<ListShowsStatusEnum>, maxPrice?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shows`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (description !== undefined) {
                localVarQueryParameter['description'] = description;
            }

            if (types) {
                localVarQueryParameter['types[]'] = types;
            }

            if (whenDateIn) {
                localVarQueryParameter['whenDateIn[]'] = whenDateIn;
            }

            if (modes) {
                localVarQueryParameter['modes[]'] = modes;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (status) {
                localVarQueryParameter['status[]'] = status;
            }

            if (maxPrice !== undefined) {
                localVarQueryParameter['maxPrice'] = maxPrice;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Patch Show
         * @param {number} showId Show id
         * @param {PatchShowRequest} patchShowRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchShow: async (showId: number, patchShowRequest: PatchShowRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'showId' is not null or undefined
            assertParamExists('patchShow', 'showId', showId)
            // verify required parameter 'patchShowRequest' is not null or undefined
            assertParamExists('patchShow', 'patchShowRequest', patchShowRequest)
            const localVarPath = `/api/v0/shows/{showId}`
                .replace(`{${"showId"}}`, encodeURIComponent(String(showId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchShowRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShowsApi - functional programming interface
 * @export
 */
export const ShowsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShowsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new Show
         * @param {CreateDraftShowRequest} createDraftShowRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDraftShow(createDraftShowRequest: CreateDraftShowRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserShowResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDraftShow(createDraftShowRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShowsApi.createDraftShow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Show by code
         * @summary Get Active Show by code
         * @param {string} code Code of show
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShowByCode(code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShowPublicOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShowByCode(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShowsApi.getShowByCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Show Detail
         * @summary Get Active Show by path
         * @param {string} path Path of show
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShowByPath(path: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShowPublicOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShowByPath(path, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShowsApi.getShowByPath']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets paginated resources
         * @param {string} [name] Name to filter resources
         * @param {string} [description] Description to filter resources
         * @param {Array<ListShowsTypesEnum>} [types] Types to filter resources
         * @param {Array<ListShowsWhenDateInEnum>} [whenDateIn] Parameter to filter resources
         * @param {Array<ListShowsModesEnum>} [modes] Modes to filter resources
         * @param {number} [page] Page of filter resources
         * @param {Array<ListShowsStatusEnum>} [status] Filter by multiple status
         * @param {number} [maxPrice] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listShows(name?: string, description?: string, types?: Array<ListShowsTypesEnum>, whenDateIn?: Array<ListShowsWhenDateInEnum>, modes?: Array<ListShowsModesEnum>, page?: number, status?: Array<ListShowsStatusEnum>, maxPrice?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListShows200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listShows(name, description, types, whenDateIn, modes, page, status, maxPrice, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShowsApi.listShows']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Patch Show
         * @param {number} showId Show id
         * @param {PatchShowRequest} patchShowRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchShow(showId: number, patchShowRequest: PatchShowRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserShowResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchShow(showId, patchShowRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShowsApi.patchShow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ShowsApi - factory interface
 * @export
 */
export const ShowsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShowsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new Show
         * @param {CreateDraftShowRequest} createDraftShowRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDraftShow(createDraftShowRequest: CreateDraftShowRequest, options?: any): AxiosPromise<UserShowResource> {
            return localVarFp.createDraftShow(createDraftShowRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Show by code
         * @summary Get Active Show by code
         * @param {string} code Code of show
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShowByCode(code: string, options?: any): AxiosPromise<ShowPublicOutput> {
            return localVarFp.getShowByCode(code, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Show Detail
         * @summary Get Active Show by path
         * @param {string} path Path of show
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShowByPath(path: string, options?: any): AxiosPromise<ShowPublicOutput> {
            return localVarFp.getShowByPath(path, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets paginated resources
         * @param {string} [name] Name to filter resources
         * @param {string} [description] Description to filter resources
         * @param {Array<ListShowsTypesEnum>} [types] Types to filter resources
         * @param {Array<ListShowsWhenDateInEnum>} [whenDateIn] Parameter to filter resources
         * @param {Array<ListShowsModesEnum>} [modes] Modes to filter resources
         * @param {number} [page] Page of filter resources
         * @param {Array<ListShowsStatusEnum>} [status] Filter by multiple status
         * @param {number} [maxPrice] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listShows(name?: string, description?: string, types?: Array<ListShowsTypesEnum>, whenDateIn?: Array<ListShowsWhenDateInEnum>, modes?: Array<ListShowsModesEnum>, page?: number, status?: Array<ListShowsStatusEnum>, maxPrice?: number, options?: any): AxiosPromise<ListShows200Response> {
            return localVarFp.listShows(name, description, types, whenDateIn, modes, page, status, maxPrice, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Patch Show
         * @param {number} showId Show id
         * @param {PatchShowRequest} patchShowRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchShow(showId: number, patchShowRequest: PatchShowRequest, options?: any): AxiosPromise<UserShowResource> {
            return localVarFp.patchShow(showId, patchShowRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShowsApi - object-oriented interface
 * @export
 * @class ShowsApi
 * @extends {BaseAPI}
 */
export class ShowsApi extends BaseAPI {
    /**
     * 
     * @summary Create a new Show
     * @param {CreateDraftShowRequest} createDraftShowRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShowsApi
     */
    public createDraftShow(createDraftShowRequest: CreateDraftShowRequest, options?: RawAxiosRequestConfig) {
        return ShowsApiFp(this.configuration).createDraftShow(createDraftShowRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Show by code
     * @summary Get Active Show by code
     * @param {string} code Code of show
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShowsApi
     */
    public getShowByCode(code: string, options?: RawAxiosRequestConfig) {
        return ShowsApiFp(this.configuration).getShowByCode(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Show Detail
     * @summary Get Active Show by path
     * @param {string} path Path of show
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShowsApi
     */
    public getShowByPath(path: string, options?: RawAxiosRequestConfig) {
        return ShowsApiFp(this.configuration).getShowByPath(path, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets paginated resources
     * @param {string} [name] Name to filter resources
     * @param {string} [description] Description to filter resources
     * @param {Array<ListShowsTypesEnum>} [types] Types to filter resources
     * @param {Array<ListShowsWhenDateInEnum>} [whenDateIn] Parameter to filter resources
     * @param {Array<ListShowsModesEnum>} [modes] Modes to filter resources
     * @param {number} [page] Page of filter resources
     * @param {Array<ListShowsStatusEnum>} [status] Filter by multiple status
     * @param {number} [maxPrice] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShowsApi
     */
    public listShows(name?: string, description?: string, types?: Array<ListShowsTypesEnum>, whenDateIn?: Array<ListShowsWhenDateInEnum>, modes?: Array<ListShowsModesEnum>, page?: number, status?: Array<ListShowsStatusEnum>, maxPrice?: number, options?: RawAxiosRequestConfig) {
        return ShowsApiFp(this.configuration).listShows(name, description, types, whenDateIn, modes, page, status, maxPrice, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Patch Show
     * @param {number} showId Show id
     * @param {PatchShowRequest} patchShowRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShowsApi
     */
    public patchShow(showId: number, patchShowRequest: PatchShowRequest, options?: RawAxiosRequestConfig) {
        return ShowsApiFp(this.configuration).patchShow(showId, patchShowRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListShowsTypesEnum = {
    Paid: 'paid',
    External: 'external'
} as const;
export type ListShowsTypesEnum = typeof ListShowsTypesEnum[keyof typeof ListShowsTypesEnum];
/**
 * @export
 */
export const ListShowsWhenDateInEnum = {
    ThisWeek: 'thisWeek',
    ThisMonth: 'thisMonth'
} as const;
export type ListShowsWhenDateInEnum = typeof ListShowsWhenDateInEnum[keyof typeof ListShowsWhenDateInEnum];
/**
 * @export
 */
export const ListShowsModesEnum = {
    Online: 'online',
    InPlace: 'inPlace'
} as const;
export type ListShowsModesEnum = typeof ListShowsModesEnum[keyof typeof ListShowsModesEnum];
/**
 * @export
 */
export const ListShowsStatusEnum = {
    Active: 'active',
    Finished: 'finished'
} as const;
export type ListShowsStatusEnum = typeof ListShowsStatusEnum[keyof typeof ListShowsStatusEnum];


/**
 * TermsAndConditionsApi - axios parameter creator
 * @export
 */
export const TermsAndConditionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get Term And Condition by Language
         * @param {string} language Language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTermAndConditionByLanguage: async (language: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('getTermAndConditionByLanguage', 'language', language)
            const localVarPath = `/api/termsAndConditions/{language}`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TermsAndConditionsApi - functional programming interface
 * @export
 */
export const TermsAndConditionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TermsAndConditionsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get Term And Condition by Language
         * @param {string} language Language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTermAndConditionByLanguage(language: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TermAndConditionPublicOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTermAndConditionByLanguage(language, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TermsAndConditionsApi.getTermAndConditionByLanguage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TermsAndConditionsApi - factory interface
 * @export
 */
export const TermsAndConditionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TermsAndConditionsApiFp(configuration)
    return {
        /**
         * Get Term And Condition by Language
         * @param {string} language Language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTermAndConditionByLanguage(language: string, options?: any): AxiosPromise<TermAndConditionPublicOutput> {
            return localVarFp.getTermAndConditionByLanguage(language, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TermsAndConditionsApi - object-oriented interface
 * @export
 * @class TermsAndConditionsApi
 * @extends {BaseAPI}
 */
export class TermsAndConditionsApi extends BaseAPI {
    /**
     * Get Term And Condition by Language
     * @param {string} language Language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TermsAndConditionsApi
     */
    public getTermAndConditionByLanguage(language: string, options?: RawAxiosRequestConfig) {
        return TermsAndConditionsApiFp(this.configuration).getTermAndConditionByLanguage(language, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TicketsApi - axios parameter creator
 * @export
 */
export const TicketsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Consume Tickets
         * @param {ConsumeTicketRequest} consumeTicketRequest Consume Ticket Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consumeTicket: async (consumeTicketRequest: ConsumeTicketRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'consumeTicketRequest' is not null or undefined
            assertParamExists('consumeTicket', 'consumeTicketRequest', consumeTicketRequest)
            const localVarPath = `/api/tickets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(consumeTicketRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets paginated resources
         * @param {number} showId ID of show
         * @param {number} showEventId ID of showEvent
         * @param {number} [itemsPerPage] Items per Page
         * @param {string} [uuid] Search by uuid
         * @param {string} [search] Search By Id or Buyer information
         * @param {number} [page] Page of filter resources
         * @param {number} [priceId] Show Price Id
         * @param {string} [controlCode] Control Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTickets: async (showId: number, showEventId: number, itemsPerPage?: number, uuid?: string, search?: string, page?: number, priceId?: number, controlCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'showId' is not null or undefined
            assertParamExists('listTickets', 'showId', showId)
            // verify required parameter 'showEventId' is not null or undefined
            assertParamExists('listTickets', 'showEventId', showEventId)
            const localVarPath = `/api/tickets/{showId}/{showEventId}`
                .replace(`{${"showId"}}`, encodeURIComponent(String(showId)))
                .replace(`{${"showEventId"}}`, encodeURIComponent(String(showEventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (uuid !== undefined) {
                localVarQueryParameter['uuid'] = uuid;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (priceId !== undefined) {
                localVarQueryParameter['priceId'] = priceId;
            }

            if (controlCode !== undefined) {
                localVarQueryParameter['controlCode'] = controlCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id Reservation id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userListTickets: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('userListTickets', 'id', id)
            const localVarPath = `/api/user/reservations/{id}/tickets`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TicketsApi - functional programming interface
 * @export
 */
export const TicketsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TicketsApiAxiosParamCreator(configuration)
    return {
        /**
         * Consume Tickets
         * @param {ConsumeTicketRequest} consumeTicketRequest Consume Ticket Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async consumeTicket(consumeTicketRequest: ConsumeTicketRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConsumeTicketOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.consumeTicket(consumeTicketRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TicketsApi.consumeTicket']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets paginated resources
         * @param {number} showId ID of show
         * @param {number} showEventId ID of showEvent
         * @param {number} [itemsPerPage] Items per Page
         * @param {string} [uuid] Search by uuid
         * @param {string} [search] Search By Id or Buyer information
         * @param {number} [page] Page of filter resources
         * @param {number} [priceId] Show Price Id
         * @param {string} [controlCode] Control Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTickets(showId: number, showEventId: number, itemsPerPage?: number, uuid?: string, search?: string, page?: number, priceId?: number, controlCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTickets200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTickets(showId, showEventId, itemsPerPage, uuid, search, page, priceId, controlCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TicketsApi.listTickets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id Reservation id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userListTickets(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserListTickets200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userListTickets(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TicketsApi.userListTickets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TicketsApi - factory interface
 * @export
 */
export const TicketsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TicketsApiFp(configuration)
    return {
        /**
         * Consume Tickets
         * @param {ConsumeTicketRequest} consumeTicketRequest Consume Ticket Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consumeTicket(consumeTicketRequest: ConsumeTicketRequest, options?: any): AxiosPromise<ConsumeTicketOutput> {
            return localVarFp.consumeTicket(consumeTicketRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets paginated resources
         * @param {number} showId ID of show
         * @param {number} showEventId ID of showEvent
         * @param {number} [itemsPerPage] Items per Page
         * @param {string} [uuid] Search by uuid
         * @param {string} [search] Search By Id or Buyer information
         * @param {number} [page] Page of filter resources
         * @param {number} [priceId] Show Price Id
         * @param {string} [controlCode] Control Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTickets(showId: number, showEventId: number, itemsPerPage?: number, uuid?: string, search?: string, page?: number, priceId?: number, controlCode?: string, options?: any): AxiosPromise<ListTickets200Response> {
            return localVarFp.listTickets(showId, showEventId, itemsPerPage, uuid, search, page, priceId, controlCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id Reservation id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userListTickets(id: number, options?: any): AxiosPromise<UserListTickets200Response> {
            return localVarFp.userListTickets(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TicketsApi - object-oriented interface
 * @export
 * @class TicketsApi
 * @extends {BaseAPI}
 */
export class TicketsApi extends BaseAPI {
    /**
     * Consume Tickets
     * @param {ConsumeTicketRequest} consumeTicketRequest Consume Ticket Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public consumeTicket(consumeTicketRequest: ConsumeTicketRequest, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).consumeTicket(consumeTicketRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets paginated resources
     * @param {number} showId ID of show
     * @param {number} showEventId ID of showEvent
     * @param {number} [itemsPerPage] Items per Page
     * @param {string} [uuid] Search by uuid
     * @param {string} [search] Search By Id or Buyer information
     * @param {number} [page] Page of filter resources
     * @param {number} [priceId] Show Price Id
     * @param {string} [controlCode] Control Code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public listTickets(showId: number, showEventId: number, itemsPerPage?: number, uuid?: string, search?: string, page?: number, priceId?: number, controlCode?: string, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).listTickets(showId, showEventId, itemsPerPage, uuid, search, page, priceId, controlCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id Reservation id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TicketsApi
     */
    public userListTickets(id: number, options?: RawAxiosRequestConfig) {
        return TicketsApiFp(this.configuration).userListTickets(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Accept linked user invitation
         * @param {AcceptLinkedUserInvitationRequest} acceptLinkedUserInvitationRequest Linked User Invitation Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptLinkedUserInvitation: async (acceptLinkedUserInvitationRequest: AcceptLinkedUserInvitationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'acceptLinkedUserInvitationRequest' is not null or undefined
            assertParamExists('acceptLinkedUserInvitation', 'acceptLinkedUserInvitationRequest', acceptLinkedUserInvitationRequest)
            const localVarPath = `/api/me/linkedUserInvitations/accept`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptLinkedUserInvitationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check if the user has payment information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkPaymentInformation: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/me/checkPaymentInformation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Event
         * @param {ControlCodeAuthRequest} controlCodeAuthRequest Control Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlCodeAuth: async (controlCodeAuthRequest: ControlCodeAuthRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'controlCodeAuthRequest' is not null or undefined
            assertParamExists('controlCodeAuth', 'controlCodeAuthRequest', controlCodeAuthRequest)
            const localVarPath = `/api/controlCodeAuth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(controlCodeAuthRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete my account
         * @param {DeleteMyAccountRequest} deleteMyAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMyAccount: async (deleteMyAccountRequest: DeleteMyAccountRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteMyAccountRequest' is not null or undefined
            assertParamExists('deleteMyAccount', 'deleteMyAccountRequest', deleteMyAccountRequest)
            const localVarPath = `/api/me/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteMyAccountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get User Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserInfo: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get User Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserLinkedAccounts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/me/linkedAccounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Invite a linked user
         * @param {InviteLinkedUserRequest} inviteLinkedUserRequest Linked User data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteLinkedUser: async (inviteLinkedUserRequest: InviteLinkedUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inviteLinkedUserRequest' is not null or undefined
            assertParamExists('inviteLinkedUser', 'inviteLinkedUserRequest', inviteLinkedUserRequest)
            const localVarPath = `/api/me/linkedUserInvitations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inviteLinkedUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List Linked User Invitations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLinkedUserInvitations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/me/linkedUserInvitations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List Linked Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLinkedUsers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/me/linkedUsers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List my Permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyPermissions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/me/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List Shows to control
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listShowsToControl: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/me/showsToControl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove User Linked Account
         * @param {number} linkedUserId The linked user\&#39;s id to remove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeLinkedUser: async (linkedUserId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'linkedUserId' is not null or undefined
            assertParamExists('removeLinkedUser', 'linkedUserId', linkedUserId)
            const localVarPath = `/api/me/linkedUsers/{linkedUserId}`
                .replace(`{${"linkedUserId"}}`, encodeURIComponent(String(linkedUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove Linked User Invitation Account
         * @param {number} linkedUserInvitation The linked user invitation\&#39;s id to remove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeLinkedUserInvitation: async (linkedUserInvitation: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'linkedUserInvitation' is not null or undefined
            assertParamExists('removeLinkedUserInvitation', 'linkedUserInvitation', linkedUserInvitation)
            const localVarPath = `/api/me/linkedUserInvitations/{linkedUserInvitation}`
                .replace(`{${"linkedUserInvitation"}}`, encodeURIComponent(String(linkedUserInvitation)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove User Linked Account
         * @param {RemoveUserLinkedAccountsLinkedAccountEnum} linkedAccount Linked account to remove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUserLinkedAccounts: async (linkedAccount: RemoveUserLinkedAccountsLinkedAccountEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'linkedAccount' is not null or undefined
            assertParamExists('removeUserLinkedAccounts', 'linkedAccount', linkedAccount)
            const localVarPath = `/api/me/linkedAccounts/{linkedAccount}`
                .replace(`{${"linkedAccount"}}`, encodeURIComponent(String(linkedAccount)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update user\'s password
         * @param {UpdateUserPasswordRequest} updateUserPasswordRequest Password data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePassword: async (updateUserPasswordRequest: UpdateUserPasswordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateUserPasswordRequest' is not null or undefined
            assertParamExists('updatePassword', 'updateUserPasswordRequest', updateUserPasswordRequest)
            const localVarPath = `/api/me/updatePassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update user\'s payment information
         * @param {UpdateUserPaymentInformationRequest} updateUserPaymentInformationRequest Password data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePaymentInformation: async (updateUserPaymentInformationRequest: UpdateUserPaymentInformationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateUserPaymentInformationRequest' is not null or undefined
            assertParamExists('updatePaymentInformation', 'updateUserPaymentInformationRequest', updateUserPaymentInformationRequest)
            const localVarPath = `/api/me/updatePaymentInformation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserPaymentInformationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update user\'s information
         * @param {UpdateUserInformationRequest} updateUserInformationRequest User Information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserInfo: async (updateUserInformationRequest: UpdateUserInformationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateUserInformationRequest' is not null or undefined
            assertParamExists('updateUserInfo', 'updateUserInformationRequest', updateUserInformationRequest)
            const localVarPath = `/api/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserInformationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * Accept linked user invitation
         * @param {AcceptLinkedUserInvitationRequest} acceptLinkedUserInvitationRequest Linked User Invitation Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptLinkedUserInvitation(acceptLinkedUserInvitationRequest: AcceptLinkedUserInvitationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptLinkedUserInvitation(acceptLinkedUserInvitationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.acceptLinkedUserInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Check if the user has payment information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkPaymentInformation(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkPaymentInformation(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.checkPaymentInformation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Event
         * @param {ControlCodeAuthRequest} controlCodeAuthRequest Control Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlCodeAuth(controlCodeAuthRequest: ControlCodeAuthRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserEventStandaloneResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlCodeAuth(controlCodeAuthRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.controlCodeAuth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete my account
         * @param {DeleteMyAccountRequest} deleteMyAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMyAccount(deleteMyAccountRequest: DeleteMyAccountRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMyAccount(deleteMyAccountRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.deleteMyAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get User Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserInfo(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDataOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserInfo(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.getUserInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get User Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserLinkedAccounts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserLinkedAccountsOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserLinkedAccounts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.getUserLinkedAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Invite a linked user
         * @param {InviteLinkedUserRequest} inviteLinkedUserRequest Linked User data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inviteLinkedUser(inviteLinkedUserRequest: InviteLinkedUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inviteLinkedUser(inviteLinkedUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.inviteLinkedUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List Linked User Invitations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listLinkedUserInvitations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LinkedUserInvitationOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listLinkedUserInvitations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.listLinkedUserInvitations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List Linked Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listLinkedUsers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LinkedUserOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listLinkedUsers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.listLinkedUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List my Permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMyPermissions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMyPermissions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.listMyPermissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List Shows to control
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listShowsToControl(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListShowsToControl200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listShowsToControl(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.listShowsToControl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove User Linked Account
         * @param {number} linkedUserId The linked user\&#39;s id to remove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeLinkedUser(linkedUserId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeLinkedUser(linkedUserId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.removeLinkedUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove Linked User Invitation Account
         * @param {number} linkedUserInvitation The linked user invitation\&#39;s id to remove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeLinkedUserInvitation(linkedUserInvitation: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeLinkedUserInvitation(linkedUserInvitation, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.removeLinkedUserInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove User Linked Account
         * @param {RemoveUserLinkedAccountsLinkedAccountEnum} linkedAccount Linked account to remove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeUserLinkedAccounts(linkedAccount: RemoveUserLinkedAccountsLinkedAccountEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeUserLinkedAccounts(linkedAccount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.removeUserLinkedAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update user\'s password
         * @param {UpdateUserPasswordRequest} updateUserPasswordRequest Password data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePassword(updateUserPasswordRequest: UpdateUserPasswordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePassword(updateUserPasswordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.updatePassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update user\'s payment information
         * @param {UpdateUserPaymentInformationRequest} updateUserPaymentInformationRequest Password data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePaymentInformation(updateUserPaymentInformationRequest: UpdateUserPaymentInformationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePaymentInformation(updateUserPaymentInformationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.updatePaymentInformation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update user\'s information
         * @param {UpdateUserInformationRequest} updateUserInformationRequest User Information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserInfo(updateUserInformationRequest: UpdateUserInformationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserInfo(updateUserInformationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.updateUserInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * Accept linked user invitation
         * @param {AcceptLinkedUserInvitationRequest} acceptLinkedUserInvitationRequest Linked User Invitation Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptLinkedUserInvitation(acceptLinkedUserInvitationRequest: AcceptLinkedUserInvitationRequest, options?: any): AxiosPromise<any> {
            return localVarFp.acceptLinkedUserInvitation(acceptLinkedUserInvitationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Check if the user has payment information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkPaymentInformation(options?: any): AxiosPromise<any> {
            return localVarFp.checkPaymentInformation(options).then((request) => request(axios, basePath));
        },
        /**
         * Event
         * @param {ControlCodeAuthRequest} controlCodeAuthRequest Control Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlCodeAuth(controlCodeAuthRequest: ControlCodeAuthRequest, options?: any): AxiosPromise<UserEventStandaloneResource> {
            return localVarFp.controlCodeAuth(controlCodeAuthRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete my account
         * @param {DeleteMyAccountRequest} deleteMyAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMyAccount(deleteMyAccountRequest: DeleteMyAccountRequest, options?: any): AxiosPromise<any> {
            return localVarFp.deleteMyAccount(deleteMyAccountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get User Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserInfo(options?: any): AxiosPromise<UserDataOutput> {
            return localVarFp.getUserInfo(options).then((request) => request(axios, basePath));
        },
        /**
         * Get User Data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserLinkedAccounts(options?: any): AxiosPromise<UserLinkedAccountsOutput> {
            return localVarFp.getUserLinkedAccounts(options).then((request) => request(axios, basePath));
        },
        /**
         * Invite a linked user
         * @param {InviteLinkedUserRequest} inviteLinkedUserRequest Linked User data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteLinkedUser(inviteLinkedUserRequest: InviteLinkedUserRequest, options?: any): AxiosPromise<any> {
            return localVarFp.inviteLinkedUser(inviteLinkedUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * List Linked User Invitations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLinkedUserInvitations(options?: any): AxiosPromise<Array<LinkedUserInvitationOutput>> {
            return localVarFp.listLinkedUserInvitations(options).then((request) => request(axios, basePath));
        },
        /**
         * List Linked Users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLinkedUsers(options?: any): AxiosPromise<Array<LinkedUserOutput>> {
            return localVarFp.listLinkedUsers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List my Permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyPermissions(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.listMyPermissions(options).then((request) => request(axios, basePath));
        },
        /**
         * List Shows to control
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listShowsToControl(options?: any): AxiosPromise<ListShowsToControl200Response> {
            return localVarFp.listShowsToControl(options).then((request) => request(axios, basePath));
        },
        /**
         * Remove User Linked Account
         * @param {number} linkedUserId The linked user\&#39;s id to remove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeLinkedUser(linkedUserId: number, options?: any): AxiosPromise<any> {
            return localVarFp.removeLinkedUser(linkedUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove Linked User Invitation Account
         * @param {number} linkedUserInvitation The linked user invitation\&#39;s id to remove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeLinkedUserInvitation(linkedUserInvitation: number, options?: any): AxiosPromise<any> {
            return localVarFp.removeLinkedUserInvitation(linkedUserInvitation, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove User Linked Account
         * @param {RemoveUserLinkedAccountsLinkedAccountEnum} linkedAccount Linked account to remove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUserLinkedAccounts(linkedAccount: RemoveUserLinkedAccountsLinkedAccountEnum, options?: any): AxiosPromise<any> {
            return localVarFp.removeUserLinkedAccounts(linkedAccount, options).then((request) => request(axios, basePath));
        },
        /**
         * Update user\'s password
         * @param {UpdateUserPasswordRequest} updateUserPasswordRequest Password data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePassword(updateUserPasswordRequest: UpdateUserPasswordRequest, options?: any): AxiosPromise<any> {
            return localVarFp.updatePassword(updateUserPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update user\'s payment information
         * @param {UpdateUserPaymentInformationRequest} updateUserPaymentInformationRequest Password data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePaymentInformation(updateUserPaymentInformationRequest: UpdateUserPaymentInformationRequest, options?: any): AxiosPromise<any> {
            return localVarFp.updatePaymentInformation(updateUserPaymentInformationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update user\'s information
         * @param {UpdateUserInformationRequest} updateUserInformationRequest User Information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserInfo(updateUserInformationRequest: UpdateUserInformationRequest, options?: any): AxiosPromise<any> {
            return localVarFp.updateUserInfo(updateUserInformationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * Accept linked user invitation
     * @param {AcceptLinkedUserInvitationRequest} acceptLinkedUserInvitationRequest Linked User Invitation Data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public acceptLinkedUserInvitation(acceptLinkedUserInvitationRequest: AcceptLinkedUserInvitationRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).acceptLinkedUserInvitation(acceptLinkedUserInvitationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check if the user has payment information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public checkPaymentInformation(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).checkPaymentInformation(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Event
     * @param {ControlCodeAuthRequest} controlCodeAuthRequest Control Code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public controlCodeAuth(controlCodeAuthRequest: ControlCodeAuthRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).controlCodeAuth(controlCodeAuthRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete my account
     * @param {DeleteMyAccountRequest} deleteMyAccountRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public deleteMyAccount(deleteMyAccountRequest: DeleteMyAccountRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).deleteMyAccount(deleteMyAccountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get User Data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getUserInfo(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).getUserInfo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get User Data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getUserLinkedAccounts(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).getUserLinkedAccounts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Invite a linked user
     * @param {InviteLinkedUserRequest} inviteLinkedUserRequest Linked User data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public inviteLinkedUser(inviteLinkedUserRequest: InviteLinkedUserRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).inviteLinkedUser(inviteLinkedUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List Linked User Invitations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public listLinkedUserInvitations(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).listLinkedUserInvitations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List Linked Users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public listLinkedUsers(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).listLinkedUsers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List my Permissions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public listMyPermissions(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).listMyPermissions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List Shows to control
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public listShowsToControl(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).listShowsToControl(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove User Linked Account
     * @param {number} linkedUserId The linked user\&#39;s id to remove
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public removeLinkedUser(linkedUserId: number, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).removeLinkedUser(linkedUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove Linked User Invitation Account
     * @param {number} linkedUserInvitation The linked user invitation\&#39;s id to remove
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public removeLinkedUserInvitation(linkedUserInvitation: number, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).removeLinkedUserInvitation(linkedUserInvitation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove User Linked Account
     * @param {RemoveUserLinkedAccountsLinkedAccountEnum} linkedAccount Linked account to remove
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public removeUserLinkedAccounts(linkedAccount: RemoveUserLinkedAccountsLinkedAccountEnum, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).removeUserLinkedAccounts(linkedAccount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update user\'s password
     * @param {UpdateUserPasswordRequest} updateUserPasswordRequest Password data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public updatePassword(updateUserPasswordRequest: UpdateUserPasswordRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).updatePassword(updateUserPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update user\'s payment information
     * @param {UpdateUserPaymentInformationRequest} updateUserPaymentInformationRequest Password data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public updatePaymentInformation(updateUserPaymentInformationRequest: UpdateUserPaymentInformationRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).updatePaymentInformation(updateUserPaymentInformationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update user\'s information
     * @param {UpdateUserInformationRequest} updateUserInformationRequest User Information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public updateUserInfo(updateUserInformationRequest: UpdateUserInformationRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).updateUserInfo(updateUserInformationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const RemoveUserLinkedAccountsLinkedAccountEnum = {
    Mp: 'mp',
    Google: 'google'
} as const;
export type RemoveUserLinkedAccountsLinkedAccountEnum = typeof RemoveUserLinkedAccountsLinkedAccountEnum[keyof typeof RemoveUserLinkedAccountsLinkedAccountEnum];


/**
 * UserShowsApi - axios parameter creator
 * @export
 */
export const UserShowsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Adds a new email address to the daily report list for a specific show.
         * @summary Add a report email to a show
         * @param {number} showId ID of the show
         * @param {AddReportEmailRequest} addReportEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addShowReportEmail: async (showId: number, addReportEmailRequest: AddReportEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'showId' is not null or undefined
            assertParamExists('addShowReportEmail', 'showId', showId)
            // verify required parameter 'addReportEmailRequest' is not null or undefined
            assertParamExists('addShowReportEmail', 'addReportEmailRequest', addReportEmailRequest)
            const localVarPath = `/api/user/shows/{showId}/report-emails`
                .replace(`{${"showId"}}`, encodeURIComponent(String(showId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addReportEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Flyer
         * @param {number} showId Show id
         * @param {CreateFlyerRequest} createFlyerRequest Create Flyer Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFlyer: async (showId: number, createFlyerRequest: CreateFlyerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'showId' is not null or undefined
            assertParamExists('createFlyer', 'showId', showId)
            // verify required parameter 'createFlyerRequest' is not null or undefined
            assertParamExists('createFlyer', 'createFlyerRequest', createFlyerRequest)
            const localVarPath = `/api/user/shows/{showId}/flyers`
                .replace(`{${"showId"}}`, encodeURIComponent(String(showId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFlyerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create new Show
         * @summary Create a new Show
         * @param {CreateShowRequest} createShowRequest Create Show Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShow: async (createShowRequest: CreateShowRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createShowRequest' is not null or undefined
            assertParamExists('createShow', 'createShowRequest', createShowRequest)
            const localVarPath = `/api/user/shows`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createShowRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update Show by Id
         * @summary Update Show by Id
         * @param {number} showId ID of show
         * @param {UpdateShowRequest} updateShowRequest Update Show Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editUserShow: async (showId: number, updateShowRequest: UpdateShowRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'showId' is not null or undefined
            assertParamExists('editUserShow', 'showId', showId)
            // verify required parameter 'updateShowRequest' is not null or undefined
            assertParamExists('editUserShow', 'updateShowRequest', updateShowRequest)
            const localVarPath = `/api/user/shows/{showId}`
                .replace(`{${"showId"}}`, encodeURIComponent(String(showId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateShowRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update Show status
         * @summary Update Show status
         * @param {number} showId ID of show
         * @param {EditUserShowStatusStatusEnum} status New status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editUserShowStatus: async (showId: number, status: EditUserShowStatusStatusEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'showId' is not null or undefined
            assertParamExists('editUserShowStatus', 'showId', showId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('editUserShowStatus', 'status', status)
            const localVarPath = `/api/user/shows/{showId}/status/{status}`
                .replace(`{${"showId"}}`, encodeURIComponent(String(showId)))
                .replace(`{${"status"}}`, encodeURIComponent(String(status)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Show Detail
         * @summary Get Show by Id
         * @param {number} showId ID of show
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserShowById: async (showId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'showId' is not null or undefined
            assertParamExists('getUserShowById', 'showId', showId)
            const localVarPath = `/api/user/shows/{showId}`
                .replace(`{${"showId"}}`, encodeURIComponent(String(showId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of all email addresses configured for daily reports for a specific show.
         * @summary List report emails for a show
         * @param {number} showId ID of the show
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listShowReportEmails: async (showId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'showId' is not null or undefined
            assertParamExists('listShowReportEmails', 'showId', showId)
            const localVarPath = `/api/user/shows/{showId}/report-emails`
                .replace(`{${"showId"}}`, encodeURIComponent(String(showId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets paginated resources
         * @param {Array<ListUserShowsStatusEnum>} [status] 
         * @param {string} [name] 
         * @param {string} [description] 
         * @param {boolean} [online] 
         * @param {string} [city] 
         * @param {number} [genre] Filter by genre id
         * @param {Array<ListUserShowsTypesEnum>} [types] 
         * @param {Array<ListUserShowsWhenDateInEnum>} [whenDateIn] 
         * @param {ListUserShowsItemsToShowEnum} [itemsToShow] 
         * @param {number} [page] 
         * @param {number} [maxPrice] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserShows: async (status?: Array<ListUserShowsStatusEnum>, name?: string, description?: string, online?: boolean, city?: string, genre?: number, types?: Array<ListUserShowsTypesEnum>, whenDateIn?: Array<ListUserShowsWhenDateInEnum>, itemsToShow?: ListUserShowsItemsToShowEnum, page?: number, maxPrice?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/shows`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status) {
                localVarQueryParameter['status[]'] = status;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (description !== undefined) {
                localVarQueryParameter['description'] = description;
            }

            if (online !== undefined) {
                localVarQueryParameter['online'] = online;
            }

            if (city !== undefined) {
                localVarQueryParameter['city'] = city;
            }

            if (genre !== undefined) {
                localVarQueryParameter['genre'] = genre;
            }

            if (types) {
                localVarQueryParameter['types[]'] = types;
            }

            if (whenDateIn) {
                localVarQueryParameter['whenDateIn[]'] = whenDateIn;
            }

            if (itemsToShow !== undefined) {
                localVarQueryParameter['itemsToShow'] = itemsToShow;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (maxPrice !== undefined) {
                localVarQueryParameter['maxPrice'] = maxPrice;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Patch Flyer
         * @param {number} showId Show id
         * @param {number} flyerId Flyer id
         * @param {PatchFlyerRequest} patchFlyerRequest Patch Flyer Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchFlyer: async (showId: number, flyerId: number, patchFlyerRequest: PatchFlyerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'showId' is not null or undefined
            assertParamExists('patchFlyer', 'showId', showId)
            // verify required parameter 'flyerId' is not null or undefined
            assertParamExists('patchFlyer', 'flyerId', flyerId)
            // verify required parameter 'patchFlyerRequest' is not null or undefined
            assertParamExists('patchFlyer', 'patchFlyerRequest', patchFlyerRequest)
            const localVarPath = `/api/user/shows/{showId}/flyers/{flyerId}`
                .replace(`{${"showId"}}`, encodeURIComponent(String(showId)))
                .replace(`{${"flyerId"}}`, encodeURIComponent(String(flyerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchFlyerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a specific email address from the daily report list.
         * @summary Remove a report email from a show
         * @param {number} showId ID of the show
         * @param {number} emailId ID of the report email entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeShowReportEmail: async (showId: number, emailId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'showId' is not null or undefined
            assertParamExists('removeShowReportEmail', 'showId', showId)
            // verify required parameter 'emailId' is not null or undefined
            assertParamExists('removeShowReportEmail', 'emailId', emailId)
            const localVarPath = `/api/user/shows/{showId}/report-emails/{emailId}`
                .replace(`{${"showId"}}`, encodeURIComponent(String(showId)))
                .replace(`{${"emailId"}}`, encodeURIComponent(String(emailId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserShowsApi - functional programming interface
 * @export
 */
export const UserShowsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserShowsApiAxiosParamCreator(configuration)
    return {
        /**
         * Adds a new email address to the daily report list for a specific show.
         * @summary Add a report email to a show
         * @param {number} showId ID of the show
         * @param {AddReportEmailRequest} addReportEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addShowReportEmail(showId: number, addReportEmailRequest: AddReportEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SalesReportRecipientMinimalResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addShowReportEmail(showId, addReportEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserShowsApi.addShowReportEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Flyer
         * @param {number} showId Show id
         * @param {CreateFlyerRequest} createFlyerRequest Create Flyer Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFlyer(showId: number, createFlyerRequest: CreateFlyerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlyerResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFlyer(showId, createFlyerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserShowsApi.createFlyer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create new Show
         * @summary Create a new Show
         * @param {CreateShowRequest} createShowRequest Create Show Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createShow(createShowRequest: CreateShowRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Show>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createShow(createShowRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserShowsApi.createShow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update Show by Id
         * @summary Update Show by Id
         * @param {number} showId ID of show
         * @param {UpdateShowRequest} updateShowRequest Update Show Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editUserShow(showId: number, updateShowRequest: UpdateShowRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editUserShow(showId, updateShowRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserShowsApi.editUserShow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update Show status
         * @summary Update Show status
         * @param {number} showId ID of show
         * @param {EditUserShowStatusStatusEnum} status New status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editUserShowStatus(showId: number, status: EditUserShowStatusStatusEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserShowResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editUserShowStatus(showId, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserShowsApi.editUserShowStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Show Detail
         * @summary Get Show by Id
         * @param {number} showId ID of show
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserShowById(showId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserShowResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserShowById(showId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserShowsApi.getUserShowById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a list of all email addresses configured for daily reports for a specific show.
         * @summary List report emails for a show
         * @param {number} showId ID of the show
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listShowReportEmails(showId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SalesReportRecipientMinimalResource>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listShowReportEmails(showId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserShowsApi.listShowReportEmails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets paginated resources
         * @param {Array<ListUserShowsStatusEnum>} [status] 
         * @param {string} [name] 
         * @param {string} [description] 
         * @param {boolean} [online] 
         * @param {string} [city] 
         * @param {number} [genre] Filter by genre id
         * @param {Array<ListUserShowsTypesEnum>} [types] 
         * @param {Array<ListUserShowsWhenDateInEnum>} [whenDateIn] 
         * @param {ListUserShowsItemsToShowEnum} [itemsToShow] 
         * @param {number} [page] 
         * @param {number} [maxPrice] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUserShows(status?: Array<ListUserShowsStatusEnum>, name?: string, description?: string, online?: boolean, city?: string, genre?: number, types?: Array<ListUserShowsTypesEnum>, whenDateIn?: Array<ListUserShowsWhenDateInEnum>, itemsToShow?: ListUserShowsItemsToShowEnum, page?: number, maxPrice?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListUserShows200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUserShows(status, name, description, online, city, genre, types, whenDateIn, itemsToShow, page, maxPrice, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserShowsApi.listUserShows']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Patch Flyer
         * @param {number} showId Show id
         * @param {number} flyerId Flyer id
         * @param {PatchFlyerRequest} patchFlyerRequest Patch Flyer Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchFlyer(showId: number, flyerId: number, patchFlyerRequest: PatchFlyerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FlyerResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchFlyer(showId, flyerId, patchFlyerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserShowsApi.patchFlyer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes a specific email address from the daily report list.
         * @summary Remove a report email from a show
         * @param {number} showId ID of the show
         * @param {number} emailId ID of the report email entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeShowReportEmail(showId: number, emailId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeShowReportEmail(showId, emailId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserShowsApi.removeShowReportEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserShowsApi - factory interface
 * @export
 */
export const UserShowsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserShowsApiFp(configuration)
    return {
        /**
         * Adds a new email address to the daily report list for a specific show.
         * @summary Add a report email to a show
         * @param {number} showId ID of the show
         * @param {AddReportEmailRequest} addReportEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addShowReportEmail(showId: number, addReportEmailRequest: AddReportEmailRequest, options?: any): AxiosPromise<SalesReportRecipientMinimalResource> {
            return localVarFp.addShowReportEmail(showId, addReportEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Flyer
         * @param {number} showId Show id
         * @param {CreateFlyerRequest} createFlyerRequest Create Flyer Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFlyer(showId: number, createFlyerRequest: CreateFlyerRequest, options?: any): AxiosPromise<FlyerResource> {
            return localVarFp.createFlyer(showId, createFlyerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create new Show
         * @summary Create a new Show
         * @param {CreateShowRequest} createShowRequest Create Show Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShow(createShowRequest: CreateShowRequest, options?: any): AxiosPromise<Show> {
            return localVarFp.createShow(createShowRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update Show by Id
         * @summary Update Show by Id
         * @param {number} showId ID of show
         * @param {UpdateShowRequest} updateShowRequest Update Show Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editUserShow(showId: number, updateShowRequest: UpdateShowRequest, options?: any): AxiosPromise<any> {
            return localVarFp.editUserShow(showId, updateShowRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update Show status
         * @summary Update Show status
         * @param {number} showId ID of show
         * @param {EditUserShowStatusStatusEnum} status New status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editUserShowStatus(showId: number, status: EditUserShowStatusStatusEnum, options?: any): AxiosPromise<UserShowResource> {
            return localVarFp.editUserShowStatus(showId, status, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Show Detail
         * @summary Get Show by Id
         * @param {number} showId ID of show
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserShowById(showId: number, options?: any): AxiosPromise<UserShowResource> {
            return localVarFp.getUserShowById(showId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of all email addresses configured for daily reports for a specific show.
         * @summary List report emails for a show
         * @param {number} showId ID of the show
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listShowReportEmails(showId: number, options?: any): AxiosPromise<Array<SalesReportRecipientMinimalResource>> {
            return localVarFp.listShowReportEmails(showId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets paginated resources
         * @param {Array<ListUserShowsStatusEnum>} [status] 
         * @param {string} [name] 
         * @param {string} [description] 
         * @param {boolean} [online] 
         * @param {string} [city] 
         * @param {number} [genre] Filter by genre id
         * @param {Array<ListUserShowsTypesEnum>} [types] 
         * @param {Array<ListUserShowsWhenDateInEnum>} [whenDateIn] 
         * @param {ListUserShowsItemsToShowEnum} [itemsToShow] 
         * @param {number} [page] 
         * @param {number} [maxPrice] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserShows(status?: Array<ListUserShowsStatusEnum>, name?: string, description?: string, online?: boolean, city?: string, genre?: number, types?: Array<ListUserShowsTypesEnum>, whenDateIn?: Array<ListUserShowsWhenDateInEnum>, itemsToShow?: ListUserShowsItemsToShowEnum, page?: number, maxPrice?: number, options?: any): AxiosPromise<ListUserShows200Response> {
            return localVarFp.listUserShows(status, name, description, online, city, genre, types, whenDateIn, itemsToShow, page, maxPrice, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Patch Flyer
         * @param {number} showId Show id
         * @param {number} flyerId Flyer id
         * @param {PatchFlyerRequest} patchFlyerRequest Patch Flyer Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchFlyer(showId: number, flyerId: number, patchFlyerRequest: PatchFlyerRequest, options?: any): AxiosPromise<FlyerResource> {
            return localVarFp.patchFlyer(showId, flyerId, patchFlyerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a specific email address from the daily report list.
         * @summary Remove a report email from a show
         * @param {number} showId ID of the show
         * @param {number} emailId ID of the report email entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeShowReportEmail(showId: number, emailId: number, options?: any): AxiosPromise<void> {
            return localVarFp.removeShowReportEmail(showId, emailId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserShowsApi - object-oriented interface
 * @export
 * @class UserShowsApi
 * @extends {BaseAPI}
 */
export class UserShowsApi extends BaseAPI {
    /**
     * Adds a new email address to the daily report list for a specific show.
     * @summary Add a report email to a show
     * @param {number} showId ID of the show
     * @param {AddReportEmailRequest} addReportEmailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserShowsApi
     */
    public addShowReportEmail(showId: number, addReportEmailRequest: AddReportEmailRequest, options?: RawAxiosRequestConfig) {
        return UserShowsApiFp(this.configuration).addShowReportEmail(showId, addReportEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Flyer
     * @param {number} showId Show id
     * @param {CreateFlyerRequest} createFlyerRequest Create Flyer Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserShowsApi
     */
    public createFlyer(showId: number, createFlyerRequest: CreateFlyerRequest, options?: RawAxiosRequestConfig) {
        return UserShowsApiFp(this.configuration).createFlyer(showId, createFlyerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create new Show
     * @summary Create a new Show
     * @param {CreateShowRequest} createShowRequest Create Show Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserShowsApi
     */
    public createShow(createShowRequest: CreateShowRequest, options?: RawAxiosRequestConfig) {
        return UserShowsApiFp(this.configuration).createShow(createShowRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update Show by Id
     * @summary Update Show by Id
     * @param {number} showId ID of show
     * @param {UpdateShowRequest} updateShowRequest Update Show Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserShowsApi
     */
    public editUserShow(showId: number, updateShowRequest: UpdateShowRequest, options?: RawAxiosRequestConfig) {
        return UserShowsApiFp(this.configuration).editUserShow(showId, updateShowRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update Show status
     * @summary Update Show status
     * @param {number} showId ID of show
     * @param {EditUserShowStatusStatusEnum} status New status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserShowsApi
     */
    public editUserShowStatus(showId: number, status: EditUserShowStatusStatusEnum, options?: RawAxiosRequestConfig) {
        return UserShowsApiFp(this.configuration).editUserShowStatus(showId, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Show Detail
     * @summary Get Show by Id
     * @param {number} showId ID of show
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserShowsApi
     */
    public getUserShowById(showId: number, options?: RawAxiosRequestConfig) {
        return UserShowsApiFp(this.configuration).getUserShowById(showId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list of all email addresses configured for daily reports for a specific show.
     * @summary List report emails for a show
     * @param {number} showId ID of the show
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserShowsApi
     */
    public listShowReportEmails(showId: number, options?: RawAxiosRequestConfig) {
        return UserShowsApiFp(this.configuration).listShowReportEmails(showId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets paginated resources
     * @param {Array<ListUserShowsStatusEnum>} [status] 
     * @param {string} [name] 
     * @param {string} [description] 
     * @param {boolean} [online] 
     * @param {string} [city] 
     * @param {number} [genre] Filter by genre id
     * @param {Array<ListUserShowsTypesEnum>} [types] 
     * @param {Array<ListUserShowsWhenDateInEnum>} [whenDateIn] 
     * @param {ListUserShowsItemsToShowEnum} [itemsToShow] 
     * @param {number} [page] 
     * @param {number} [maxPrice] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserShowsApi
     */
    public listUserShows(status?: Array<ListUserShowsStatusEnum>, name?: string, description?: string, online?: boolean, city?: string, genre?: number, types?: Array<ListUserShowsTypesEnum>, whenDateIn?: Array<ListUserShowsWhenDateInEnum>, itemsToShow?: ListUserShowsItemsToShowEnum, page?: number, maxPrice?: number, options?: RawAxiosRequestConfig) {
        return UserShowsApiFp(this.configuration).listUserShows(status, name, description, online, city, genre, types, whenDateIn, itemsToShow, page, maxPrice, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Patch Flyer
     * @param {number} showId Show id
     * @param {number} flyerId Flyer id
     * @param {PatchFlyerRequest} patchFlyerRequest Patch Flyer Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserShowsApi
     */
    public patchFlyer(showId: number, flyerId: number, patchFlyerRequest: PatchFlyerRequest, options?: RawAxiosRequestConfig) {
        return UserShowsApiFp(this.configuration).patchFlyer(showId, flyerId, patchFlyerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a specific email address from the daily report list.
     * @summary Remove a report email from a show
     * @param {number} showId ID of the show
     * @param {number} emailId ID of the report email entry
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserShowsApi
     */
    public removeShowReportEmail(showId: number, emailId: number, options?: RawAxiosRequestConfig) {
        return UserShowsApiFp(this.configuration).removeShowReportEmail(showId, emailId, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const EditUserShowStatusStatusEnum = {
    Revision: 'revision'
} as const;
export type EditUserShowStatusStatusEnum = typeof EditUserShowStatusStatusEnum[keyof typeof EditUserShowStatusStatusEnum];
/**
 * @export
 */
export const ListUserShowsStatusEnum = {
    Draft: 'draft',
    Revision: 'revision',
    Active: 'active',
    Blocked: 'blocked',
    Finished: 'finished'
} as const;
export type ListUserShowsStatusEnum = typeof ListUserShowsStatusEnum[keyof typeof ListUserShowsStatusEnum];
/**
 * @export
 */
export const ListUserShowsTypesEnum = {
    Paid: 'paid',
    External: 'external'
} as const;
export type ListUserShowsTypesEnum = typeof ListUserShowsTypesEnum[keyof typeof ListUserShowsTypesEnum];
/**
 * @export
 */
export const ListUserShowsWhenDateInEnum = {
    ThisWeek: 'thisWeek',
    ThisMonth: 'thisMonth'
} as const;
export type ListUserShowsWhenDateInEnum = typeof ListUserShowsWhenDateInEnum[keyof typeof ListUserShowsWhenDateInEnum];
/**
 * @export
 */
export const ListUserShowsItemsToShowEnum = {
    All: 'all',
    Current: 'current',
    Past: 'past'
} as const;
export type ListUserShowsItemsToShowEnum = typeof ListUserShowsItemsToShowEnum[keyof typeof ListUserShowsItemsToShowEnum];


